export default [
  { label: "Ashland University", value: "Ashland University" },
  { label: "Abilene Christian University", value: "Abilene Christian University" },
  { label: "Associacao Recifense de Educacao e Cultura ESUDA ", value: "Associacao Recifense de Educacao e Cultura ESUDA " },
  { label: "Broward College", value: "Broward College" },
  { label: "Bryant University", value: "Bryant University" },
  { label: "California Institute of Advanced Management", value: "California Institute of Advanced Management" },
  { label: "California State University - Fresno ", value: "California State University - Fresno " },
  { label: "Centro Universitario Senac", value: "Centro Universitario Senac" },
  { label: "CESI - Campus D'ENSEIGNEMENT SUPERIEUR ET DE FORMATION PROFESSIONALE", value: "CESI - Campus D'ENSEIGNEMENT SUPERIEUR ET DE FORMATION PROFESSIONALE" },
  { label: "Cestar College of Business, Health & Technology", value: "Cestar College of Business, Health & Technology" },
  { label: "Clemson University", value: "Clemson University" },
  { label: "Durham College", value: "Durham College" },
  { label: "EAFIT", value: "EAFIT" },
  { label: "Ecole des Sciences de l'Information", value: "Ecole des Sciences de l'Information" },
  { label: "ESC - Clermont Graduate School of Management", value: "ESC - Clermont Graduate School of Management" },
  { label: "Escuela Internacional De Gestion De Proyectos (EIGP)", value: "Escuela Internacional De Gestion De Proyectos (EIGP)" },
  { label: "ESI School of Management", value: "ESI School of Management" },
  { label: "Fairmont State University", value: "Fairmont State University" },
  { label: "Fleming College", value: "Fleming College" },
  { label: "Florida State University - Republic of Panama", value: "Florida State University - Republic of Panama" },
  { label: "FSG Centro Universitario ", value: "FSG Centro Universitario " },
  { label: "Fundacao Carlos Alberto Vanzolini-Sao Paulo University", value: "Fundacao Carlos Alberto Vanzolini-Sao Paulo University" },
  { label: "Fundação Getulio Vargas", value: "Fundação Getulio Vargas" },
  { label: "Grove City College ", value: "Grove City College " },
  { label: "HITO Master DAP SL", value: "HITO Master DAP SL" },
  { label: "Hogeschool PXL", value: "Hogeschool PXL" },
  { label: "Humboldt State University", value: "Humboldt State University" },
  { label: "IAG-A Escola de Negocios da Puc-Rio", value: "IAG-A Escola de Negocios da Puc-Rio" },
  { label: "Indiana Wesleyan University", value: "Indiana Wesleyan University" },
  { label: "INSEEC ", value: "INSEEC " },
  { label: "Institución Universitaria Politécnico Grancolombiano", value: "Institución Universitaria Politécnico Grancolombiano" },
  { label: "Instituto Tecnologico de Monterrey", value: "Instituto Tecnologico de Monterrey" },
  { label: "John Brown University", value: "John Brown University" },
  { label: "Lambton College in Toronto", value: "Lambton College in Toronto" },
  { label: "Lambton College of Applied Arts and Technology, Sarnia, Ontario", value: "Lambton College of Applied Arts and Technology, Sarnia, Ontario" },
  { label: "Langara College", value: "Langara College" },
  { label: "Laval University", value: "Laval University" },
  { label: "Loyola University, New Orleans", value: "Loyola University, New Orleans" },
  { label: "Mary Baldwin College", value: "Mary Baldwin College" },
  { label: "Metropolitan Community College", value: "Metropolitan Community College" },
  { label: "Metropolitan State University", value: "Metropolitan State University" },
  { label: "Montclair State University", value: "Montclair State University" },
  { label: "National Academy of Construction Hyderabad", value: "National Academy of Construction Hyderabad" },
  { label: "OBS (EAE Institucion)", value: "OBS (EAE Institucion)" },
  { label: "ONTREO (EAE Institucion)", value: "ONTREO (EAE Institucion)" },
  { label: "Paderborn University ", value: "Paderborn University " },
  { label: "Paris School of Business ", value: "Paris School of Business " },
  { label: "Peruvian University of Applied Sciences", value: "Peruvian University of Applied Sciences" },
  { label: "Politécnico Grancolombiano ", value: "Politécnico Grancolombiano " },
  { label: "Pontifical Catholic University ", value: "Pontifical Catholic University " },
  { label: "Pontificia Universidad Católica", value: "Pontificia Universidad Católica" },
  { label: "Pontificia Universidade do Rio Grande do Sul (PUCPR)", value: "Pontificia Universidade do Rio Grande do Sul (PUCPR)" },
  { label: "Reykjavik University", value: "Reykjavik University" },
  { label: "Royal Military Academy", value: "Royal Military Academy" },
  { label: "Rutgers University", value: "Rutgers University" },
  { label: "Senac Campinas", value: "Senac Campinas" },
  { label: "Senac Campus Santo Amaro ", value: "Senac Campus Santo Amaro " },
  { label: "Senac Lapa Tito", value: "Senac Lapa Tito" },
  { label: "Senac Lapa Tito", value: "Senac Lapa Tito" },
  { label: "Senac Oscasco", value: "Senac Oscasco" },
  { label: "Senac Ribeirão Preto", value: "Senac Ribeirão Preto" },
  { label: "Senac Santo Andre", value: "Senac Santo Andre" },
  { label: "Senac São José do Rio Preto", value: "Senac São José do Rio Preto" },
  { label: "Senac Sao Paolo", value: "Senac Sao Paolo" },
  { label: "Seneca College", value: "Seneca College" },
  { label: "Smith College ", value: "Smith College " },
  { label: "Southern Utah University", value: "Southern Utah University" },
  { label: "Southwestern Adventist University", value: "Southwestern Adventist University" },
  { label: "St. Lawrence College", value: "St. Lawrence College" },
  { label: "Syracuse University", value: "Syracuse University" },
  { label: "TECSUP ", value: "TECSUP " },
  { label: "Telkom University", value: "Telkom University" },
  { label: "Toulouse Business School", value: "Toulouse Business School" },
  { label: "UAGRM Business School", value: "UAGRM Business School" },
  { label: "U-ERRE - Universidad Regiomontana", value: "U-ERRE - Universidad Regiomontana" },
  { label: "UNIBE - Universidad Iberoamericana", value: "UNIBE - Universidad Iberoamericana" },
  { label: "UNIR - Universidad Internacional de la Rioja", value: "UNIR - Universidad Internacional de la Rioja" },
  { label: "UNITEC- Universidad Tecnológica Centroamericana ", value: "UNITEC- Universidad Tecnológica Centroamericana " },
  { label: "Univalle", value: "Univalle" },
  { label: "Universal College of Learning", value: "Universal College of Learning" },
  { label: "Universidad Autonoma Gabriel Rene Moreno", value: "Universidad Autonoma Gabriel Rene Moreno" },
  { label: "Universidad Catolica Boliviana - San Pablo ", value: "Universidad Catolica Boliviana - San Pablo " },
  { label: "Universidad Catolica del Norte", value: "Universidad Catolica del Norte" },
  { label: "Universidad de Chile", value: "Universidad de Chile" },
  { label: "Universidad de Especialidades Espiritu Santo (UEES)", value: "Universidad de Especialidades Espiritu Santo (UEES)" },
  { label: "Universidad de Las Americas", value: "Universidad de Las Americas" },
  { label: "Universidad de San Buenaventura", value: "Universidad de San Buenaventura" },
  { label: "Universidad del CEMA", value: "Universidad del CEMA" },
  { label: "Universidad del Magdalena", value: "Universidad del Magdalena" },
  { label: "Universidad del Norte", value: "Universidad del Norte" },
  { label: "Universidad del Valle de Guatemala", value: "Universidad del Valle de Guatemala" },
  { label: "Universidad del Valle de Guatemala ", value: "Universidad del Valle de Guatemala " },
  { label: "Universidad del Valle, Bolivia - Univalle S.A", value: "Universidad del Valle, Bolivia - Univalle S.A" },
  { label: "Universidad del Valle, Colombia", value: "Universidad del Valle, Colombia" },
  { label: "Universidad EAFIT", value: "Universidad EAFIT" },
  { label: "Universidad EAN", value: "Universidad EAN" },
  { label: "Universidad Galileo", value: "Universidad Galileo" },
  { label: "Universidad Iberoamericana (UNIBE)", value: "Universidad Iberoamericana (UNIBE)" },
  { label: "Universidad ICESI", value: "Universidad ICESI" },
  { label: "Universidad Internacional de la Rioja", value: "Universidad Internacional de la Rioja" },
  { label: "Universidad Internacional Valenciana, S.L. (VIU)", value: "Universidad Internacional Valenciana, S.L. (VIU)" },
  { label: "Universidad Piloto de Colombia", value: "Universidad Piloto de Colombia" },
  { label: "Universidad Piloto de Colombia", value: "Universidad Piloto de Colombia" },
  { label: "Universidad Pontificia Bolivariana", value: "Universidad Pontificia Bolivariana" },
  { label: "Universidad Privada de Santa Cruz de la Sierra", value: "Universidad Privada de Santa Cruz de la Sierra" },
  { label: "Universidad Rafael Landivar", value: "Universidad Rafael Landivar" },
  { label: "Universidad Regiomontana, U-ERRE  ", value: "Universidad Regiomontana, U-ERRE  " },
  { label: "Universidad San Francisco de Quito", value: "Universidad San Francisco de Quito" },
  { label: "Universidad Tec Milenio", value: "Universidad Tec Milenio" },
  { label: "Universidad Tecnica Particular De Loja", value: "Universidad Tecnica Particular De Loja" },
  { label: "Universidad Tecnologica de Bolivar ", value: "Universidad Tecnologica de Bolivar " },
  { label: "Universidad Tecnologica Privada de Santa Cruz", value: "Universidad Tecnologica Privada de Santa Cruz" },
  { label: "Universidad Viña del Mar", value: "Universidad Viña del Mar" },
  { label: "Universidade Adolfo Ibanez", value: "Universidade Adolfo Ibanez" },
  { label: "Universidade de Catalunya", value: "Universidade de Catalunya" },
  { label: "Universidade de Caxias do Sul ", value: "Universidade de Caxias do Sul " },
  { label: "Universidade Federal do Rio Grande do Sul", value: "Universidade Federal do Rio Grande do Sul" },
  { label: "Universidade La Salle  - Brazil ", value: "Universidade La Salle  - Brazil " },
  { label: "Universidade Tecnica Federico Santa Maria", value: "Universidade Tecnica Federico Santa Maria" },
  { label: "Universidade Vila Velha ", value: "Universidade Vila Velha " },
  { label: "Universitas Islam Indonesia", value: "Universitas Islam Indonesia" },
  { label: "Universitat de Barcelona, IL3", value: "Universitat de Barcelona, IL3" },
  { label: "Universite de Sherbrooke", value: "Universite de Sherbrooke" },
  { label: "Université Laval", value: "Université Laval" },
  { label: "University of Bradford", value: "University of Bradford" },
  { label: "University of Buea", value: "University of Buea" },
  { label: "University of Fortaleza", value: "University of Fortaleza" },
  { label: "University of Maryland University College", value: "University of Maryland University College" },
  { label: "University of Missouri", value: "University of Missouri" },
  { label: "University of Namibia ", value: "University of Namibia " },
  { label: "University of New Brunswick", value: "University of New Brunswick" },
  { label: "University of Salamanca", value: "University of Salamanca" },
  { label: "University of Utah", value: "University of Utah" },
  { label: "University of Valencia", value: "University of Valencia" },
  { label: "University of Washinghton Tacoma ", value: "University of Washinghton Tacoma " },
  { label: "University of West Indies ", value: "University of West Indies " },
  { label: "University of Winnipeg", value: "University of Winnipeg" },
  { label: "Uvirtual Universidad", value: "Uvirtual Universidad" },
  { label: "Wawasan Open University", value: "Wawasan Open University" },
  { label: "Western Governeors University", value: "Western Governeors University" },
  { label: "Yakima Valley College", value: "Yakima Valley College" },
  { label: "York County Community College ", value: "York County Community College " },
  { label: "Youngstown State University ", value: "Youngstown State University " },
  { label: "114th Partnership", value: "114th Partnership" },
  { label: "4 H", value: "4 H" },
  { label: "ACTE", value: "ACTE" },
  { label: "Advance CTE", value: "Advance CTE" },
  { label: "ALAS", value: "ALAS" },
  { label: "American Camp Association", value: "American Camp Association" },
  { label: "CALCA", value: "CALCA" },
  { label: "CARE USA", value: "CARE USA" },
  { label: "CCSSO (Council of Chief State School Officers", value: "CCSSO (Council of Chief State School Officers" },
  { label: "Center for Digital Inclusion (CDI) (RECODE)", value: "Center for Digital Inclusion (CDI) (RECODE)" },
  { label: "COSN", value: "COSN" },
  { label: "DECA", value: "DECA" },
  { label: "Destination Imagination", value: "Destination Imagination" },
  { label: "Educa", value: "Educa" },
  { label: "Educación para Compartir (Education for Sharing)", value: "Educación para Compartir (Education for Sharing)" },
  { label: "Focal Point Global", value: "Focal Point Global" },
  { label: "Fondazione Enrica Amiotti", value: "Fondazione Enrica Amiotti" },
  { label: "Future Problem Solving Program International", value: "Future Problem Solving Program International" },
  { label: "Girl Scouts USA", value: "Girl Scouts USA" },
  { label: "Helen Keller International", value: "Helen Keller International" },
  { label: "iEARN (International Education and Resource Network", value: "iEARN (International Education and Resource Network" },
  { label: "INJAZ", value: "INJAZ" },
  { label: "International Model United Nations", value: "International Model United Nations" },
  { label: "Iowa CTE Programs Schools", value: "Iowa CTE Programs Schools" },
  { label: "JA Americas", value: "JA Americas" },
  { label: "JA Worldwide", value: "JA Worldwide" },
  { label: "Junior Achievement Brazil", value: "Junior Achievement Brazil" },
  { label: "Junior Achievement of Chicago", value: "Junior Achievement of Chicago" },
  { label: "Junior Achievement USA ", value: "Junior Achievement USA " },
  { label: "Junior Achievment Ireland", value: "Junior Achievment Ireland" },
  { label: "Kiwanis Youth Programs", value: "Kiwanis Youth Programs" },
  { label: "Marine Advanced Technology Education (MATE) ROV Competition", value: "Marine Advanced Technology Education (MATE) ROV Competition" },
  { label: "NAF", value: "NAF" },
  { label: "NASA Goddard Optimus Prime Spinoff Challenge", value: "NASA Goddard Optimus Prime Spinoff Challenge" },
  { label: "NASA Human Exploration Rover Challenge", value: "NASA Human Exploration Rover Challenge" },
  { label: "North Carolina State Dept of Educ", value: "North Carolina State Dept of Educ" },
  { label: "OnPoint Partners", value: "OnPoint Partners" },
  { label: "PBL Works (Formerly Buck Institute for Education)", value: "PBL Works (Formerly Buck Institute for Education)" },
  { label: "Philadelphia Academies", value: "Philadelphia Academies" },
  { label: "Philadelphia School District ", value: "Philadelphia School District " },
  { label: "Plan International", value: "Plan International" },
  { label: "Pratham", value: "Pratham" },
  { label: "Rise Against Hunger (formerly Stop Hunger Now)", value: "Rise Against Hunger (formerly Stop Hunger Now)" },
  { label: "Rotary International", value: "Rotary International" },
  { label: "SeaPerch National Challenge", value: "SeaPerch National Challenge" },
  { label: "SREB (Southern Regional Educational Board)", value: "SREB (Southern Regional Educational Board)" },
  { label: "The Alliance for Education-All4ED", value: "The Alliance for Education-All4ED" },
  { label: "The Torrance Center - Portugal", value: "The Torrance Center - Portugal" },
  { label: "True Colors Fund", value: "True Colors Fund" },
  { label: "Union of Brazilian Scouts", value: "Union of Brazilian Scouts" },
  { label: "World Federation of United Nations Associations", value: "World Federation of United Nations Associations" },
  { label: "New York Public Schools", value: "New York Public Schools" },
  { value: "Universiti Malaysia Pahang", label: "Universiti Malaysia Pahang" },
  { value: "Vistula University", label: "Vistula University" },
  { value: "Beijing University of Posts and Telecommunications", label: "Beijing University of Posts and Telecommunications" },
  { value: "Universidad El Bosque", label: "Universidad El Bosque" },
  { value: "Granite State College", label: "Granite State College" },
  { value: "Southern Alberta Institute of Technology (SAIT)", label: "Southern Alberta Institute of Technology (SAIT)" },
  { value: "Amity University", label: "Amity University" },
  { value: "Stevens Institute of Technology", label: "Stevens Institute of Technology" },
  { value: "Skema Business School", label: "Skema Business School" },
  { value: "Western Carolina University", label: "Western Carolina University" },
  { value: "University of Texas at Dallas", label: "University of Texas at Dallas" },
  { value: "RMIT University", label: "RMIT University" },
  { value: "University of Pretoria", label: "University of Pretoria" },
  { value: "Capella University", label: "Capella University" },
  { value: "Heriot-Watt University", label: "Heriot-Watt University" },
  { value: "George Washington University", label: "George Washington University" },
  { value: "Tsinghua University", label: "Tsinghua University" },
  { value: "Universidad para la Cooperacion Internacional (University for International Cooperation)", label: "Universidad para la Cooperacion Internacional (University for International Cooperation)" },
  { value: "Missouri State University", label: "Missouri State University" },
  { value: "Robert Gordon University", label: "Robert Gordon University" },
  { value: "British University in Dubai (BUiD)", label: "British University in Dubai (BUiD)" },
  { value: "University of Maryland Global Campus", label: "University of Maryland Global Campus" },
  { value: "Edith Cowan University", label: "Edith Cowan University" },
  { value: "University of Houston", label: "University of Houston" },
  { value: "Curtin University", label: "Curtin University" },
  { value: "City University of Seattle", label: "City University of Seattle" },
  { value: "Florida Institute of Technology", label: "Florida Institute of Technology" },
  { value: "Morgan State University", label: "Morgan State University" },
  { value: "University of Maryland", label: "University of Maryland" },
  { value: "Minnesota State University-Moorhead, ", label: "Minnesota State University-Moorhead, " },
  { value: "College of St. Scholastica", label: "College of St. Scholastica" },
  { value: "New York University ", label: "New York University " },
  { value: "Amberton University", label: "Amberton University" },
  { value: "SNSPA-National School of Political Studies and Public Administration", label: "SNSPA-National School of Political Studies and Public Administration" },
  { value: "University of Westminster", label: "University of Westminster" },
  { value: "Escuela Superior Politecnica del Litoral (ESPOL)", label: "Escuela Superior Politecnica del Litoral (ESPOL)" },
  { value: "Hohai University", label: "Hohai University" },
  { value: "Queensland University of Technology", label: "Queensland University of Technology" },
  { value: "Bond University ", label: "Bond University " },
  { value: "Université du Québec à Montréal", label: "Université du Québec à Montréal" },
  { value: "HELP University", label: "HELP University" },
  { value: "Colorado State University - Global Campus", label: "Colorado State University - Global Campus" },
  { value: "Universidad Tecnológica Centroamericana (UNITEC)", label: "Universidad Tecnológica Centroamericana (UNITEC)" },
  { value: "Harrisburg University of Science and Technology", label: "Harrisburg University of Science and Technology" },
  { value: "Northwestern Polytechnical University", label: "Northwestern Polytechnical University" },
  { value: "University of Technology, Sydney", label: "University of Technology, Sydney" },
  { value: "University of Management and Technology", label: "University of Management and Technology" },
  { value: "Boston University - Metropolitan College", label: "Boston University - Metropolitan College" },
  { value: "University of Sydney ", label: "University of Sydney " },
  { value: "DeVry University", label: "DeVry University" },
  { value: "Saint Mary's University of Minnesota", label: "Saint Mary's University of Minnesota" },
  { value: "University of Alaska-Anchorage", label: "University of Alaska-Anchorage" },
  { value: "University of Wisconsin, Platteville", label: "University of Wisconsin, Platteville" },
  { value: "Shanghai Jiao Tong University", label: "Shanghai Jiao Tong University" },
  { value: "Colorado Technical University (CTU)", label: "Colorado Technical University (CTU)" },
  { value: "University of Limerick", label: "University of Limerick" },
  { value: "La Salle Ramon Llull University", label: "La Salle Ramon Llull University" },
  { value: "The Citadel", label: "The Citadel" },
  { value: "Regis University", label: "Regis University" },
  { value: "Walden University", label: "Walden University" },
  { value: "Norwich University", label: "Norwich University" },
  { value: "Tianjin University", label: "Tianjin University" },
  { value: "Shandong University", label: "Shandong University" },
  { value: "Embry-Riddle Aeronautical University ", label: "Embry-Riddle Aeronautical University " },
  { value: "Hanyang University", label: "Hanyang University" },
  { value: "Northeastern University", label: "Northeastern University" },
  { value: "Bellevue University", label: "Bellevue University" },
  { value: "Tongji University", label: "Tongji University" },
  { value: "La Universidad Peruana de Ciencias Aplicadas (UPC)", label: "La Universidad Peruana de Ciencias Aplicadas (UPC)" },
  { value: "Columbia Basin College", label: "Columbia Basin College" },
  { value: "ISACA", label: "ISACA" },
  { value: "CommFranc", label: "CommFranc" },
  { value: "PMIGSNA", label: "PMIGSNA" },
  { value: "PDMA", label: "PDMA" },
  { value: "CCL", label: "CCL" },
  { value: "CompTIA", label: "CompTIA" },
  { value: "IPMA", label: "IPMA" },
  { value: "MASSCOM", label: "MASSCOM" },
  { value: "PMO GLobal Alliance", label: "PMO GLobal Alliance" },
  { value: "HIMSS", label: "HIMSS" },
  { value: "INCOSE", label: "INCOSE" },
  { value: "Reconomics", label: "Reconomics" },
  { value: "TOCICO", label: "TOCICO" },
  { value: "ACMP", label: "ACMP" },
  { value: "The Conference Board", label: "The Conference Board" },
  { value: "World Business Council For Sustainable Development", label: "World Business Council For Sustainable Development" },
  { value: "Unleash", label: "Unleash" },
  { value: "TEF", label: "TEF" },
  { value: "TCS", label: "TCS" },
  { value: "Grow with Google", label: "Grow with Google" },
  { value: "UN Global Compact", label: "UN Global Compact" },
  { value: "CompassPoint", label: "CompassPoint" },
  { value: "None", label: "None" },
  { value: "Harvard University", label: "Harvard University" },
  { value: "Stanford University", label: "Stanford University" },
  { value: "University of Cambridge", label: "University of Cambridge" },
  {
    value: "Massachusetts Institute of Technology (MIT)",
    label: "Massachusetts Institute of Technology (MIT)",
  },
  {
    value: "University of California, Berkeley",
    label: "University of California, Berkeley",
  },
  { value: "Princeton University", label: "Princeton University" },
  { value: "Columbia University", label: "Columbia University" },
  {
    value: "California Institute of Technology",
    label: "California Institute of Technology",
  },
  { value: "University of Oxford", label: "University of Oxford" },
  { value: "University of Chicago", label: "University of Chicago" },
  { value: "Yale University", label: "Yale University" },
  { value: "Cornell University", label: "Cornell University" },
  {
    value: "University of California, Los Angeles",
    label: "University of California, Los Angeles",
  },
  { value: "Paris-Saclay University", label: "Paris-Saclay University" },
  { value: "Johns Hopkins University", label: "Johns Hopkins University" },
  { value: "University College London", label: "University College London" },
  { value: "University of Washington", label: "University of Washington" },
  {
    value: "University of California, San Diego",
    label: "University of California, San Diego",
  },
  { value: "University of Pennsylvania", label: "University of Pennsylvania" },
  { value: "ETH Zurich", label: "ETH Zurich" },
  {
    value: "University of California, San Francisco",
    label: "University of California, San Francisco",
  },
  {
    value: "University of Michigan-Ann Arbor",
    label: "University of Michigan-Ann Arbor",
  },
  { value: "University of Toronto", label: "University of Toronto" },
  {
    value: "Washington University in St. Louis",
    label: "Washington University in St. Louis",
  },
  { value: "Imperial College London", label: "Imperial College London" },
  { value: "The University of Tokyo", label: "The University of Tokyo" },
  { value: "Duke University", label: "Duke University" },
  { value: "New York University", label: "New York University" },
  { value: "Tsinghua University", label: "Tsinghua University" },
  { value: "Northwestern University", label: "Northwestern University" },
  {
    value: "University of North Carolina at Chapel Hill",
    label: "University of North Carolina at Chapel Hill",
  },
  {
    value: "University of Wisconsin - Madison",
    label: "University of Wisconsin - Madison",
  },
  { value: "University of Copenhagen", label: "University of Copenhagen" },
  { value: "Kyoto University", label: "Kyoto University" },
  {
    value: "The University of Melbourne",
    label: "The University of Melbourne",
  },
  { value: "PSL University", label: "PSL University" },
  {
    value: "The University of Manchester",
    label: "The University of Manchester",
  },
  {
    value: "University of British Columbia",
    label: "University of British Columbia",
  },
  { value: "Sorbonne University", label: "Sorbonne University" },
  {
    value: "University of Minnesota, Twin Cities",
    label: "University of Minnesota, Twin Cities",
  },
  {
    value: "The University of Texas at Austin",
    label: "The University of Texas at Austin",
  },
  {
    value: "The University of Edinburgh",
    label: "The University of Edinburgh",
  },
  { value: "Rockefeller University", label: "Rockefeller University" },
  {
    value: "University of Colorado at Boulder",
    label: "University of Colorado at Boulder",
  },
  { value: "Karolinska Institute", label: "Karolinska Institute" },
  {
    value: "University of Illinois at Urbana-Champaign",
    label: "University of Illinois at Urbana-Champaign",
  },
  { value: "King's College London", label: "King's College London" },
  {
    value: "The University of Texas Southwestern Medical Center at Dallas",
    label: "The University of Texas Southwestern Medical Center at Dallas",
  },
  { value: "Peking University", label: "Peking University" },
  {
    value: "University of California, Santa Barbara",
    label: "University of California, Santa Barbara",
  },
  { value: "University of Munich", label: "University of Munich" },
  { value: "Utrecht University", label: "Utrecht University" },
  {
    value: "University of Maryland, College Park",
    label: "University of Maryland, College Park",
  },
  {
    value: "Technical University of Munich",
    label: "Technical University of Munich",
  },
  {
    value: "The University of Queensland",
    label: "The University of Queensland",
  },
  { value: "University of Zurich", label: "University of Zurich" },
  { value: "Heidelberg University", label: "Heidelberg University" },
  { value: "Zhejiang University", label: "Zhejiang University" },
  { value: "University of Geneva", label: "University of Geneva" },
  { value: "University of Oslo", label: "University of Oslo" },
  {
    value: "University of Southern California",
    label: "University of Southern California",
  },
  { value: "Vanderbilt University", label: "Vanderbilt University" },
  {
    value: "Shanghai Jiao Tong University",
    label: "Shanghai Jiao Tong University",
  },
  { value: "University of Bristol", label: "University of Bristol" },
  { value: "University of Paris", label: "University of Paris" },
  { value: "Ghent University", label: "Ghent University" },
  {
    value: "The Australian National University",
    label: "The Australian National University",
  },
  {
    value: "The University of Texas M. D. Anderson Cancer Center",
    label: "The University of Texas M. D. Anderson Cancer Center",
  },
  { value: "Aarhus University", label: "Aarhus University" },
  { value: "Stockholm University", label: "Stockholm University" },
  {
    value: "University of California, Irvine",
    label: "University of California, Irvine",
  },
  { value: "University of Groningen", label: "University of Groningen" },
  {
    value: "University of Science and Technology of China",
    label: "University of Science and Technology of China",
  },
  {
    value: "The University of New South Wales",
    label: "The University of New South Wales",
  },
  { value: "University of Helsinki", label: "University of Helsinki" },
  { value: "University of Sydney", label: "University of Sydney" },
  { value: "Uppsala University", label: "Uppsala University" },
  { value: "McGill University", label: "McGill University" },
  {
    value: "Purdue University - West Lafayette",
    label: "Purdue University - West Lafayette",
  },
  {
    value: "Erasmus University Rotterdam",
    label: "Erasmus University Rotterdam",
  },
  { value: "Leiden University", label: "Leiden University" },
  {
    value: "National University of Singapore",
    label: "National University of Singapore",
  },
  { value: "Nagoya University", label: "Nagoya University" },
  {
    value: "Swiss Federal Institute of Technology Lausanne",
    label: "Swiss Federal Institute of Technology Lausanne",
  },
  { value: "Monash University", label: "Monash University" },
  {
    value: "The University of Western Australia",
    label: "The University of Western Australia",
  },
  { value: "University of Bonn", label: "University of Bonn" },
  { value: "University of Basel", label: "University of Basel" },
  { value: "University of Florida", label: "University of Florida" },
  { value: "Boston University", label: "Boston University" },
  {
    value: "Nanyang Technological University",
    label: "Nanyang Technological University",
  },
  {
    value: "University of California, Davis",
    label: "University of California, Davis",
  },
  { value: "Moscow State University", label: "Moscow State University" },
  {
    value: "Weizmann Institute of Science",
    label: "Weizmann Institute of Science",
  },
  { value: "Carnegie Mellon University", label: "Carnegie Mellon University" },
  { value: "University of Pittsburgh", label: "University of Pittsburgh" },
  { value: "KU Leuven", label: "KU Leuven" },
  { value: "McMaster University", label: "McMaster University" },
  { value: "Université Grenoble Alpes", label: "Université Grenoble Alpes" },
  { value: "Fudan University", label: "Fudan University" },
  { value: "Aix Marseille University", label: "Aix Marseille University" },
  { value: "Arizona State University", label: "Arizona State University" },
  { value: "Brown University", label: "Brown University" },
  {
    value: "Case Western Reserve University",
    label: "Case Western Reserve University",
  },
  { value: "Central South University", label: "Central South University" },
  { value: "Emory University", label: "Emory University" },
  {
    value: "Georgia Institute of Technology",
    label: "Georgia Institute of Technology",
  },
  {
    value: "Goethe University Frankfurt",
    label: "Goethe University Frankfurt",
  },
  {
    value: "Harbin Institute of Technology",
    label: "Harbin Institute of Technology",
  },
  {
    value: "Huazhong University of Science and Technology",
    label: "Huazhong University of Science and Technology",
  },
  {
    value: "Icahn School of Medicine at Mount Sinai",
    label: "Icahn School of Medicine at Mount Sinai",
  },
  {
    value: "Indiana University Bloomington",
    label: "Indiana University Bloomington",
  },
  { value: "King Abdulaziz University", label: "King Abdulaziz University" },
  {
    value: "Mayo Clinic Alix School of Medicine",
    label: "Mayo Clinic Alix School of Medicine",
  },
  { value: "Michigan State University", label: "Michigan State University" },
  { value: "Nanjing University", label: "Nanjing University" },
  {
    value: "Norwegian University of Science and Technology - NTNU",
    label: "Norwegian University of Science and Technology - NTNU",
  },
  {
    value: "Pennsylvania State University - University Park",
    label: "Pennsylvania State University - University Park",
  },
  {
    value: "Radboud University Nijmegen",
    label: "Radboud University Nijmegen",
  },
  { value: "Rice University", label: "Rice University" },
  {
    value: "Rutgers, The State University of New Jersey - New Brunswick",
    label: "Rutgers, The State University of New Jersey - New Brunswick",
  },
  { value: "Seoul National University", label: "Seoul National University" },
  { value: "Southeast University", label: "Southeast University" },
  { value: "Sun Yat-sen University", label: "Sun Yat-sen University" },
  {
    value: "Technion-Israel Institute of Technology",
    label: "Technion-Israel Institute of Technology",
  },
  {
    value: "The Chinese University of Hong Kong",
    label: "The Chinese University of Hong Kong",
  },
  {
    value: "The Hebrew University of Jerusalem",
    label: "The Hebrew University of Jerusalem",
  },
  {
    value: "The Ohio State University - Columbus",
    label: "The Ohio State University - Columbus",
  },
  {
    value: "The University of Sheffield",
    label: "The University of Sheffield",
  },
  {
    value: "Tokyo Institute of Technology",
    label: "Tokyo Institute of Technology",
  },
  {
    value: "Université libre de Bruxelles (ULB)",
    label: "Université libre de Bruxelles (ULB)",
  },
  { value: "University of Alberta", label: "University of Alberta" },
  { value: "University of Amsterdam", label: "University of Amsterdam" },
  { value: "University of Arizona", label: "University of Arizona" },
  { value: "University of Bern", label: "University of Bern" },
  { value: "University of Birmingham", label: "University of Birmingham" },
  { value: "University of Freiburg", label: "University of Freiburg" },
  { value: "University of Goettingen", label: "University of Goettingen" },
  { value: "University of Gothenburg", label: "University of Gothenburg" },
  { value: "University of Lausanne", label: "University of Lausanne" },
  { value: "University of Leeds", label: "University of Leeds" },
  { value: "University of Liverpool", label: "University of Liverpool" },
  { value: "University of Nottingham", label: "University of Nottingham" },
  { value: "University of Sao Paulo", label: "University of Sao Paulo" },
  { value: "University of Southampton", label: "University of Southampton" },
  { value: "University of Strasbourg", label: "University of Strasbourg" },
  { value: "University of Utah", label: "University of Utah" },
  { value: "University of Warwick", label: "University of Warwick" },
  {
    value: "Vrije Universiteit Amsterdam",
    label: "Vrije Universiteit Amsterdam",
  },
  { value: "Xi'an Jiaotong University", label: "Xi'an Jiaotong University" },
  { value: "Baylor College of Medicine", label: "Baylor College of Medicine" },
  { value: "Beihang University", label: "Beihang University" },
  { value: "Cardiff University", label: "Cardiff University" },
  {
    value: "Catholic University of Louvain",
    label: "Catholic University of Louvain",
  },
  {
    value: "Delft University of Technology",
    label: "Delft University of Technology",
  },
  { value: "Hokkaido University", label: "Hokkaido University" },
  { value: "Jilin University", label: "Jilin University" },
  { value: "King Saud University", label: "King Saud University" },
  {
    value: "London School of Economics and Political Science",
    label: "London School of Economics and Political Science",
  },
  { value: "Lund University", label: "Lund University" },
  { value: "Osaka University", label: "Osaka University" },
  {
    value: "Sapienza University of Rome",
    label: "Sapienza University of Rome",
  },
  { value: "Shandong University", label: "Shandong University" },
  { value: "Sichuan University", label: "Sichuan University" },
  { value: "Soochow University (China)", label: "Soochow University (China)" },
  {
    value: "South China University of Technology",
    label: "South China University of Technology",
  },
  {
    value: "Technical University of Denmark",
    label: "Technical University of Denmark",
  },
  { value: "Tel Aviv University", label: "Tel Aviv University" },
  { value: "Texas A&M University", label: "Texas A&M University" },
  { value: "The University of Adelaide", label: "The University of Adelaide" },
  { value: "The University of Calgary", label: "The University of Calgary" },
  { value: "The University of Glasgow", label: "The University of Glasgow" },
  {
    value: "The University of Hong Kong",
    label: "The University of Hong Kong",
  },
  { value: "Tianjin University", label: "Tianjin University" },
  { value: "Tohoku University", label: "Tohoku University" },
  { value: "Trinity College Dublin", label: "Trinity College Dublin" },
  { value: "Tufts University", label: "Tufts University" },
  { value: "University of Barcelona", label: "University of Barcelona" },
  {
    value: "University of California, Santa Cruz",
    label: "University of California, Santa Cruz",
  },
  { value: "University of Cologne", label: "University of Cologne" },
  {
    value: "University of Electronic Science and Technology of China",
    label: "University of Electronic Science and Technology of China",
  },
  { value: "University of Exeter", label: "University of Exeter" },
  { value: "University of Lisbon", label: "University of Lisbon" },
  {
    value: "University of Massachusetts Amherst",
    label: "University of Massachusetts Amherst",
  },
  {
    value: "University of Massachusetts Medical School - Worcester",
    label: "University of Massachusetts Medical School - Worcester",
  },
  { value: "University of Milan", label: "University of Milan" },
  {
    value: "University of Missouri - Columbia",
    label: "University of Missouri - Columbia",
  },
  { value: "University of Montpellier", label: "University of Montpellier" },
  { value: "University of Montreal", label: "University of Montreal" },
  { value: "University of Muenster", label: "University of Muenster" },
  { value: "University of Ottawa", label: "University of Ottawa" },
  { value: "University of Pisa", label: "University of Pisa" },
  { value: "University of Rochester", label: "University of Rochester" },
  { value: "University of Sussex", label: "University of Sussex" },
  { value: "University of Tuebingen", label: "University of Tuebingen" },
  { value: "University of Vienna", label: "University of Vienna" },
  { value: "University of Virginia", label: "University of Virginia" },
  { value: "University of Waterloo", label: "University of Waterloo" },
  {
    value: "Wageningen University & Research",
    label: "Wageningen University & Research",
  },
  { value: "Wuhan University", label: "Wuhan University" },
  {
    value: "Autonomous University of Barcelona",
    label: "Autonomous University of Barcelona",
  },
  {
    value: "Beijing Institute of Technology",
    label: "Beijing Institute of Technology",
  },
  { value: "Beijing Normal University", label: "Beijing Normal University" },
  {
    value: "Charles University in Prague",
    label: "Charles University in Prague",
  },
  {
    value: "China Medical University (Taichung)",
    label: "China Medical University (Taichung)",
  },
  {
    value: "City University of Hong Kong",
    label: "City University of Hong Kong",
  },
  {
    value: "Claude Bernard University Lyon 1",
    label: "Claude Bernard University Lyon 1",
  },
  { value: "Colorado State University", label: "Colorado State University" },
  {
    value: "Complutense University of Madrid",
    label: "Complutense University of Madrid",
  },
  { value: "Curtin University", label: "Curtin University" },
  { value: "Dalhousie University", label: "Dalhousie University" },
  {
    value: "Dalian University of Technology",
    label: "Dalian University of Technology",
  },
  { value: "Dartmouth College", label: "Dartmouth College" },
  { value: "Deakin University", label: "Deakin University" },
  { value: "Durham University", label: "Durham University" },
  { value: "Florida State University", label: "Florida State University" },
  { value: "George Mason University", label: "George Mason University" },
  { value: "Georgetown University", label: "Georgetown University" },
  { value: "Hanyang University", label: "Hanyang University" },
  { value: "Hunan University", label: "Hunan University" },
  { value: "Iowa State University", label: "Iowa State University" },
  {
    value: "Karlsruhe Institute of Technology (KIT)",
    label: "Karlsruhe Institute of Technology (KIT)",
  },
  {
    value: "King Abdullah University of Science and Technology",
    label: "King Abdullah University of Science and Technology",
  },
  {
    value: "Korea Advanced Institute of Science and Technology",
    label: "Korea Advanced Institute of Science and Technology",
  },
  { value: "Korea University", label: "Korea University" },
  {
    value: "KTH Royal Institute of Technology",
    label: "KTH Royal Institute of Technology",
  },
  {
    value: "London School of Hygiene & Tropical Medicine",
    label: "London School of Hygiene & Tropical Medicine",
  },
  { value: "Maastricht University", label: "Maastricht University" },
  { value: "Macquarie University", label: "Macquarie University" },
  {
    value: "Medical University of Vienna",
    label: "Medical University of Vienna",
  },
  { value: "Nankai University", label: "Nankai University" },
  {
    value: "National Autonomous University of Mexico",
    label: "National Autonomous University of Mexico",
  },
  { value: "National Taiwan University", label: "National Taiwan University" },
  { value: "Newcastle University", label: "Newcastle University" },
  {
    value: "North Carolina State University - Raleigh",
    label: "North Carolina State University - Raleigh",
  },
  {
    value: "Northeastern University (Boston)",
    label: "Northeastern University (Boston)",
  },
  {
    value: "Northwestern Polytechnical University",
    label: "Northwestern Polytechnical University",
  },
  {
    value: "Oregon Health and Science University",
    label: "Oregon Health and Science University",
  },
  { value: "Oregon State University", label: "Oregon State University" },
  {
    value: "Paul Sabatier University (Toulouse 3)",
    label: "Paul Sabatier University (Toulouse 3)",
  },
  {
    value: "Polytechnic University of Milan",
    label: "Polytechnic University of Milan",
  },
  {
    value: "Queen Mary University of London",
    label: "Queen Mary University of London",
  },
  { value: "Queen's University", label: "Queen's University" },
  { value: "RWTH Aachen University", label: "RWTH Aachen University" },
  { value: "Shenzhen University", label: "Shenzhen University" },
  { value: "Stony Brook University", label: "Stony Brook University" },
  { value: "Sungkyunkwan University", label: "Sungkyunkwan University" },
  {
    value: "Swinburne University of Technology",
    label: "Swinburne University of Technology",
  },
  {
    value: "The Hong Kong Polytechnic University",
    label: "The Hong Kong Polytechnic University",
  },
  { value: "The University of Auckland", label: "The University of Auckland" },
  { value: "The University of Georgia", label: "The University of Georgia" },
  { value: "The University of Reading", label: "The University of Reading" },
  { value: "Tongji University", label: "Tongji University" },
  { value: "TU Dresden", label: "TU Dresden" },
  { value: "University of Aberdeen", label: "University of Aberdeen" },
  { value: "University of Bologna", label: "University of Bologna" },
  { value: "University of Bordeaux", label: "University of Bordeaux" },
  { value: "University of Buenos Aires", label: "University of Buenos Aires" },
  {
    value: "University of California, Riverside",
    label: "University of California, Riverside",
  },
  { value: "University of Cape Town", label: "University of Cape Town" },
  { value: "University of Cincinnati", label: "University of Cincinnati" },
  {
    value: "University of Colorado at Denver",
    label: "University of Colorado at Denver",
  },
  { value: "University of Connecticut", label: "University of Connecticut" },
  { value: "University of Delaware", label: "University of Delaware" },
  { value: "University of East Anglia", label: "University of East Anglia" },
  {
    value: "University of Erlangen-Nuremberg",
    label: "University of Erlangen-Nuremberg",
  },
  { value: "University of Granada", label: "University of Granada" },
  { value: "University of Hamburg", label: "University of Hamburg" },
  { value: "University of Houston", label: "University of Houston" },
  {
    value: "University of Illinois at Chicago",
    label: "University of Illinois at Chicago",
  },
  { value: "University of Innsbruck", label: "University of Innsbruck" },
  { value: "University of Iowa", label: "University of Iowa" },
  { value: "University of Kansas", label: "University of Kansas" },
  { value: "University of Kiel", label: "University of Kiel" },
  { value: "University of Leipzig", label: "University of Leipzig" },
  { value: "University of Liege", label: "University of Liege" },
  { value: "University of Lorraine", label: "University of Lorraine" },
  { value: "University of Mainz", label: "University of Mainz" },
  {
    value: "University of Maryland, Baltimore",
    label: "University of Maryland, Baltimore",
  },
  { value: "University of Miami", label: "University of Miami" },
  {
    value: "University of Nebraska - Lincoln",
    label: "University of Nebraska - Lincoln",
  },
  { value: "University of Padua", label: "University of Padua" },
  {
    value: "University of Science and Technology Beijing",
    label: "University of Science and Technology Beijing",
  },
  {
    value: "University of South Florida",
    label: "University of South Florida",
  },
  { value: "University of Tasmania", label: "University of Tasmania" },
  {
    value: "University of Technology Sydney",
    label: "University of Technology Sydney",
  },
  {
    value: "University of Tennessee - Knoxville",
    label: "University of Tennessee - Knoxville",
  },
  {
    value: "University of the Witwatersrand",
    label: "University of the Witwatersrand",
  },
  { value: "University of Tsukuba", label: "University of Tsukuba" },
  { value: "University of Turin", label: "University of Turin" },
  { value: "University of Valencia", label: "University of Valencia" },
  { value: "University of Wollongong", label: "University of Wollongong" },
  { value: "University of Wuerzburg", label: "University of Wuerzburg" },
  { value: "University of York", label: "University of York" },
  {
    value: "Virginia Commonwealth University",
    label: "Virginia Commonwealth University",
  },
  {
    value: "Virginia Polytechnic Institute and State University",
    label: "Virginia Polytechnic Institute and State University",
  },
  { value: "Western University", label: "Western University" },
  { value: "Xiamen University", label: "Xiamen University" },
  { value: "Yeshiva University", label: "Yeshiva University" },
  { value: "Yonsei University", label: "Yonsei University" },
  { value: "Aalborg University", label: "Aalborg University" },
  {
    value: "Autonomous University of Madrid",
    label: "Autonomous University of Madrid",
  },
  {
    value: "Beijing University of Chemical Technology",
    label: "Beijing University of Chemical Technology",
  },
  { value: "Brandeis University", label: "Brandeis University" },
  { value: "Capital Medical University", label: "Capital Medical University" },
  {
    value: "Chalmers University of Technology",
    label: "Chalmers University of Technology",
  },
  {
    value: "China Agricultural University",
    label: "China Agricultural University",
  },
  {
    value: "China University of Geosciences (Wuhan)",
    label: "China University of Geosciences (Wuhan)",
  },
  { value: "Chongqing University", label: "Chongqing University" },
  { value: "Drexel University", label: "Drexel University" },
  {
    value: "East China University of Science and Technology",
    label: "East China University of Science and Technology",
  },
  {
    value: "Ecole Normale Superieure - Lyon",
    label: "Ecole Normale Superieure - Lyon",
  },
  { value: "Griffith University", label: "Griffith University" },
  {
    value: "Heinrich Heine University Duesseldorf",
    label: "Heinrich Heine University Duesseldorf",
  },
  {
    value: "Huazhong Agricultural University",
    label: "Huazhong Agricultural University",
  },
  {
    value: "Indiana University-Purdue University at Indianapolis",
    label: "Indiana University-Purdue University at Indianapolis",
  },
  {
    value: "Institut Polytechnique de Paris",
    label: "Institut Polytechnique de Paris",
  },
  { value: "James Cook University", label: "James Cook University" },
  { value: "Jiangsu University", label: "Jiangsu University" },
  { value: "Keio University", label: "Keio University" },
  { value: "Kyung Hee University", label: "Kyung Hee University" },
  {
    value: "Kyungpook National University",
    label: "Kyungpook National University",
  },
  { value: "Kyushu University", label: "Kyushu University" },
  { value: "La Trobe University", label: "La Trobe University" },
  { value: "Lancaster University", label: "Lancaster University" },
  { value: "Laval University", label: "Laval University" },
  { value: "Linkoping University", label: "Linkoping University" },
  {
    value: "Louisiana State University - Baton Rouge",
    label: "Louisiana State University - Baton Rouge",
  },
  {
    value: "Medical University of South Carolina",
    label: "Medical University of South Carolina",
  },
  {
    value: "Nanjing Agricultural University",
    label: "Nanjing Agricultural University",
  },
  {
    value: "Nanjing University of Aeronautics and Astronautics",
    label: "Nanjing University of Aeronautics and Astronautics",
  },
  {
    value: "Nanjing University of Science and Technology",
    label: "Nanjing University of Science and Technology",
  },
  {
    value: "National and Kapodistrian University of Athens",
    label: "National and Kapodistrian University of Athens",
  },
  {
    value: "National Cheng Kung University",
    label: "National Cheng Kung University",
  },
  {
    value: "Northeastern University (Shenyang)",
    label: "Northeastern University (Shenyang)",
  },
  {
    value: "Peking Union Medical College",
    label: "Peking Union Medical College",
  },
  {
    value: "Pohang University of Science and Technology",
    label: "Pohang University of Science and Technology",
  },
  {
    value: "Polytechnic University of Valencia",
    label: "Polytechnic University of Valencia",
  },
  { value: "Pompeu Fabra University", label: "Pompeu Fabra University" },
  {
    value: "Queensland University of Technology",
    label: "Queensland University of Technology",
  },
  { value: "RMIT University", label: "RMIT University" },
  {
    value: "Saint Petersburg State University",
    label: "Saint Petersburg State University",
  },
  { value: "Shanghai University", label: "Shanghai University" },
  { value: "Simon Fraser University", label: "Simon Fraser University" },
  {
    value: "Southern University of Science and Technology",
    label: "Southern University of Science and Technology",
  },
  {
    value: "Swedish University of Agricultural Sciences",
    label: "Swedish University of Agricultural Sciences",
  },
  {
    value: "Technical University of Berlin",
    label: "Technical University of Berlin",
  },
  { value: "Temple University", label: "Temple University" },
  {
    value: "The George Washington University",
    label: "The George Washington University",
  },
  {
    value: "The Hong Kong University of Science and Technology",
    label: "The Hong Kong University of Science and Technology",
  },
  { value: "The University of Dundee", label: "The University of Dundee" },
  {
    value: "The University of New Mexico - Albuquerque",
    label: "The University of New Mexico - Albuquerque",
  },
  {
    value: "The University of Newcastle, Australia",
    label: "The University of Newcastle, Australia",
  },
  {
    value: "The University of Texas at Dallas",
    label: "The University of Texas at Dallas",
  },
  {
    value: "The University of Texas Health Science Center at Houston",
    label: "The University of Texas Health Science Center at Houston",
  },
  { value: "UNESP", label: "UNESP" },
  {
    value: "University at Buffalo, the State University of New York",
    label: "University at Buffalo, the State University of New York",
  },
  { value: "University College Dublin", label: "University College Dublin" },
  {
    value: "University of Alabama at Birmingham",
    label: "University of Alabama at Birmingham",
  },
  { value: "University of Antwerp", label: "University of Antwerp" },
  { value: "University of Bath", label: "University of Bath" },
  { value: "University of Bergen", label: "University of Bergen" },
  { value: "University of Campinas", label: "University of Campinas" },
  {
    value: "University of Central Florida",
    label: "University of Central Florida",
  },
  { value: "University of Côte d'Azur", label: "University of Côte d'Azur" },
  {
    value: "University of Duisburg-Essen",
    label: "University of Duisburg-Essen",
  },
  { value: "University of Florence", label: "University of Florence" },
  { value: "University of Guelph", label: "University of Guelph" },
  {
    value: "University of Hawaii at Manoa",
    label: "University of Hawaii at Manoa",
  },
  { value: "University of Kentucky", label: "University of Kentucky" },
  { value: "University of Leicester", label: "University of Leicester" },
  { value: "University of Malaya", label: "University of Malaya" },
  { value: "University of Manitoba", label: "University of Manitoba" },
  {
    value: "University of Milano-Bicocca",
    label: "University of Milano-Bicocca",
  },
  {
    value: "University of Naples Federico II",
    label: "University of Naples Federico II",
  },
  {
    value: "University of Natural Resources and Life Sciences, Vienna",
    label: "University of Natural Resources and Life Sciences, Vienna",
  },
  { value: "University of Notre Dame", label: "University of Notre Dame" },
  { value: "University of Oregon", label: "University of Oregon" },
  { value: "University of Otago", label: "University of Otago" },
  { value: "University of Porto", label: "University of Porto" },
  { value: "University of Saskatchewan", label: "University of Saskatchewan" },
  {
    value: "University of South Carolina - Columbia",
    label: "University of South Carolina - Columbia",
  },
  {
    value: "University of Southern Denmark",
    label: "University of Southern Denmark",
  },
  { value: "University of St Andrews", label: "University of St Andrews" },
  { value: "University of Stuttgart", label: "University of Stuttgart" },
  { value: "University of Surrey", label: "University of Surrey" },
  { value: "University of Tehran", label: "University of Tehran" },
  {
    value: "University of the Basque Country",
    label: "University of the Basque Country",
  },
  { value: "University of Toulouse 1", label: "University of Toulouse 1" },
  { value: "University of Turku", label: "University of Turku" },
  { value: "University of Ulm", label: "University of Ulm" },
  { value: "University of Vermont", label: "University of Vermont" },
  { value: "University of Victoria", label: "University of Victoria" },
  { value: "University of Warsaw", label: "University of Warsaw" },
  {
    value: "Vienna University of Technology",
    label: "Vienna University of Technology",
  },
  {
    value: "Vrije Universiteit Brussel (VUB)",
    label: "Vrije Universiteit Brussel (VUB)",
  },
  {
    value: "Washington State University",
    label: "Washington State University",
  },
  { value: "Western Sydney University", label: "Western Sydney University" },
  {
    value: "Wuhan University of Technology",
    label: "Wuhan University of Technology",
  },
  { value: "Zhengzhou University", label: "Zhengzhou University" },
  { value: "Aalto University", label: "Aalto University" },
  { value: "Bar-Ilan University", label: "Bar-Ilan University" },
  {
    value: "Beijing Jiaotong University",
    label: "Beijing Jiaotong University",
  },
  {
    value: "Beijing University of Technology",
    label: "Beijing University of Technology",
  },
  {
    value: "Ben-Gurion University of the Negev",
    label: "Ben-Gurion University of the Negev",
  },
  { value: "Brigham Young University", label: "Brigham Young University" },
  { value: "Cairo University", label: "Cairo University" },
  { value: "Chiba University", label: "Chiba University" },
  {
    value: "China University of Geosciences (Beijing)",
    label: "China University of Geosciences (Beijing)",
  },
  {
    value: "China University of Mining and Technology - Xuzhou",
    label: "China University of Mining and Technology - Xuzhou",
  },
  {
    value: "CUNY Graduate School and University Center",
    label: "CUNY Graduate School and University Center",
  },
  {
    value: "East China Normal University",
    label: "East China Normal University",
  },
  {
    value: "Eindhoven University of Technology",
    label: "Eindhoven University of Technology",
  },
  {
    value: "Federal University of Minas Gerais",
    label: "Federal University of Minas Gerais",
  },
  {
    value: "Federal University of Rio de Janeiro",
    label: "Federal University of Rio de Janeiro",
  },
  {
    value: "Federal University of Rio Grande do Sul",
    label: "Federal University of Rio Grande do Sul",
  },
  { value: "Flinders University", label: "Flinders University" },
  {
    value: "Florida International University",
    label: "Florida International University",
  },
  { value: "Fuzhou University", label: "Fuzhou University" },
  { value: "Georgia State University", label: "Georgia State University" },
  {
    value: "Guangdong University of Technology",
    label: "Guangdong University of Technology",
  },
  { value: "Hannover Medical School", label: "Hannover Medical School" },
  {
    value: "Harbin Engineering University",
    label: "Harbin Engineering University",
  },
  {
    value: "Hefei University of Technology",
    label: "Hefei University of Technology",
  },
  { value: "Istanbul University", label: "Istanbul University" },
  { value: "Jagiellonian University", label: "Jagiellonian University" },
  { value: "Jinan University", label: "Jinan University" },
  { value: "Kansas State University", label: "Kansas State University" },
  {
    value: "King Fahd University of Petroleum & Minerals",
    label: "King Fahd University of Petroleum & Minerals",
  },
  { value: "Kobe University", label: "Kobe University" },
  { value: "Lanzhou University", label: "Lanzhou University" },
  { value: "Mahidol University", label: "Mahidol University" },
  { value: "Medical University of Graz", label: "Medical University of Graz" },
  {
    value: "Moscow Institute of Physics and Technology",
    label: "Moscow Institute of Physics and Technology",
  },
  { value: "Nanchang University", label: "Nanchang University" },
  { value: "Nanjing Medical University", label: "Nanjing Medical University" },
  { value: "NanJing Tech University", label: "NanJing Tech University" },
  {
    value: "Nanjing University of Information Science & Technology",
    label: "Nanjing University of Information Science & Technology",
  },
  {
    value: "National Chiao Tung University",
    label: "National Chiao Tung University",
  },
  {
    value: "National Tsing Hua University",
    label: "National Tsing Hua University",
  },
  { value: "Ocean University of China", label: "Ocean University of China" },
  { value: "Okayama University", label: "Okayama University" },
  { value: "Pusan National University", label: "Pusan National University" },
  { value: "Qingdao University", label: "Qingdao University" },
  { value: "Queen's University Belfast", label: "Queen's University Belfast" },
  {
    value: "Rensselaer Polytechnic Institute",
    label: "Rensselaer Polytechnic Institute",
  },
  { value: "Saint Louis University", label: "Saint Louis University" },
  { value: "San Diego State University", label: "San Diego State University" },
  {
    value: "Scuola Normale Superiore - Pisa",
    label: "Scuola Normale Superiore - Pisa",
  },
  {
    value: "Shandong University of Science and Technology",
    label: "Shandong University of Science and Technology",
  },
  { value: "ShanghaiTech University", label: "ShanghaiTech University" },
  {
    value: "South China Agricultural University",
    label: "South China Agricultural University",
  },
  { value: "Southwest University", label: "Southwest University" },
  { value: "Stellenbosch University", label: "Stellenbosch University" },
  {
    value: "Stockholm School of Economics",
    label: "Stockholm School of Economics",
  },
  {
    value: "Technical University Darmstadt",
    label: "Technical University Darmstadt",
  },
  { value: "Texas Tech University", label: "Texas Tech University" },
  {
    value: "The City College of New York",
    label: "The City College of New York",
  },
  {
    value: "The University of Texas Health Science Center at San Antonio",
    label: "The University of Texas Health Science Center at San Antonio",
  },
  {
    value: "The University of Texas Medical Branch at Galveston",
    label: "The University of Texas Medical Branch at Galveston",
  },
  {
    value: "Tokyo University of Science",
    label: "Tokyo University of Science",
  },
  {
    value: "Ulsan National Institute of Science and Technology",
    label: "Ulsan National Institute of Science and Technology",
  },
  { value: "Umea University", label: "Umea University" },
  { value: "University College Cork", label: "University College Cork" },
  { value: "University of Bari", label: "University of Bari" },
  { value: "University of Belgrade", label: "University of Belgrade" },
  { value: "University of Bochum", label: "University of Bochum" },
  {
    value: "University of California-Merced",
    label: "University of California-Merced",
  },
  { value: "University of Canterbury", label: "University of Canterbury" },
  { value: "University of Catania", label: "University of Catania" },
  { value: "University of Chile", label: "University of Chile" },
  { value: "University of Fribourg", label: "University of Fribourg" },
  { value: "University of Graz", label: "University of Graz" },
  { value: "University of Jena", label: "University of Jena" },
  { value: "University of Lille", label: "University of Lille" },
  { value: "University of Maine", label: "University of Maine" },
  { value: "University of Marburg", label: "University of Marburg" },
  { value: "University of Minho", label: "University of Minho" },
  { value: "University of North Texas", label: "University of North Texas" },
  {
    value: "University of Oklahoma - Norman",
    label: "University of Oklahoma - Norman",
  },
  { value: "University of Oviedo", label: "University of Oviedo" },
  { value: "University of Pavia", label: "University of Pavia" },
  { value: "University of Perugia", label: "University of Perugia" },
  { value: "University of Potsdam", label: "University of Potsdam" },
  { value: "University of Pretoria", label: "University of Pretoria" },
  {
    value: "University of Santiago Compostela",
    label: "University of Santiago Compostela",
  },
  { value: "University of Seville", label: "University of Seville" },
  { value: "University of Strathclyde", label: "University of Strathclyde" },
  { value: "University of Tartu", label: "University of Tartu" },
  { value: "University of Trento", label: "University of Trento" },
  { value: "University of Twente", label: "University of Twente" },
  { value: "University of Zagreb", label: "University of Zagreb" },
  { value: "University of Zaragoza", label: "University of Zaragoza" },
  { value: "Utah State University", label: "Utah State University" },
  {
    value: "Victoria University of Wellington",
    label: "Victoria University of Wellington",
  },
  {
    value: "Vita-Salute San Raffaele University",
    label: "Vita-Salute San Raffaele University",
  },
  { value: "Wake Forest University", label: "Wake Forest University" },
  { value: "West Virginia University", label: "West Virginia University" },
  { value: "Xidian University", label: "Xidian University" },
  { value: "York University", label: "York University" },
  {
    value: "Amirkabir University of Technology",
    label: "Amirkabir University of Technology",
  },
  {
    value: "Aristotle University of Thessaloniki",
    label: "Aristotle University of Thessaloniki",
  },
  { value: "Auburn University", label: "Auburn University" },
  {
    value: "Australian Catholic University",
    label: "Australian Catholic University",
  },
  { value: "Baylor University", label: "Baylor University" },
  { value: "Binghamton University", label: "Binghamton University" },
  { value: "Bocconi University", label: "Bocconi University" },
  { value: "Boston College", label: "Boston College" },
  { value: "Brunel University", label: "Brunel University" },
  { value: "Carleton University", label: "Carleton University" },
  {
    value: "Central China Normal University",
    label: "Central China Normal University",
  },
  { value: "Chang Gung University", label: "Chang Gung University" },
  {
    value: "China University of Petroleum (Huadong)",
    label: "China University of Petroleum (Huadong)",
  },
  {
    value: "Chonbuk National University",
    label: "Chonbuk National University",
  },
  {
    value: "Chonnam National University",
    label: "Chonnam National University",
  },
  { value: "Clemson University", label: "Clemson University" },
  {
    value: "COMSATS University Islamabad",
    label: "COMSATS University Islamabad",
  },
  { value: "Donghua University", label: "Donghua University" },
  { value: "Ewha Womans University", label: "Ewha Womans University" },
  { value: "Hiroshima University", label: "Hiroshima University" },
  {
    value: "Indian Institute of Science",
    label: "Indian Institute of Science",
  },
  { value: "Jiangnan University", label: "Jiangnan University" },
  { value: "Kent State University", label: "Kent State University" },
  { value: "Kitasato University", label: "Kitasato University" },
  { value: "Loughborough University", label: "Loughborough University" },
  { value: "Loyola University Chicago", label: "Loyola University Chicago" },
  {
    value: "Macau University of Science and Technology",
    label: "Macau University of Science and Technology",
  },
  {
    value: "Medical University of Innsbruck",
    label: "Medical University of Innsbruck",
  },
  {
    value: "Mississippi State University",
    label: "Mississippi State University",
  },
  { value: "Nanjing Normal University", label: "Nanjing Normal University" },
  {
    value: "National Polytechnic Institute",
    label: "National Polytechnic Institute",
  },
  {
    value: "National University of Defense Technology",
    label: "National University of Defense Technology",
  },
  {
    value: "National University of Malaysia",
    label: "National University of Malaysia",
  },
  {
    value: "National Yang Ming University",
    label: "National Yang Ming University",
  },
  {
    value: "North China Electric Power University",
    label: "North China Electric Power University",
  },
  {
    value: "Northern Arizona University",
    label: "Northern Arizona University",
  },
  { value: "Northwest A&F University", label: "Northwest A&F University" },
  {
    value: "Novosibirsk State University",
    label: "Novosibirsk State University",
  },
  { value: "Oklahoma State University", label: "Oklahoma State University" },
  { value: "Palacký University Olomouc", label: "Palacký University Olomouc" },
  {
    value: "Polytechnic University of Madrid",
    label: "Polytechnic University of Madrid",
  },
  {
    value: "Pontifical Catholic University of Chile",
    label: "Pontifical Catholic University of Chile",
  },
  { value: "Rush University", label: "Rush University" },
  { value: "Saarland University", label: "Saarland University" },
  { value: "Sejong University", label: "Sejong University" },
  {
    value: "Sharif University of Technology",
    label: "Sharif University of Technology",
  },
  {
    value: "South China Normal University",
    label: "South China Normal University",
  },
  {
    value: "Southern Medical University",
    label: "Southern Medical University",
  },
  {
    value: "Southern Methodist University",
    label: "Southern Methodist University",
  },
  {
    value: "St George's, University of London",
    label: "St George's, University of London",
  },
  { value: "Tarbiat Modares University", label: "Tarbiat Modares University" },
  {
    value: "Tehran University of Medical Sciences",
    label: "Tehran University of Medical Sciences",
  },
  {
    value: "The University of Alabama - Tuscaloosa",
    label: "The University of Alabama - Tuscaloosa",
  },
  {
    value: "The University of Tokushima",
    label: "The University of Tokushima",
  },
  {
    value: "Thomas Jefferson University",
    label: "Thomas Jefferson University",
  },
  {
    value: "University at Albany (State University of New York)",
    label: "University at Albany (State University of New York)",
  },
  { value: "University of Auvergne", label: "University of Auvergne" },
  { value: "University of Aveiro", label: "University of Aveiro" },
  { value: "University of Bremen", label: "University of Bremen" },
  { value: "University of Burgundy", label: "University of Burgundy" },
  { value: "University of Coimbra", label: "University of Coimbra" },
  {
    value: "University of Eastern Finland",
    label: "University of Eastern Finland",
  },
  { value: "University of Essex", label: "University of Essex" },
  { value: "University of Ferrara", label: "University of Ferrara" },
  { value: "University of Genoa", label: "University of Genoa" },
  {
    value: "University of Halle-Wittenberg",
    label: "University of Halle-Wittenberg",
  },
  { value: "University of Iceland", label: "University of Iceland" },
  { value: "University of Idaho", label: "University of Idaho" },
  { value: "University of Kent", label: "University of Kent" },
  {
    value: "University of KwaZulu-Natal",
    label: "University of KwaZulu-Natal",
  },
  { value: "University of Ljubljana", label: "University of Ljubljana" },
  { value: "University of Navarra", label: "University of Navarra" },
  {
    value: "University of Nevada - Reno",
    label: "University of Nevada - Reno",
  },
  {
    value: "University of Nevada-Las Vegas",
    label: "University of Nevada-Las Vegas",
  },
  { value: "University of New England", label: "University of New England" },
  {
    value: "University of New Hampshire",
    label: "University of New Hampshire",
  },
  { value: "University of Oulu", label: "University of Oulu" },
  { value: "University of Palermo", label: "University of Palermo" },
  { value: "University of Parma", label: "University of Parma" },
  { value: "University of Plymouth", label: "University of Plymouth" },
  { value: "University of Portsmouth", label: "University of Portsmouth" },
  { value: "University of Regensburg", label: "University of Regensburg" },
  { value: "University of Rennes 1", label: "University of Rennes 1" },
  {
    value: "University of Roma - Tor Vergata",
    label: "University of Roma - Tor Vergata",
  },
  { value: "University of Rostock", label: "University of Rostock" },
  {
    value: "University of Science, Malaysia",
    label: "University of Science, Malaysia",
  },
  {
    value: "University of South Australia",
    label: "University of South Australia",
  },
  { value: "University of Tampere", label: "University of Tampere" },
  {
    value: "University of the Balearic Islands",
    label: "University of the Balearic Islands",
  },
  { value: "University of Tromso", label: "University of Tromso" },
  { value: "University of Ulsan", label: "University of Ulsan" },
  { value: "University of Verona", label: "University of Verona" },
  { value: "University of Vigo", label: "University of Vigo" },
  { value: "University of Wyoming", label: "University of Wyoming" },
  {
    value: "University Rovira i Virgili",
    label: "University Rovira i Virgili",
  },
  { value: "Wayne State University", label: "Wayne State University" },
  { value: "Wenzhou Medical University", label: "Wenzhou Medical University" },
  { value: "Yangzhou University", label: "Yangzhou University" },
  { value: "Yeungnam University", label: "Yeungnam University" },
  {
    value: "Zhejiang University of Technology",
    label: "Zhejiang University of Technology",
  },
  {
    value: "American University of Beirut",
    label: "American University of Beirut",
  },
  {
    value: "Beijing University of Posts and Telecommunications",
    label: "Beijing University of Posts and Telecommunications",
  },
  {
    value: "Catholic University of the Sacred Heart",
    label: "Catholic University of the Sacred Heart",
  },
  {
    value: "China Medical University (Shenyang)",
    label: "China Medical University (Shenyang)",
  },
  { value: "Chung-Ang University", label: "Chung-Ang University" },
  {
    value: "Chungbuk National University",
    label: "Chungbuk National University",
  },
  { value: "Colorado School of Mines", label: "Colorado School of Mines" },
  {
    value: "Comenius University in Bratislava",
    label: "Comenius University in Bratislava",
  },
  { value: "Concordia University", label: "Concordia University" },
  { value: "CUNY Hunter College", label: "CUNY Hunter College" },
  { value: "Edith Cowan University", label: "Edith Cowan University" },
  { value: "Eotvos Lorand University", label: "Eotvos Lorand University" },
  {
    value: "Federal University of Parana",
    label: "Federal University of Parana",
  },
  {
    value: "Federal University of Sao Paulo",
    label: "Federal University of Sao Paulo",
  },
  {
    value: "Fujian Agriculture and Forestry University",
    label: "Fujian Agriculture and Forestry University",
  },
  { value: "Fujian Normal University", label: "Fujian Normal University" },
  {
    value: "Graz University of Technology",
    label: "Graz University of Technology",
  },
  {
    value: "Guangzhou Medical University",
    label: "Guangzhou Medical University",
  },
  { value: "Guangzhou University", label: "Guangzhou University" },
  { value: "Hacettepe University", label: "Hacettepe University" },
  { value: "Hasselt University", label: "Hasselt University" },
  { value: "Hohai University", label: "Hohai University" },
  { value: "Humanitas University", label: "Humanitas University" },
  { value: "Hunan Normal University", label: "Hunan Normal University" },
  {
    value: "Indian Institute of Technology Madras",
    label: "Indian Institute of Technology Madras",
  },
  { value: "INHA University", label: "INHA University" },
  {
    value: "Istanbul Technical University",
    label: "Istanbul Technical University",
  },
  { value: "Keele University", label: "Keele University" },
  {
    value: "Leibniz University Hannover",
    label: "Leibniz University Hannover",
  },
  { value: "Masaryk University", label: "Masaryk University" },
  { value: "Massey University", label: "Massey University" },
  {
    value: "Medical College of Wisconsin",
    label: "Medical College of Wisconsin",
  },
  {
    value: "Memorial University of Newfoundland",
    label: "Memorial University of Newfoundland",
  },
  {
    value: "Miguel Hernandez University of Elche",
    label: "Miguel Hernandez University of Elche",
  },
  {
    value: "Missouri University of Science and Technology",
    label: "Missouri University of Science and Technology",
  },
  { value: "Murdoch University", label: "Murdoch University" },
  {
    value: "National Sun Yat-Sen University",
    label: "National Sun Yat-Sen University",
  },
  {
    value: "National Technical University of Athens",
    label: "National Technical University of Athens",
  },
  {
    value: "National University of Ireland, Galway",
    label: "National University of Ireland, Galway",
  },
  { value: "New University of Lisbon", label: "New University of Lisbon" },
  {
    value: "Northeast Normal University",
    label: "Northeast Normal University",
  },
  { value: "Northwest University", label: "Northwest University" },
  { value: "North-West University", label: "North-West University" },
  {
    value: "Norwegian University of Life Sciences",
    label: "Norwegian University of Life Sciences",
  },
  { value: "Ohio University", label: "Ohio University" },
  { value: "Orebro University", label: "Orebro University" },
  {
    value: "Polytechnic University of Turin",
    label: "Polytechnic University of Turin",
  },
  { value: "Qatar University", label: "Qatar University" },
  { value: "Renmin University of China", label: "Renmin University of China" },
  { value: "Shaanxi Normal University", label: "Shaanxi Normal University" },
  { value: "Shanxi University", label: "Shanxi University" },
  {
    value: "Southwest Jiaotong University",
    label: "Southwest Jiaotong University",
  },
  {
    value: "State University of New York Health Science Center at Brooklyn",
    label: "State University of New York Health Science Center at Brooklyn",
  },
  { value: "Swansea University", label: "Swansea University" },
  { value: "Swarthmore College", label: "Swarthmore College" },
  { value: "Syracuse University", label: "Syracuse University" },
  { value: "Taipei Medical University", label: "Taipei Medical University" },
  {
    value: "Technical University of Braunschweig",
    label: "Technical University of Braunschweig",
  },
  {
    value: "The University of Texas at Arlington",
    label: "The University of Texas at Arlington",
  },
  {
    value: "The University of Texas at San Antonio",
    label: "The University of Texas at San Antonio",
  },
  { value: "Tianjin Medical University", label: "Tianjin Medical University" },
  { value: "Tilburg University", label: "Tilburg University" },
  {
    value: "Tokyo Medical and Dental University",
    label: "Tokyo Medical and Dental University",
  },
  { value: "Tulane University", label: "Tulane University" },
  { value: "Universitat Jaume I", label: "Universitat Jaume I" },
  {
    value: "Universiti Teknologi Malaysia",
    label: "Universiti Teknologi Malaysia",
  },
  {
    value: "University of Alaska - Fairbanks",
    label: "University of Alaska - Fairbanks",
  },
  { value: "University of Alicante", label: "University of Alicante" },
  {
    value: "University of Arkansas at Fayetteville",
    label: "University of Arkansas at Fayetteville",
  },
  { value: "University of Calcutta", label: "University of Calcutta" },
  { value: "University of Canberra", label: "University of Canberra" },
  { value: "University of Cyprus", label: "University of Cyprus" },
  { value: "University of Delhi", label: "University of Delhi" },
  { value: "University of Haifa", label: "University of Haifa" },
  { value: "University of Jinan", label: "University of Jinan" },
  { value: "University of Johannesburg", label: "University of Johannesburg" },
  { value: "University of Konstanz", label: "University of Konstanz" },
  { value: "University of La Laguna", label: "University of La Laguna" },
  { value: "University of Louisville", label: "University of Louisville" },
  { value: "University of Luxembourg", label: "University of Luxembourg" },
  { value: "University of Macau", label: "University of Macau" },
  { value: "University of Magdeburg", label: "University of Magdeburg" },
  {
    value: "University of Maryland, Baltimore County",
    label: "University of Maryland, Baltimore County",
  },
  {
    value: "University of Montana - Missoula",
    label: "University of Montana - Missoula",
  },
  { value: "University of Nantes", label: "University of Nantes" },
  {
    value: "University of Nebraska Medical Center",
    label: "University of Nebraska Medical Center",
  },
  {
    value: "University of Quebec Montreal",
    label: "University of Quebec Montreal",
  },
  { value: "University of Salerno", label: "University of Salerno" },
  {
    value: "University of Shanghai for Science and Technology",
    label: "University of Shanghai for Science and Technology",
  },
  { value: "University of Sherbrooke", label: "University of Sherbrooke" },
  { value: "University of Siena", label: "University of Siena" },
  { value: "University of Szeged", label: "University of Szeged" },
  {
    value: "University of Tennessee Health Science Center",
    label: "University of Tennessee Health Science Center",
  },
  {
    value: "University of Texas at El Paso",
    label: "University of Texas at El Paso",
  },
  { value: "University of Toledo", label: "University of Toledo" },
  { value: "University of Trieste", label: "University of Trieste" },
  {
    value: "University of Versailles Saint-Quentin-en-Yvelines",
    label: "University of Versailles Saint-Quentin-en-Yvelines",
  },
  {
    value: "University of Wisconsin-Milwaukee",
    label: "University of Wisconsin-Milwaukee",
  },
  { value: "Waseda University", label: "Waseda University" },
  {
    value: "Xi'an University of Technology",
    label: "Xi'an University of Technology",
  },
  {
    value: "AGH University of Science and Technology",
    label: "AGH University of Science and Technology",
  },
  {
    value: "Air Force Medical University",
    label: "Air Force Medical University",
  },
  { value: "Alexandria University", label: "Alexandria University" },
  { value: "Anhui Medical University", label: "Anhui Medical University" },
  { value: "Anhui University", label: "Anhui University" },
  { value: "Army Medical University", label: "Army Medical University" },
  { value: "Aston University", label: "Aston University" },
  { value: "Babeș-Bolyai University", label: "Babeș-Bolyai University" },
  { value: "Bangor University", label: "Bangor University" },
  {
    value: "Beijing Forestry University",
    label: "Beijing Forestry University",
  },
  { value: "Bielefeld University", label: "Bielefeld University" },
  { value: "Brescia University", label: "Brescia University" },
  {
    value: "Catholic University of Korea",
    label: "Catholic University of Korea",
  },
  {
    value: "China University of Petroleum - Beijing",
    label: "China University of Petroleum - Beijing",
  },
  {
    value: "Chongqing Medical University",
    label: "Chongqing Medical University",
  },
  { value: "Chulalongkorn University", label: "Chulalongkorn University" },
  {
    value: "Chungnam National University",
    label: "Chungnam National University",
  },
  { value: "City University London", label: "City University London" },
  {
    value: "Czech Technical University in Prague",
    label: "Czech Technical University in Prague",
  },
  { value: "Dokuz Eylul University", label: "Dokuz Eylul University" },
  { value: "Ege University", label: "Ege University" },
  {
    value: "Federal University of Santa Catarina",
    label: "Federal University of Santa Catarina",
  },
  {
    value: "Federal University of Sao Carlos",
    label: "Federal University of Sao Carlos",
  },
  {
    value: "Fluminense Federal University",
    label: "Fluminense Federal University",
  },
  { value: "Guizhou University", label: "Guizhou University" },
  { value: "Hangzhou Dianzi University", label: "Hangzhou Dianzi University" },
  { value: "Harbin Medical University", label: "Harbin Medical University" },
  { value: "Heriot-Watt University", label: "Heriot-Watt University" },
  {
    value: "Hong Kong Baptist University",
    label: "Hong Kong Baptist University",
  },
  {
    value: "Indian Institute of Technology Delhi",
    label: "Indian Institute of Technology Delhi",
  },
  {
    value: "Indian Institute of Technology Kharagpur",
    label: "Indian Institute of Technology Kharagpur",
  },
  {
    value: "International School for Advanced Studies",
    label: "International School for Advanced Studies",
  },
  {
    value: "Jawaharlal Nehru University",
    label: "Jawaharlal Nehru University",
  },
  { value: "Juntendo University", label: "Juntendo University" },
  { value: "Kanazawa University", label: "Kanazawa University" },
  {
    value: "Kangwon National University",
    label: "Kangwon National University",
  },
  {
    value: "Kaohsiung Medical University",
    label: "Kaohsiung Medical University",
  },
  { value: "Kindai University", label: "Kindai University" },
  { value: "Konkuk University", label: "Konkuk University" },
  {
    value: "Kunming University of Science and Technology",
    label: "Kunming University of Science and Technology",
  },
  { value: "Lehigh University", label: "Lehigh University" },
  {
    value: "Liverpool John Moores University",
    label: "Liverpool John Moores University",
  },
  {
    value: "Michigan Technological University",
    label: "Michigan Technological University",
  },
  {
    value: "Nanjing Forestry University",
    label: "Nanjing Forestry University",
  },
  {
    value: "Nanjing University of Posts and Telecommunications",
    label: "Nanjing University of Posts and Telecommunications",
  },
  {
    value: "National Central University",
    label: "National Central University",
  },
  {
    value:
      "National Research Nuclear University MEPhI (Moscow Engineering Physics Institute)",
    label:
      "National Research Nuclear University MEPhI (Moscow Engineering Physics Institute)",
  },
  {
    value: "National University of Colombia",
    label: "National University of Colombia",
  },
  {
    value: "National University of La Plata",
    label: "National University of La Plata",
  },
  { value: "Ningbo University", label: "Ningbo University" },
  {
    value: "Nottingham Trent University",
    label: "Nottingham Trent University",
  },
  { value: "Old Dominion University", label: "Old Dominion University" },
  { value: "Osaka City University", label: "Osaka City University" },
  {
    value: "Polytechnic University of Catalonia",
    label: "Polytechnic University of Catalonia",
  },
  {
    value: "Qingdao University of Science and Technology",
    label: "Qingdao University of Science and Technology",
  },
  { value: "Qufu Normal University", label: "Qufu Normal University" },
  {
    value: "Royal Holloway, University of London",
    label: "Royal Holloway, University of London",
  },
  {
    value: "School for Advanced Studies in the Social Sciences",
    label: "School for Advanced Studies in the Social Sciences",
  },
  {
    value: "Shahid Beheshti University of Medical Sciences",
    label: "Shahid Beheshti University of Medical Sciences",
  },
  { value: "Shinshu University", label: "Shinshu University" },
  { value: "Shiraz University", label: "Shiraz University" },
  {
    value: "SUNY Upstate Medical University",
    label: "SUNY Upstate Medical University",
  },
  {
    value: "Taiyuan University of Technology",
    label: "Taiyuan University of Technology",
  },
  { value: "The Open University", label: "The Open University" },
  {
    value: "The Second Military Medical University",
    label: "The Second Military Medical University",
  },
  { value: "The University of Waikato", label: "The University of Waikato" },
  { value: "Ton Duc Thang University", label: "Ton Duc Thang University" },
  {
    value: "Università Della Svizzera Italiana",
    label: "Università Della Svizzera Italiana",
  },
  { value: "Universitat de Lleida", label: "Universitat de Lleida" },
  { value: "Université Gustave Eiffel", label: "Université Gustave Eiffel" },
  {
    value: "University of Arkansas for Medical Sciences",
    label: "University of Arkansas for Medical Sciences",
  },
  { value: "University of Bayreuth", label: "University of Bayreuth" },
  { value: "University of Brasília", label: "University of Brasília" },
  {
    value: "University of Campania Luigi Vanvitelli",
    label: "University of Campania Luigi Vanvitelli",
  },
  { value: "University of Cordoba", label: "University of Cordoba" },
  {
    value: "University of Eastern Piedmont",
    label: "University of Eastern Piedmont",
  },
  { value: "University of Extremadura", label: "University of Extremadura" },
  { value: "University of Giessen", label: "University of Giessen" },
  { value: "University of Hohenheim", label: "University of Hohenheim" },
  { value: "University of Hull", label: "University of Hull" },
  { value: "University of Jaen", label: "University of Jaen" },
  { value: "University of Jyvaskyla", label: "University of Jyvaskyla" },
  { value: "University of Kassel", label: "University of Kassel" },
  { value: "University of L'Aquila", label: "University of L'Aquila" },
  { value: "University of Limerick", label: "University of Limerick" },
  { value: "University of Luebeck", label: "University of Luebeck" },
  { value: "University of Malaga", label: "University of Malaga" },
  {
    value: "University of Missouri-Kansas City",
    label: "University of Missouri-Kansas City",
  },
  {
    value: "University of Modena and Reggio Emilia",
    label: "University of Modena and Reggio Emilia",
  },
  { value: "University of Murcia", label: "University of Murcia" },
  { value: "University of Regina", label: "University of Regina" },
  { value: "University of Salamanca", label: "University of Salamanca" },
  { value: "University of Salento", label: "University of Salento" },
  { value: "University of Savoy", label: "University of Savoy" },
  { value: "University of Urbino", label: "University of Urbino" },
  {
    value: "University Paris Est Creteil (UPEC)",
    label: "University Paris Est Creteil (UPEC)",
  },
  { value: "University Putra Malaysia", label: "University Putra Malaysia" },
  { value: "Ural Federal University", label: "Ural Federal University" },
  { value: "Vilnius University", label: "Vilnius University" },
  {
    value: "WU Vienna University of Economics and Business",
    label: "WU Vienna University of Economics and Business",
  },
  { value: "Adam Mickiewicz University", label: "Adam Mickiewicz University" },
  { value: "Addis Ababa University", label: "Addis Ababa University" },
  { value: "Ain Shams University", label: "Ain Shams University" },
  { value: "Ajou University", label: "Ajou University" },
  { value: "Aligarh Muslim University", label: "Aligarh Muslim University" },
  { value: "Amherst College", label: "Amherst College" },
  { value: "Ankara University", label: "Ankara University" },
  { value: "Bilkent University", label: "Bilkent University" },
  { value: "Boise State University", label: "Boise State University" },
  {
    value: "Budapest University of Technology and Economics",
    label: "Budapest University of Technology and Economics",
  },
  { value: "Chang'an University", label: "Chang'an University" },
  {
    value: "China Pharmaceutical University",
    label: "China Pharmaceutical University",
  },
  {
    value: "China University of Mining and Technology - Beijing",
    label: "China University of Mining and Technology - Beijing",
  },
  { value: "Copenhagen Business School", label: "Copenhagen Business School" },
  {
    value: "Czech University of Life Sciences Prague",
    label: "Czech University of Life Sciences Prague",
  },
  { value: "Dongguk University", label: "Dongguk University" },
  { value: "Duke-NUS Medical School", label: "Duke-NUS Medical School" },
  { value: "Ehime University", label: "Ehime University" },
  {
    value: "Federal University of Goiás",
    label: "Federal University of Goiás",
  },
  {
    value: "Federal University of Pernambuco",
    label: "Federal University of Pernambuco",
  },
  {
    value: "Federal University of Rio Grande do Norte",
    label: "Federal University of Rio Grande do Norte",
  },
  {
    value: "Federal University of Viçosa",
    label: "Federal University of Viçosa",
  },
  {
    value: "Ferdowsi University of Mashhad",
    label: "Ferdowsi University of Mashhad",
  },
  {
    value: "Florida Atlantic University",
    label: "Florida Atlantic University",
  },
  { value: "Fujian Medical University", label: "Fujian Medical University" },
  { value: "Gachon University", label: "Gachon University" },
  {
    value: "Gdansk University of Technology",
    label: "Gdansk University of Technology",
  },
  { value: "Guangxi University", label: "Guangxi University" },
  {
    value: "Gwangju Institute of Science and Technology",
    label: "Gwangju Institute of Science and Technology",
  },
  {
    value: "Gyeongsang National University",
    label: "Gyeongsang National University",
  },
  { value: "Hallym University", label: "Hallym University" },
  { value: "Haverford College", label: "Haverford College" },
  { value: "Henan University", label: "Henan University" },
  { value: "HSE University", label: "HSE University" },
  { value: "Kumamoto University", label: "Kumamoto University" },
  { value: "Lincoln University", label: "Lincoln University" },
  { value: "Linnaeus University", label: "Linnaeus University" },
  {
    value: "Liverpool School of Tropical Medicine",
    label: "Liverpool School of Tropical Medicine",
  },
  { value: "London Business School", label: "London Business School" },
  {
    value: "Lulea University of Technology",
    label: "Lulea University of Technology",
  },
  { value: "Mansoura University", label: "Mansoura University" },
  {
    value: "Marche Polytechnic University",
    label: "Marche Polytechnic University",
  },
  { value: "Meijo University", label: "Meijo University" },
  {
    value: "Middle East Technical University",
    label: "Middle East Technical University",
  },
  {
    value: "Montana State University - Bozeman",
    label: "Montana State University - Bozeman",
  },
  { value: "Nagasaki University", label: "Nagasaki University" },
  { value: "Nantong University", label: "Nantong University" },
  {
    value: "National Taiwan University of Science and Technology",
    label: "National Taiwan University of Science and Technology",
  },
  {
    value: "National University of Cordoba",
    label: "National University of Cordoba",
  },
  { value: "Niigata University", label: "Niigata University" },
  { value: "Ontario Tech University", label: "Ontario Tech University" },
  { value: "Portland State University", label: "Portland State University" },
  {
    value: "Prince of Songkla University",
    label: "Prince of Songkla University",
  },
  { value: "Quaid-i-Azam University", label: "Quaid-i-Azam University" },
  { value: "Rutgers University-Newark", label: "Rutgers University-Newark" },
  { value: "Saitama University", label: "Saitama University" },
  { value: "Shandong Normal University", label: "Shandong Normal University" },
  {
    value: "Sichuan Agricultural University",
    label: "Sichuan Agricultural University",
  },
  {
    value: "South Dakota State University",
    label: "South Dakota State University",
  },
  {
    value: "Technical University of Dortmund",
    label: "Technical University of Dortmund",
  },
  {
    value: "The Education University of Hong Kong",
    label: "The Education University of Hong Kong",
  },
  {
    value: "The Graduate University for Advanced Studies",
    label: "The Graduate University for Advanced Studies",
  },
  {
    value: "The Royal Veterinary College",
    label: "The Royal Veterinary College",
  },
  { value: "Tomsk State University", label: "Tomsk State University" },
  { value: "Tuscia University", label: "Tuscia University" },
  {
    value: "Universidad de Las Palmas de Gran Canaria",
    label: "Universidad de Las Palmas de Gran Canaria",
  },
  {
    value: "Universidad Pablo de Olavide",
    label: "Universidad Pablo de Olavide",
  },
  {
    value: "Universidade Federal de Pelotas",
    label: "Universidade Federal de Pelotas",
  },
  { value: "University of Alcalá", label: "University of Alcalá" },
  { value: "University of Cagliari", label: "University of Cagliari" },
  { value: "University of Calabria", label: "University of Calabria" },
  { value: "University of Cantabria", label: "University of Cantabria" },
  {
    value: "University of Castilla–La Mancha",
    label: "University of Castilla–La Mancha",
  },
  {
    value: "University of Chieti-Pescara",
    label: "University of Chieti-Pescara",
  },
  { value: "University of Concepcion", label: "University of Concepcion" },
  { value: "University of Crete", label: "University of Crete" },
  { value: "University of Girona", label: "University of Girona" },
  { value: "University of Greenwich", label: "University of Greenwich" },
  {
    value: "University of Hertfordshire",
    label: "University of Hertfordshire",
  },
  { value: "University of Ioannina", label: "University of Ioannina" },
  { value: "University of Klagenfurt", label: "University of Klagenfurt" },
  { value: "University of Messina", label: "University of Messina" },
  { value: "University of Oldenburg", label: "University of Oldenburg" },
  { value: "University of Poitiers", label: "University of Poitiers" },
  { value: "University of Rhode Island", label: "University of Rhode Island" },
  { value: "University of South Africa", label: "University of South Africa" },
  {
    value: "University of Southern Queensland",
    label: "University of Southern Queensland",
  },
  { value: "University of Tabriz", label: "University of Tabriz" },
  { value: "University of the Punjab", label: "University of the Punjab" },
  {
    value: "University of the Sunshine Coast",
    label: "University of the Sunshine Coast",
  },
  { value: "University of Toyama", label: "University of Toyama" },
  { value: "University of Udine", label: "University of Udine" },
  { value: "University of Valladolid", label: "University of Valladolid" },
  {
    value: "University of Veterinary Medicine Vienna",
    label: "University of Veterinary Medicine Vienna",
  },
  { value: "University of Wuppertal", label: "University of Wuppertal" },
  {
    value: "Vellore Institute of Technology",
    label: "Vellore Institute of Technology",
  },
  {
    value: "Warsaw University of Technology",
    label: "Warsaw University of Technology",
  },
  { value: "Yokohama City University", label: "Yokohama City University" },
  { value: "Yunnan University", label: "Yunnan University" },
  { value: "Zhejiang Normal University", label: "Zhejiang Normal University" },
  { value: "Aberystwyth University", label: "Aberystwyth University" },
  {
    value: "All India Institute of Medical Sciences",
    label: "All India Institute of Medical Sciences",
  },
  { value: "Anna University", label: "Anna University" },
  { value: "Asia University, Taiwan", label: "Asia University, Taiwan" },
  { value: "Augusta University", label: "Augusta University" },
  { value: "AUT University", label: "AUT University" },
  { value: "Bharathiar University", label: "Bharathiar University" },
  {
    value: "Birkbeck, University of London",
    label: "Birkbeck, University of London",
  },
  { value: "Bond University", label: "Bond University" },
  {
    value: "Carlos III University of Madrid",
    label: "Carlos III University of Madrid",
  },
  { value: "Changzhou University", label: "Changzhou University" },
  { value: "Chiang Mai University", label: "Chiang Mai University" },
  {
    value: "City University New York - Baruch College",
    label: "City University New York - Baruch College",
  },
  {
    value: "College of William and Mary",
    label: "College of William and Mary",
  },
  { value: "Coventry University", label: "Coventry University" },
  { value: "Dalian Medical University", label: "Dalian Medical University" },
  { value: "East Carolina University", label: "East Carolina University" },
  { value: "Erciyes University", label: "Erciyes University" },
  {
    value: "Federal University of Bahia",
    label: "Federal University of Bahia",
  },
  {
    value: "Federal University of Ceara",
    label: "Federal University of Ceara",
  },
  {
    value: "Federal University of Santa Maria",
    label: "Federal University of Santa Maria",
  },
  { value: "Gazi University", label: "Gazi University" },
  { value: "Gifu University", label: "Gifu University" },
  { value: "Hebei Medical University", label: "Hebei Medical University" },
  {
    value: "Hebei University of Technology",
    label: "Hebei University of Technology",
  },
  { value: "Howard University", label: "Howard University" },
  { value: "Huaqiao University", label: "Huaqiao University" },
  {
    value: "Indian Institute of Technology Kanpur",
    label: "Indian Institute of Technology Kanpur",
  },
  {
    value: "Indian Institute of Technology Roorkee",
    label: "Indian Institute of Technology Roorkee",
  },
  {
    value: "Indian Institutes of Science Education and Research (IISERs)",
    label: "Indian Institutes of Science Education and Research (IISERs)",
  },
  { value: "Inje university", label: "Inje university" },
  {
    value: "Iran University of Science & Technology",
    label: "Iran University of Science & Technology",
  },
  {
    value: "Isfahan University of Technology",
    label: "Isfahan University of Technology",
  },
  { value: "ITMO University", label: "ITMO University" },
  {
    value: "Johannes Kepler University Linz",
    label: "Johannes Kepler University Linz",
  },
  {
    value: "Kazan (Volga region) Federal University",
    label: "Kazan (Volga region) Federal University",
  },
  {
    value: "King Juan Carlos University",
    label: "King Juan Carlos University",
  },
  { value: "Lakehead University", label: "Lakehead University" },
  {
    value: "Lappeenranta University of Technology",
    label: "Lappeenranta University of Technology",
  },
  {
    value: "Leuphana University Luneburg",
    label: "Leuphana University Luneburg",
  },
  {
    value: "Liaoning University of Technology",
    label: "Liaoning University of Technology",
  },
  { value: "Marmara University", label: "Marmara University" },
  {
    value: "Medical University of Silesia",
    label: "Medical University of Silesia",
  },
  {
    value: "Medical University of Warsaw",
    label: "Medical University of Warsaw",
  },
  {
    value: "Nanjing University of Chinese Medicine",
    label: "Nanjing University of Chinese Medicine",
  },
  {
    value: "Nara Institute of Science and Technology",
    label: "Nara Institute of Science and Technology",
  },
  {
    value: "National Chung Hsing University",
    label: "National Chung Hsing University",
  },
  {
    value: "National Taiwan Normal University",
    label: "National Taiwan Normal University",
  },
  {
    value: "New Jersey Institute of Technology",
    label: "New Jersey Institute of Technology",
  },
  { value: "Nihon University", label: "Nihon University" },
  {
    value: "Northeast Agricultural University - China",
    label: "Northeast Agricultural University - China",
  },
  { value: "Northumbria University", label: "Northumbria University" },
  { value: "Rhodes University", label: "Rhodes University" },
  {
    value: "Rio de Janeiro State University",
    label: "Rio de Janeiro State University",
  },
  { value: "Ritsumeikan University", label: "Ritsumeikan University" },
  { value: "Ryerson University", label: "Ryerson University" },
  { value: "Semmelweis University", label: "Semmelweis University" },
  { value: "Shanghai Normal University", label: "Shanghai Normal University" },
  { value: "Shantou University", label: "Shantou University" },
  { value: "Shizuoka University", label: "Shizuoka University" },
  {
    value: "Singapore University of Technology & Design",
    label: "Singapore University of Technology & Design",
  },
  { value: "Sogang University", label: "Sogang University" },
  { value: "Southern Cross University", label: "Southern Cross University" },
  {
    value: "Southwest Petroleum University",
    label: "Southwest Petroleum University",
  },
  {
    value: "Stevens Institute of Technology",
    label: "Stevens Institute of Technology",
  },
  {
    value: "The National University of Science and Technology MISiS",
    label: "The National University of Science and Technology MISiS",
  },
  { value: "The University of Akron", label: "The University of Akron" },
  {
    value: "Tokyo Metropolitan University",
    label: "Tokyo Metropolitan University",
  },
  { value: "Universidad Andrés Bello", label: "Universidad Andrés Bello" },
  { value: "Universidad de Cadiz", label: "Universidad de Cadiz" },
  {
    value: "Universidade Federal de Mato Grosso do Sul",
    label: "Universidade Federal de Mato Grosso do Sul",
  },
  {
    value: "Universite de Tunis El Manar",
    label: "Universite de Tunis El Manar",
  },
  { value: "University of Angers", label: "University of Angers" },
  {
    value: "University of Arkansas at Little Rock",
    label: "University of Arkansas at Little Rock",
  },
  {
    value: "University of Chemistry and Technology Prague",
    label: "University of Chemistry and Technology Prague",
  },
  { value: "University of Costa Rica", label: "University of Costa Rica" },
  { value: "University of Debrecen", label: "University of Debrecen" },
  { value: "University of Denver", label: "University of Denver" },
  {
    value: "University of Engineering and Technology (UET)",
    label: "University of Engineering and Technology (UET)",
  },
  { value: "University of Guilan", label: "University of Guilan" },
  { value: "University of Insubria", label: "University of Insubria" },
  { value: "University of Lincoln", label: "University of Lincoln" },
  {
    value: "University of Massachusetts Boston",
    label: "University of Massachusetts Boston",
  },
  {
    value: "University of Massachusetts Lowell",
    label: "University of Massachusetts Lowell",
  },
  {
    value: "University of North Carolina at Charlotte",
    label: "University of North Carolina at Charlotte",
  },
  {
    value: "University of North Carolina at Greensboro",
    label: "University of North Carolina at Greensboro",
  },
  { value: "University of Orleans", label: "University of Orleans" },
  { value: "University of Salzburg", label: "University of Salzburg" },
  {
    value: "University of South Bohemia",
    label: "University of South Bohemia",
  },
  { value: "University of Stirling", label: "University of Stirling" },
  {
    value: "University of the Republic - Uruguay",
    label: "University of the Republic - Uruguay",
  },
  { value: "University of Thessaly", label: "University of Thessaly" },
  { value: "University of Tours", label: "University of Tours" },
  { value: "University of Yamanashi", label: "University of Yamanashi" },
  { value: "Victoria University", label: "Victoria University" },
  { value: "Williams College", label: "Williams College" },
  {
    value: "Worcester Polytechnic Institute",
    label: "Worcester Polytechnic Institute",
  },
  { value: "Yanshan University", label: "Yanshan University" },
  { value: "Zagazig University", label: "Zagazig University" },
  {
    value: "Zhejiang Sci-Tech University",
    label: "Zhejiang Sci-Tech University",
  },

  { value: "ICBC", label: "ICBC" },
  { value: "China Construction Bank", label: "China Construction Bank" },
  { value: "JPMorgan Chase", label: "JPMorgan Chase" },
  { value: "Berkshire Hathaway", label: "Berkshire Hathaway" },
  { value: "Agricultural Bank of China", label: "Agricultural Bank of China" },
  {
    value: "Saudi Arabian Oil Company (Saudi Aramco)",
    label: "Saudi Arabian Oil Company (Saudi Aramco)",
  },
  { value: "Ping An Insurance Group", label: "Ping An Insurance Group" },
  { value: "Bank of America", label: "Bank of America" },
  { value: "Apple", label: "Apple" },
  { value: "Bank of China", label: "Bank of China" },
  { value: "AT&T", label: "AT&T" },
  { value: "Toyota Motor", label: "Toyota Motor" },
  { value: "Alphabet", label: "Alphabet" },
  { value: "ExxonMobil", label: "ExxonMobil" },
  { value: "Microsoft", label: "Microsoft" },
  { value: "Samsung Electronics", label: "Samsung Electronics" },
  { value: "Wells Fargo", label: "Wells Fargo" },
  { value: "Citigroup", label: "Citigroup" },
  { value: "Walmart", label: "Walmart" },
  { value: "Verizon Communications", label: "Verizon Communications" },
  { value: "Royal Dutch Shell", label: "Royal Dutch Shell" },
  { value: "Amazon", label: "Amazon" },
  { value: "Volkswagen Group", label: "Volkswagen Group" },
  { value: "UnitedHealth Group", label: "UnitedHealth Group" },
  { value: "Allianz", label: "Allianz" },
  { value: "China Merchants Bank", label: "China Merchants Bank" },
  { value: "Comcast", label: "Comcast" },
  { value: "China Mobile", label: "China Mobile" },
  { value: "Total", label: "Total" },
  {
    value: "Postal Savings Bank Of China (PSBC)",
    label: "Postal Savings Bank Of China (PSBC)",
  },
  { value: "Alibaba", label: "Alibaba" },
  { value: "Gazprom", label: "Gazprom" },
  { value: "PetroChina", label: "PetroChina" },
  { value: "Johnson & Johnson", label: "Johnson & Johnson" },
  { value: "RBC", label: "RBC" },
  { value: "Walt Disney", label: "Walt Disney" },
  { value: "China Life Insurance", label: "China Life Insurance" },
  { value: "Intel", label: "Intel" },
  { value: "Facebook", label: "Facebook" },
  { value: "CVS Health", label: "CVS Health" },
  { value: "Nestlé", label: "Nestlé" },
  { value: "BNP Paribas", label: "BNP Paribas" },
  { value: "Nippon Telegraph & Tel", label: "Nippon Telegraph & Tel" },
  { value: "HSBC Holdings", label: "HSBC Holdings" },
  { value: "Bank of Communications", label: "Bank of Communications" },
  { value: "TD Bank Group", label: "TD Bank Group" },
  { value: "Goldman Sachs Group", label: "Goldman Sachs Group" },
  { value: "Morgan Stanley", label: "Morgan Stanley" },
  { value: "Pfizer", label: "Pfizer" },
  { value: "Tencent Holdings", label: "Tencent Holdings" },
  { value: "IBM", label: "IBM" },
  { value: "Mitsubishi UFJ Financial", label: "Mitsubishi UFJ Financial" },
  { value: "General Electric", label: "General Electric" },
  { value: "Rosneft", label: "Rosneft" },
  { value: "Santander", label: "Santander" },
  { value: "Anheuser-Busch InBev", label: "Anheuser-Busch InBev" },
  { value: "Industrial Bank", label: "Industrial Bank" },
  { value: "Reliance Industries", label: "Reliance Industries" },
  { value: "Sony", label: "Sony" },
  { value: "Sinopec", label: "Sinopec" },
  { value: "Chevron", label: "Chevron" },
  { value: "Siemens", label: "Siemens" },
  { value: "Cigna", label: "Cigna" },
  { value: "AXA Group", label: "AXA Group" },
  {
    value: "Shanghai Pudong Development",
    label: "Shanghai Pudong Development",
  },
  { value: "AIA Group", label: "AIA Group" },
  { value: "Softbank", label: "Softbank" },
  { value: "Novartis", label: "Novartis" },
  { value: "Deutsche Telekom", label: "Deutsche Telekom" },
  { value: "Petrobras", label: "Petrobras" },
  { value: "Procter & Gamble", label: "Procter & Gamble" },
  { value: "Japan Post Holdings", label: "Japan Post Holdings" },
  {
    value: "LVMH Moet Hennessy Louis Vuitton",
    label: "LVMH Moet Hennessy Louis Vuitton",
  },
  { value: "Roche Holding", label: "Roche Holding" },
  { value: "BMW Group", label: "BMW Group" },
  { value: "Zurich Insurance Group", label: "Zurich Insurance Group" },
  { value: "CITIC", label: "CITIC" },
  { value: "Itaú Unibanco Holding", label: "Itaú Unibanco Holding" },
  {
    value: "China State Construction Engineering",
    label: "China State Construction Engineering",
  },
  { value: "MetLife", label: "MetLife" },
  { value: "Sumitomo Mitsui Financial", label: "Sumitomo Mitsui Financial" },
  { value: "Cisco Systems", label: "Cisco Systems" },
  { value: "Honda Motor", label: "Honda Motor" },
  { value: "Commonwealth Bank", label: "Commonwealth Bank" },
  { value: "Bank of Nova Scotia", label: "Bank of Nova Scotia" },
  { value: "Raytheon Technologies", label: "Raytheon Technologies" },
  { value: "PepsiCo", label: "PepsiCo" },
  { value: "American Express", label: "American Express" },
  { value: "General Motors", label: "General Motors" },
  { value: "China Minsheng Bank", label: "China Minsheng Bank" },
  { value: "British American Tobacco", label: "British American Tobacco" },
  { value: "Merck & Co.", label: "Merck & Co." },
  { value: "BHP Group", label: "BHP Group" },
  { value: "Oracle", label: "Oracle" },
  {
    value: "Brookfield Asset Management",
    label: "Brookfield Asset Management",
  },
  { value: "Coca-Cola", label: "Coca-Cola" },
  { value: "Enel", label: "Enel" },
  { value: "GlaxoSmithKline", label: "GlaxoSmithKline" },
  { value: "LukOil", label: "LukOil" },
  { value: "China Vanke", label: "China Vanke" },
  { value: "Banco Bradesco", label: "Banco Bradesco" },
  { value: "Bayer", label: "Bayer" },
  { value: "US Bancorp", label: "US Bancorp" },
  { value: "Mitsubishi", label: "Mitsubishi" },
  { value: "Anthem", label: "Anthem" },
  { value: "Home Depot", label: "Home Depot" },
  { value: "BASF", label: "BASF" },
  { value: "Taiwan Semiconductor", label: "Taiwan Semiconductor" },
  { value: "UBS", label: "UBS" },
  { value: "Unilever", label: "Unilever" },
  { value: "Country Garden Holdings", label: "Country Garden Holdings" },
  { value: "EDF", label: "EDF" },
  { value: "China Citic Bank", label: "China Citic Bank" },
  { value: "Rio Tinto", label: "Rio Tinto" },
  { value: "Lloyds Banking Group", label: "Lloyds Banking Group" },
  { value: "Prudential Financial", label: "Prudential Financial" },
  { value: "Sanofi", label: "Sanofi" },
  { value: "Credit Agricole", label: "Credit Agricole" },
  { value: "AbbVie", label: "AbbVie" },
  { value: "Iberdrola", label: "Iberdrola" },
  { value: "Hon Hai Precision", label: "Hon Hai Precision" },
  { value: "KDDI", label: "KDDI" },
  { value: "Enbridge", label: "Enbridge" },
  { value: "Manulife", label: "Manulife" },
  { value: "Intesa Sanpaolo", label: "Intesa Sanpaolo" },
  { value: "CNOOC", label: "CNOOC" },
  { value: "Dell Technologies", label: "Dell Technologies" },
  { value: "Westpac Banking Group", label: "Westpac Banking Group" },
  { value: "Medtronic", label: "Medtronic" },
  { value: "China Pacific Insurance", label: "China Pacific Insurance" },
  { value: "SAIC Motor", label: "SAIC Motor" },
  { value: "Bank of Montreal", label: "Bank of Montreal" },
  { value: "Caterpillar", label: "Caterpillar" },
  { value: "Chubb", label: "Chubb" },
  { value: "Itochu", label: "Itochu" },
  { value: "Walgreens Boots Alliance", label: "Walgreens Boots Alliance" },
  { value: "VINCI", label: "VINCI" },
  { value: "Bristol-Myers Squibb", label: "Bristol-Myers Squibb" },
  { value: "PNC Financial Services", label: "PNC Financial Services" },
  { value: "Generali Group", label: "Generali Group" },
  { value: "Visa", label: "Visa" },
  { value: "Costco Wholesale", label: "Costco Wholesale" },
  { value: "United Parcel Service", label: "United Parcel Service" },
  { value: "Duke Energy", label: "Duke Energy" },
  { value: "Lockheed Martin", label: "Lockheed Martin" },
  { value: "HDFC Bank", label: "HDFC Bank" },
  { value: "Allstate", label: "Allstate" },
  { value: "China Everbright Bank", label: "China Everbright Bank" },
  { value: "Charter Communications", label: "Charter Communications" },
  { value: "SAP", label: "SAP" },
  { value: "Tokio Marine Holdings", label: "Tokio Marine Holdings" },
  { value: "CK Hutchison", label: "CK Hutchison" },
  { value: "Honeywell International", label: "Honeywell International" },
  { value: "China Evergrande Group", label: "China Evergrande Group" },
  {
    value: "American International Group",
    label: "American International Group",
  },
  { value: "Orange", label: "Orange" },
  { value: "América Móvil", label: "América Móvil" },
  { value: "Abbott Laboratories", label: "Abbott Laboratories" },
  { value: "Bank of New York Mellon", label: "Bank of New York Mellon" },
  { value: "Credit Suisse Group", label: "Credit Suisse Group" },
  { value: "Capital One Financial", label: "Capital One Financial" },
  { value: "Amgen", label: "Amgen" },
  { value: "Truist Financial", label: "Truist Financial" },
  { value: "ANZ", label: "ANZ" },
  { value: "Equinor", label: "Equinor" },
  { value: "Mitsui", label: "Mitsui" },
  { value: "Oversea-Chinese Banking", label: "Oversea-Chinese Banking" },
  { value: "China Shenhua Energy", label: "China Shenhua Energy" },
  { value: "Exelon", label: "Exelon" },
  { value: "PTT", label: "PTT" },
  { value: "State Bank of India", label: "State Bank of India" },
  {
    value: "Poly Developments & Holdings Group",
    label: "Poly Developments & Holdings Group",
  },
  { value: "Lowe's", label: "Lowe's" },
  { value: "China Telecom", label: "China Telecom" },
  { value: "Southern Company", label: "Southern Company" },
  { value: "L'Oréal", label: "L'Oréal" },
  { value: "BlackRock", label: "BlackRock" },
  { value: "Linde", label: "Linde" },
  { value: "Canadian Imperial Bank", label: "Canadian Imperial Bank" },
  { value: "NextEra Energy", label: "NextEra Energy" },
  { value: "Barclays", label: "Barclays" },
  { value: "Deere & Company", label: "Deere & Company" },
  { value: "Union Pacific", label: "Union Pacific" },
  { value: "Thermo Fisher Scientific", label: "Thermo Fisher Scientific" },
  { value: "Deutsche Post", label: "Deutsche Post" },
  { value: "Gilead Sciences", label: "Gilead Sciences" },
  { value: "Phillips 66", label: "Phillips 66" },
  { value: "Mondelez International", label: "Mondelez International" },
  { value: "Hyundai Motor", label: "Hyundai Motor" },
  { value: "Qatar National Bank", label: "Qatar National Bank" },
  {
    value: "NAB - National Australia Bank",
    label: "NAB - National Australia Bank",
  },
  { value: "Broadcom", label: "Broadcom" },
  { value: "Legal & General Group", label: "Legal & General Group" },
  { value: "ING Group", label: "ING Group" },
  { value: "3M", label: "3M" },
  { value: "Target", label: "Target" },
  { value: "Marathon Petroleum", label: "Marathon Petroleum" },
  { value: "Hitachi", label: "Hitachi" },
  { value: "Progressive", label: "Progressive" },
  { value: "DBS", label: "DBS" },
  { value: "ConocoPhillips", label: "ConocoPhillips" },
  { value: "UniCredit", label: "UniCredit" },
  {
    value: "Philip Morris International",
    label: "Philip Morris International",
  },
  { value: "China Railway Group", label: "China Railway Group" },
  { value: "Accenture", label: "Accenture" },
  { value: "Munich Re", label: "Munich Re" },
  { value: "Royal Bank of Scotland", label: "Royal Bank of Scotland" },
  { value: "Banco do Brasil", label: "Banco do Brasil" },
  { value: "McDonald's", label: "McDonald's" },
  { value: "China Resources Land", label: "China Resources Land" },
  { value: "China Railway Construction", label: "China Railway Construction" },
  { value: "Saudi Basic Industries", label: "Saudi Basic Industries" },
  { value: "Aviva", label: "Aviva" },
  { value: "General Dynamics", label: "General Dynamics" },
  { value: "MS&AD Insurance", label: "MS&AD Insurance" },
  { value: "PICC", label: "PICC" },
  { value: "Aflac", label: "Aflac" },
  { value: "E.ON", label: "E.ON" },
  { value: "Travelers", label: "Travelers" },
  { value: "Prudential", label: "Prudential" },
  { value: "Eli Lilly", label: "Eli Lilly" },
  { value: "Kraft Heinz Company", label: "Kraft Heinz Company" },
  { value: "Sunac China Holdings", label: "Sunac China Holdings" },
  { value: "Charles Schwab", label: "Charles Schwab" },
  { value: "HCA Healthcare", label: "HCA Healthcare" },
  { value: "Danaher", label: "Danaher" },
  { value: "Schneider Electric", label: "Schneider Electric" },
  { value: "Société Générale", label: "Société Générale" },
  { value: "Midea Group", label: "Midea Group" },
  { value: "Dai-ichi Life Insurance", label: "Dai-ichi Life Insurance" },
  { value: "ENGIE", label: "ENGIE" },
  { value: "Fiat Chrysler Automobiles", label: "Fiat Chrysler Automobiles" },
  { value: "Volvo Group", label: "Volvo Group" },
  { value: "Seven & I Holdings", label: "Seven & I Holdings" },
  { value: "Humana", label: "Humana" },
  { value: "Longfor Group Holdings", label: "Longfor Group Holdings" },
  { value: "AstraZeneca", label: "AstraZeneca" },
  { value: "JD.com", label: "JD.com" },
  { value: "Air Liquide", label: "Air Liquide" },
  { value: "Fresenius", label: "Fresenius" },
  { value: "Northrop Grumman", label: "Northrop Grumman" },
  { value: "Mizuho Financial", label: "Mizuho Financial" },
  { value: "Sun Life Financial", label: "Sun Life Financial" },
  { value: "Inditex", label: "Inditex" },
  { value: "Nike", label: "Nike" },
  { value: "Gree Electric Appliances", label: "Gree Electric Appliances" },
  { value: "Central Japan Railway", label: "Central Japan Railway" },
  { value: "Danone", label: "Danone" },
  { value: "PayPal", label: "PayPal" },
  { value: "Cathay Financial", label: "Cathay Financial" },
  { value: "Surgutneftegas", label: "Surgutneftegas" },
  { value: "Suncor Energy", label: "Suncor Energy" },
  { value: "Standard Chartered", label: "Standard Chartered" },
  { value: "Tesco", label: "Tesco" },
  { value: "ICICI Bank", label: "ICICI Bank" },
  { value: "Panasonic", label: "Panasonic" },
  { value: "Safran", label: "Safran" },
  { value: "Qualcomm", label: "Qualcomm" },
  { value: "Royal Ahold Delhaize N.V.", label: "Royal Ahold Delhaize N.V." },
  { value: "KBC Group", label: "KBC Group" },
  { value: "East Japan Railway", label: "East Japan Railway" },
  { value: "National Grid", label: "National Grid" },
  { value: "Delta Air Lines", label: "Delta Air Lines" },
  { value: "Peugeot", label: "Peugeot" },
  { value: "Telefónica", label: "Telefónica" },
  { value: "Kroger", label: "Kroger" },
  {
    value: "China Communications Construction",
    label: "China Communications Construction",
  },
  { value: "Shinhan Financial Group", label: "Shinhan Financial Group" },
  { value: "Oil & Natural Gas", label: "Oil & Natural Gas" },
  { value: "Sun Hung Kai Properties", label: "Sun Hung Kai Properties" },
  { value: "Huaxia Bank", label: "Huaxia Bank" },
  { value: "Fubon Financial", label: "Fubon Financial" },
  { value: "Diageo", label: "Diageo" },
  { value: "Anglo American", label: "Anglo American" },
  { value: "Mastercard", label: "Mastercard" },
  { value: "Dominion Energy", label: "Dominion Energy" },
  { value: "Micron Technology", label: "Micron Technology" },
  { value: "KB Financial Group", label: "KB Financial Group" },
  { value: "HDFC", label: "HDFC" },
  { value: "LafargeHolcim", label: "LafargeHolcim" },
  { value: "United Overseas Bank", label: "United Overseas Bank" },
  { value: "Bank of Beijing", label: "Bank of Beijing" },
  { value: "Japan Tobacco", label: "Japan Tobacco" },
  { value: "Netflix", label: "Netflix" },
  { value: "Centene", label: "Centene" },
  { value: "China Unicom", label: "China Unicom" },
  { value: "Jardine Matheson", label: "Jardine Matheson" },
  { value: "Starbucks", label: "Starbucks" },
  { value: "American Electric", label: "American Electric" },
  { value: "Sumitomo", label: "Sumitomo" },
  { value: "Nordea Bank", label: "Nordea Bank" },
  { value: "Orix", label: "Orix" },
  { value: "TJX Cos", label: "TJX Cos" },
  { value: "Mitsubishi Electric", label: "Mitsubishi Electric" },
  { value: "State Street", label: "State Street" },
  { value: "SK Hynix", label: "SK Hynix" },
  { value: "RWE Group", label: "RWE Group" },
  { value: "ABB", label: "ABB" },
  { value: "Nomura", label: "Nomura" },
  { value: "BCE", label: "BCE" },
  { value: "Automatic Data Processing", label: "Automatic Data Processing" },
  { value: "HP", label: "HP" },
  { value: "First Abu Dhabi Bank", label: "First Abu Dhabi Bank" },
  { value: "EssilorLuxottica", label: "EssilorLuxottica" },
  { value: "Henkel", label: "Henkel" },
  { value: "Canadian Natural Resources", label: "Canadian Natural Resources" },
  { value: "Greenland Holdings Group", label: "Greenland Holdings Group" },
  { value: "EMD Group", label: "EMD Group" },
  { value: "Swiss Re", label: "Swiss Re" },
  { value: "Bank Of Shanghai", label: "Bank Of Shanghai" },
  { value: "Archer Daniels Midland", label: "Archer Daniels Midland" },
  { value: "Anhui Conch Cement", label: "Anhui Conch Cement" },
  { value: "Ecopetrol", label: "Ecopetrol" },
  { value: "BT Group", label: "BT Group" },
  { value: "Poste Italiane", label: "Poste Italiane" },
  { value: "Novatek", label: "Novatek" },
  { value: "TC Energy", label: "TC Energy" },
  { value: "CRH", label: "CRH" },
  { value: "Macquarie Group", label: "Macquarie Group" },
  { value: "BBVA-Banco Bilbao Vizcaya", label: "BBVA-Banco Bilbao Vizcaya" },
  { value: "JXTG Holdings", label: "JXTG Holdings" },
  { value: "Kering", label: "Kering" },
  { value: "Baoshan Iron & Steel", label: "Baoshan Iron & Steel" },
  { value: "Daiwa House Industry", label: "Daiwa House Industry" },
  { value: "Couche Tard", label: "Couche Tard" },
  { value: "Daimler", label: "Daimler" },
  { value: "Bridgestone", label: "Bridgestone" },
  { value: "Fannie Mae", label: "Fannie Mae" },
  { value: "Tyson Foods", label: "Tyson Foods" },
  { value: "New China Life Insurance", label: "New China Life Insurance" },
  { value: "Saint-Gobain", label: "Saint-Gobain" },
  { value: "CSX", label: "CSX" },
  { value: "DNB", label: "DNB" },
  { value: "Novo Nordisk", label: "Novo Nordisk" },
  { value: "Saudi Telecom", label: "Saudi Telecom" },
  { value: "LyondellBasell Industries", label: "LyondellBasell Industries" },
  { value: "EOG Resources", label: "EOG Resources" },
  { value: "Sempra Energy", label: "Sempra Energy" },
  { value: "Eaton", label: "Eaton" },
  { value: "Freddie Mac", label: "Freddie Mac" },
  { value: "Heineken", label: "Heineken" },
  { value: "Kweichow Moutai", label: "Kweichow Moutai" },
  { value: "CK Asset Holdings", label: "CK Asset Holdings" },
  { value: "Becton Dickinson", label: "Becton Dickinson" },
  { value: "Stryker", label: "Stryker" },
  { value: "CRRC", label: "CRRC" },
  {
    value: "Bank Rakyat Indonesia (BRI)",
    label: "Bank Rakyat Indonesia (BRI)",
  },
  {
    value: "China Merchants Shekou Industrial Zone Holdings",
    label: "China Merchants Shekou Industrial Zone Holdings",
  },
  { value: "Maybank", label: "Maybank" },
  { value: "Kinder Morgan", label: "Kinder Morgan" },
  { value: "Emirates NBD", label: "Emirates NBD" },
  { value: "Marsh & McLennan", label: "Marsh & McLennan" },
  { value: "Ameriprise Financial", label: "Ameriprise Financial" },
  { value: "Dollar General", label: "Dollar General" },
  { value: "Shin-Etsu Chemical", label: "Shin-Etsu Chemical" },
  { value: "Barrick Gold", label: "Barrick Gold" },
  { value: "BP", label: "BP" },
  { value: "Etisalat", label: "Etisalat" },
  { value: "Canon", label: "Canon" },
  { value: "Sompo", label: "Sompo" },
  { value: "ASML Holding", label: "ASML Holding" },
  { value: "Natixis", label: "Natixis" },
  { value: "Vivendi", label: "Vivendi" },
  { value: "Swiss Life Holding", label: "Swiss Life Holding" },
  { value: "Posco", label: "Posco" },
  { value: "Biogen", label: "Biogen" },
  { value: "Mitsui Fudosan", label: "Mitsui Fudosan" },
  { value: "Canadian National Railway", label: "Canadian National Railway" },
  { value: "Booking Holdings", label: "Booking Holdings" },
  { value: "NN Group", label: "NN Group" },
  { value: "Fosun International", label: "Fosun International" },
  { value: "Wilmar International", label: "Wilmar International" },
  { value: "General Mills", label: "General Mills" },
  { value: "Carrefour", label: "Carrefour" },
  { value: "Daikin Industries", label: "Daikin Industries" },
  { value: "Tata Consultancy Services", label: "Tata Consultancy Services" },
  { value: "Power Corp of Canada", label: "Power Corp of Canada" },
  { value: "Boston Scientific", label: "Boston Scientific" },
  {
    value: "Discover Financial Services",
    label: "Discover Financial Services",
  },
  { value: "Synchrony Financial", label: "Synchrony Financial" },
  { value: "Michelin Group", label: "Michelin Group" },
  { value: "Paccar", label: "Paccar" },
  { value: "Sumitomo Mitsui Trust", label: "Sumitomo Mitsui Trust" },
  { value: "Xiaomi", label: "Xiaomi" },
  {
    value: "Hartford Financial Services",
    label: "Hartford Financial Services",
  },
  { value: "Philips", label: "Philips" },
  { value: "IntercontinentalExchange", label: "IntercontinentalExchange" },
  { value: "Norfolk Southern", label: "Norfolk Southern" },
  { value: "BAE Systems", label: "BAE Systems" },
  { value: "Indian Oil", label: "Indian Oil" },
  { value: "Bank of Ningbo", label: "Bank of Ningbo" },
  { value: "Sysco", label: "Sysco" },
  { value: "CNP Assurances", label: "CNP Assurances" },
  { value: "Denso", label: "Denso" },
  { value: "Newmont Mining", label: "Newmont Mining" },
  { value: "National Commercial Bank", label: "National Commercial Bank" },
  { value: "Adidas", label: "Adidas" },
  { value: "CTBC Financial", label: "CTBC Financial" },
  { value: "Danske Bank", label: "Danske Bank" },
  { value: "China National Building", label: "China National Building" },
  { value: "Richemont", label: "Richemont" },
  { value: "Sberbank", label: "Sberbank" },
  { value: "VMware", label: "VMware" },
  { value: "Nippon Steel", label: "Nippon Steel" },
  { value: "Komatsu", label: "Komatsu" },
  { value: "Transneft", label: "Transneft" },
  { value: "Talanx", label: "Talanx" },
  { value: "Xcel Energy", label: "Xcel Energy" },
  { value: "Consolidated Edison", label: "Consolidated Edison" },
  { value: "Naturgy Energy Group", label: "Naturgy Energy Group" },
  { value: "Fiserv", label: "Fiserv" },
  { value: "Bank Of Jiangsu", label: "Bank Of Jiangsu" },
  { value: "Boeing", label: "Boeing" },
  { value: "Waste Management", label: "Waste Management" },
  { value: "Woolworths", label: "Woolworths" },
  { value: "Texas Instruments", label: "Texas Instruments" },
  { value: "Hyundai Mobis", label: "Hyundai Mobis" },
  { value: "Adobe", label: "Adobe" },
  { value: "DuPont de Nemours", label: "DuPont de Nemours" },
  { value: "Hana Financial Group", label: "Hana Financial Group" },
  { value: "L3Harris Technologies", label: "L3Harris Technologies" },
  { value: "Fujitsu", label: "Fujitsu" },
  { value: "Shimao Property Holdings", label: "Shimao Property Holdings" },
  { value: "Norilsk Nickel", label: "Norilsk Nickel" },
  { value: "Imperial Brands", label: "Imperial Brands" },
  { value: "China Zheshang Bank", label: "China Zheshang Bank" },
  { value: "Tokyo Electric Power", label: "Tokyo Electric Power" },
  { value: "Fast Retailing", label: "Fast Retailing" },
  { value: "Emerson Electric", label: "Emerson Electric" },
  { value: "Toyota Industries", label: "Toyota Industries" },
  { value: "Femsa", label: "Femsa" },
  { value: "Hewlett Packard Enterprise", label: "Hewlett Packard Enterprise" },
  { value: "China Yangtze Power", label: "China Yangtze Power" },
  { value: "Recruit Holdings", label: "Recruit Holdings" },
  { value: "Keurig Dr Pepper", label: "Keurig Dr Pepper" },
  { value: "Applied Materials", label: "Applied Materials" },
  { value: "Edison International", label: "Edison International" },
  { value: "Principal Financial Group", label: "Principal Financial Group" },
  { value: "AIRBUS", label: "AIRBUS" },
  { value: "CME Group", label: "CME Group" },
  { value: "OMV Group", label: "OMV Group" },
  { value: "Marubeni", label: "Marubeni" },
  { value: "AmerisourceBergen", label: "AmerisourceBergen" },
  { value: "Larsen & Toubro", label: "Larsen & Toubro" },
  { value: "Bouygues", label: "Bouygues" },
  { value: "Nutrien", label: "Nutrien" },
  { value: "Kansai Electric Power", label: "Kansai Electric Power" },
  { value: "Sherwin-Williams", label: "Sherwin-Williams" },
  { value: "Fujifilm Holdings", label: "Fujifilm Holdings" },
  { value: "American Tower", label: "American Tower" },
  { value: "Pernod Ricard", label: "Pernod Ricard" },
  { value: "VTB Bank", label: "VTB Bank" },
  { value: "Telstra", label: "Telstra" },
  { value: "Lennar", label: "Lennar" },
  { value: "Chubu Electric Power", label: "Chubu Electric Power" },
  { value: "Ecolab", label: "Ecolab" },
  { value: "Cummins", label: "Cummins" },
  { value: "Marriott International", label: "Marriott International" },
  { value: "SEB AB", label: "SEB AB" },
  { value: "Investor AB", label: "Investor AB" },
  { value: "JBS", label: "JBS" },
  { value: "CaixaBank", label: "CaixaBank" },
  { value: "National Bank of Canada", label: "National Bank of Canada" },
  { value: "Svenska Handelsbanken", label: "Svenska Handelsbanken" },
  { value: "Vodafone", label: "Vodafone" },
  { value: "Sampo", label: "Sampo" },
  {
    value: "Power Construction Corporation of China",
    label: "Power Construction Corporation of China",
  },
  { value: "Carnival", label: "Carnival" },
  { value: "Eni", label: "Eni" },
  { value: "The Estée Lauder Companies", label: "The Estée Lauder Companies" },
  { value: "Fifth Third Bank", label: "Fifth Third Bank" },
  { value: "ViacomCBS", label: "ViacomCBS" },
  { value: "Al Rajhi Bank", label: "Al Rajhi Bank" },
  {
    value: "China Fortune Land Development",
    label: "China Fortune Land Development",
  },
  { value: "Kimberly-Clark", label: "Kimberly-Clark" },
  { value: "Fortescue Metals Group", label: "Fortescue Metals Group" },
  {
    value: "Public Service Enterprise Group",
    label: "Public Service Enterprise Group",
  },
  { value: "KIA Motors", label: "KIA Motors" },
  { value: "Subaru", label: "Subaru" },
  { value: "Suzuki Motor", label: "Suzuki Motor" },
  {
    value: "Mitsubishi Heavy Industries",
    label: "Mitsubishi Heavy Industries",
  },
  { value: "Southwest Airlines", label: "Southwest Airlines" },
  { value: "Mitsubishi Estate", label: "Mitsubishi Estate" },
  { value: "Glencore International", label: "Glencore International" },
  { value: "Aon", label: "Aon" },
  { value: "Ford Motor", label: "Ford Motor" },
  { value: "Bank Central Asia", label: "Bank Central Asia" },
  { value: "Thales", label: "Thales" },
  { value: "NVIDIA", label: "NVIDIA" },
  { value: "Suning.com", label: "Suning.com" },
  { value: "Takeda Pharmaceutical", label: "Takeda Pharmaceutical" },
  { value: "EnBW-Energie Baden", label: "EnBW-Energie Baden" },
  { value: "Valero Energy", label: "Valero Energy" },
  { value: "Colgate-Palmolive", label: "Colgate-Palmolive" },
  { value: "Bank Mandiri", label: "Bank Mandiri" },
  { value: "H&M - Hennes & Mauritz", label: "H&M - Hennes & Mauritz" },
  { value: "NTPC", label: "NTPC" },
  { value: "Murata Manufacturing", label: "Murata Manufacturing" },
  { value: "SingTel", label: "SingTel" },
  { value: "Las Vegas Sands", label: "Las Vegas Sands" },
  { value: "Magna International", label: "Magna International" },
  { value: "Weichai Power", label: "Weichai Power" },
  { value: "Fairfax Financial", label: "Fairfax Financial" },
  { value: "China Tower Corp.", label: "China Tower Corp." },
  { value: "Compass Group", label: "Compass Group" },
  { value: "Entergy", label: "Entergy" },
  { value: "Erste Group Bank", label: "Erste Group Bank" },
  { value: "Toyota Tsusho", label: "Toyota Tsusho" },
  { value: "Citic Securities", label: "Citic Securities" },
  { value: "Samsung C&T", label: "Samsung C&T" },
  { value: "Illinois Tool Works", label: "Illinois Tool Works" },
  { value: "Nissan Motor", label: "Nissan Motor" },
  { value: "FedEx", label: "FedEx" },
  { value: "Vale", label: "Vale" },
  { value: "eBay", label: "eBay" },
  { value: "Wesfarmers", label: "Wesfarmers" },
  { value: "Bank of Nanjing", label: "Bank of Nanjing" },
  { value: "M&G", label: "M&G" },
  { value: "Asahi Group Holdings", label: "Asahi Group Holdings" },
  { value: "Atlantia", label: "Atlantia" },
  { value: "DTE Energy", label: "DTE Energy" },
  { value: "Kotak Mahindra Bank", label: "Kotak Mahindra Bank" },
  { value: "Aegon", label: "Aegon" },
  { value: "Carrier Global", label: "Carrier Global" },
  { value: "United Airlines Holdings", label: "United Airlines Holdings" },
  { value: "Northern Trust", label: "Northern Trust" },
  { value: "Swisscom", label: "Swisscom" },
  { value: "CNH Industrial", label: "CNH Industrial" },
  { value: "Kubota", label: "Kubota" },
  { value: "Samsung Life Insurance", label: "Samsung Life Insurance" },
  { value: "Best Buy", label: "Best Buy" },
  { value: "Haier Smart Home", label: "Haier Smart Home" },
  { value: "Cognizant", label: "Cognizant" },
  { value: "Nintendo", label: "Nintendo" },
  { value: "McKesson", label: "McKesson" },
  { value: "FirstRand", label: "FirstRand" },
  {
    value: "China Cinda Asset Management",
    label: "China Cinda Asset Management",
  },
  { value: "Hengli Petrochemical", label: "Hengli Petrochemical" },
  { value: "Tatneft", label: "Tatneft" },
  { value: "Tenaga Nasional", label: "Tenaga Nasional" },
  { value: "SK Holdings", label: "SK Holdings" },
  { value: "Deutsche Bank", label: "Deutsche Bank" },
  { value: "M&T Bank", label: "M&T Bank" },
  { value: "Standard Bank Group", label: "Standard Bank Group" },
  { value: "China Taiping Insurance", label: "China Taiping Insurance" },
  { value: "Telecom Italia", label: "Telecom Italia" },
  { value: "Astellas Pharma", label: "Astellas Pharma" },
  { value: "Veolia Environnement", label: "Veolia Environnement" },
  { value: "Grupo Mexico", label: "Grupo Mexico" },
  { value: "Kyocera", label: "Kyocera" },
  { value: "Rogers Communications", label: "Rogers Communications" },
  { value: "Loews", label: "Loews" },
  { value: "Trane Technologies", label: "Trane Technologies" },
  { value: "Air Products & Chemicals", label: "Air Products & Chemicals" },
  { value: "Aeon", label: "Aeon" },
  { value: "Sinopharm Group", label: "Sinopharm Group" },
  { value: "PPL", label: "PPL" },
  { value: "EXOR", label: "EXOR" },
  { value: "RELX", label: "RELX" },
  { value: "Lincoln National", label: "Lincoln National" },
  { value: "Allergan", label: "Allergan" },
  { value: "NetEase", label: "NetEase" },
  { value: "Naspers", label: "Naspers" },
  { value: "Grupo ACS", label: "Grupo ACS" },
  { value: "TELUS", label: "TELUS" },
  { value: "MTR", label: "MTR" },
  { value: "KeyCorp", label: "KeyCorp" },
  { value: "Prologis", label: "Prologis" },
  { value: "Evonik", label: "Evonik" },
  { value: "Citizens Financial Group", label: "Citizens Financial Group" },
  { value: "D.R. Horton", label: "D.R. Horton" },
  { value: "Dow", label: "Dow" },
  { value: "Orsted", label: "Orsted" },
  { value: "Willis Towers Watson", label: "Willis Towers Watson" },
  { value: "DISH Network", label: "DISH Network" },
  { value: "Athene Holding", label: "Athene Holding" },
  { value: "Swedbank", label: "Swedbank" },
  { value: "Salesforce.com", label: "Salesforce.com" },
  { value: "Altria Group", label: "Altria Group" },
  { value: "Otsuka Holding", label: "Otsuka Holding" },
  { value: "Eversource Energy", label: "Eversource Energy" },
  { value: "Sekisui House", label: "Sekisui House" },
  { value: "Parker-Hannifin", label: "Parker-Hannifin" },
  { value: "Discovery", label: "Discovery" },
  { value: "Banorte", label: "Banorte" },
  { value: "Tesla", label: "Tesla" },
  { value: "TD Ameritrade Holding", label: "TD Ameritrade Holding" },
  { value: "Baxter International", label: "Baxter International" },
  { value: "Deutsche Boerse", label: "Deutsche Boerse" },
  { value: "Saudi Electricity", label: "Saudi Electricity" },
  { value: "Associated British Foods", label: "Associated British Foods" },
  { value: "Sumitomo Realty", label: "Sumitomo Realty" },
  { value: "WH Group", label: "WH Group" },
  { value: "Korea Electric Power", label: "Korea Electric Power" },
  { value: "Williams", label: "Williams" },
  { value: "WEC Energy Group", label: "WEC Energy Group" },
  { value: "Inpex", label: "Inpex" },
  { value: "Edp-energias De Portugal", label: "Edp-energias De Portugal" },
  { value: "Mitsubishi Chemical", label: "Mitsubishi Chemical" },
  { value: "Dollar Tree", label: "Dollar Tree" },
  { value: "Bharat Petroleum", label: "Bharat Petroleum" },
  { value: "Infosys", label: "Infosys" },
  { value: "MGM Resorts", label: "MGM Resorts" },
  { value: "Kao", label: "Kao" },
  { value: "International Paper", label: "International Paper" },
  { value: "CGN Power", label: "CGN Power" },
  { value: "Formosa Petrochemical", label: "Formosa Petrochemical" },
  { value: "PPG", label: "PPG" },
  { value: "Swire Pacific", label: "Swire Pacific" },
  {
    value: "Coca-Cola European Partners",
    label: "Coca-Cola European Partners",
  },
  { value: "CSL", label: "CSL" },
  { value: "Coal India", label: "Coal India" },
  { value: "Woori Financial Group", label: "Woori Financial Group" },
  { value: "Daiichi Sankyo", label: "Daiichi Sankyo" },
  { value: "SK Telecom", label: "SK Telecom" },
  { value: "Fox", label: "Fox" },
  { value: "Crown Castle International", label: "Crown Castle International" },
  { value: "Ageas", label: "Ageas" },
  { value: "Republic Services", label: "Republic Services" },
  {
    value: "Metallurgical Corp of China",
    label: "Metallurgical Corp of China",
  },
  { value: "Neste", label: "Neste" },
  { value: "Møller-Maersk", label: "Møller-Maersk" },
  { value: "CBRE Group", label: "CBRE Group" },
  { value: "International Airlines", label: "International Airlines" },
  { value: "Nokia", label: "Nokia" },
  { value: "Omnicom Group", label: "Omnicom Group" },
  { value: "Essity Ab", label: "Essity Ab" },
  { value: "Ross Stores", label: "Ross Stores" },
  { value: "Industrial Bank of Korea", label: "Industrial Bank of Korea" },
  { value: "Schlumberger", label: "Schlumberger" },
  { value: "Deutsche Lufthansa", label: "Deutsche Lufthansa" },
  { value: "Stanley Black & Decker", label: "Stanley Black & Decker" },
  { value: "Wheelock", label: "Wheelock" },
  { value: "Asahi Kasei", label: "Asahi Kasei" },
  { value: "Kellogg", label: "Kellogg" },
  { value: "SSE", label: "SSE" },
  { value: "Daqin Railway", label: "Daqin Railway" },
  { value: "Haitong Securities", label: "Haitong Securities" },
  {
    value: "Fidelity National Information",
    label: "Fidelity National Information",
  },
  { value: "Henderson Land", label: "Henderson Land" },
  { value: "Regions Financial", label: "Regions Financial" },
  { value: "JFE Holdings", label: "JFE Holdings" },
  { value: "NEC", label: "NEC" },
  { value: "Capgemini", label: "Capgemini" },
  { value: "Repsol", label: "Repsol" },
  { value: "Continental", label: "Continental" },
  { value: "Regeneron Pharmaceuticals", label: "Regeneron Pharmaceuticals" },
  { value: "New World Development", label: "New World Development" },
  { value: "Royal Caribbean Cruises", label: "Royal Caribbean Cruises" },
  { value: "ArcelorMittal", label: "ArcelorMittal" },
  { value: "Reckitt Benckiser Group", label: "Reckitt Benckiser Group" },
  { value: "Vonovia", label: "Vonovia" },
  { value: "Fortis (Canada)", label: "Fortis (Canada)" },
  { value: "Resona Holdings", label: "Resona Holdings" },
  { value: "FirstEnergy", label: "FirstEnergy" },
  { value: "Ally Financial", label: "Ally Financial" },
  { value: "Zimmer Biomet", label: "Zimmer Biomet" },
  { value: "Atlas Copco", label: "Atlas Copco" },
  { value: "Lam Research", label: "Lam Research" },
  { value: "CLP Holdings", label: "CLP Holdings" },
  { value: "Cardinal Health", label: "Cardinal Health" },
  { value: "Activision Blizzard", label: "Activision Blizzard" },
  { value: "West Japan Railway", label: "West Japan Railway" },
  { value: "Public Bank", label: "Public Bank" },
  { value: "WPP", label: "WPP" },
  { value: "CarMax", label: "CarMax" },
  { value: "CNPC Capital", label: "CNPC Capital" },
  { value: "Simon Property Group", label: "Simon Property Group" },
  { value: "Occidental Petroleum", label: "Occidental Petroleum" },
  { value: "London Stock Exchange", label: "London Stock Exchange" },
  { value: "Eiffage", label: "Eiffage" },
  { value: "TE Connectivity", label: "TE Connectivity" },
  { value: "Sodexo", label: "Sodexo" },
  { value: "Sumitomo Electric", label: "Sumitomo Electric" },
  { value: "Porsche Automobil Holding", label: "Porsche Automobil Holding" },
  {
    value: "Reinsurance Group of America",
    label: "Reinsurance Group of America",
  },
  { value: "National Bank of Kuwait", label: "National Bank of Kuwait" },
  { value: "HeidelbergCement", label: "HeidelbergCement" },
  { value: "AutoZone", label: "AutoZone" },
  { value: "Nidec", label: "Nidec" },
  { value: "Lenovo Group", label: "Lenovo Group" },
  {
    value: "Johnson Controls International",
    label: "Johnson Controls International",
  },
  { value: "Unipol Gruppo", label: "Unipol Gruppo" },
  { value: "S.F. Holding", label: "S.F. Holding" },
  { value: "First Republic Bank", label: "First Republic Bank" },
  { value: "Xiamen C&D", label: "Xiamen C&D" },
  {
    value: "Beijing-Shanghai High-Speed Railway",
    label: "Beijing-Shanghai High-Speed Railway",
  },
  { value: "Hong Kong Exchanges", label: "Hong Kong Exchanges" },
  { value: "CIMB Group Holdings", label: "CIMB Group Holdings" },
  { value: "WestRock", label: "WestRock" },
  { value: "Telenor", label: "Telenor" },
  { value: "Commerzbank", label: "Commerzbank" },
  { value: "Siam Cement", label: "Siam Cement" },
  { value: "Tokyo Electron", label: "Tokyo Electron" },
  { value: "Dongfeng Motor Group", label: "Dongfeng Motor Group" },
  { value: "Gemdale", label: "Gemdale" },
  { value: "Seazen Group", label: "Seazen Group" },
  { value: "Huatai Securities", label: "Huatai Securities" },
  { value: "Wens Foodstuff Group", label: "Wens Foodstuff Group" },
  { value: "Bharti Airtel", label: "Bharti Airtel" },
  { value: "China Energy Engineering", label: "China Energy Engineering" },
  { value: "Nucor", label: "Nucor" },
  { value: "Sany Heavy Industry", label: "Sany Heavy Industry" },
  { value: "Ericsson", label: "Ericsson" },
  { value: "Baidu", label: "Baidu" },
  { value: "Kirin Holdings", label: "Kirin Holdings" },
  { value: "SM Investments", label: "SM Investments" },
  { value: "Telkom Indonesia", label: "Telkom Indonesia" },
  { value: "Riyad Bank", label: "Riyad Bank" },
  { value: "Legend Holding", label: "Legend Holding" },
  { value: "Grupo Aval", label: "Grupo Aval" },
  { value: "Ferguson", label: "Ferguson" },
  { value: "Uber", label: "Uber" },
  { value: "Kasikornbank", label: "Kasikornbank" },
  { value: "DP World", label: "DP World" },
  { value: "Geely Automobile Holdings", label: "Geely Automobile Holdings" },
  { value: "Credicorp", label: "Credicorp" },
  { value: "Isbank", label: "Isbank" },
  { value: "LG Chem", label: "LG Chem" },
  { value: "Analog Devices", label: "Analog Devices" },
  { value: "Guangzhou R&F", label: "Guangzhou R&F" },
  { value: "Eletrobrás", label: "Eletrobrás" },
  { value: "Coles Group", label: "Coles Group" },
  { value: "Hermès International", label: "Hermès International" },
  {
    value: "Raiffeisen Bank International",
    label: "Raiffeisen Bank International",
  },
  { value: "S&P Global", label: "S&P Global" },
  { value: "Axis Bank", label: "Axis Bank" },
  { value: "Samsung Fire & Marine", label: "Samsung Fire & Marine" },
  { value: "Carlsberg", label: "Carlsberg" },
  { value: "Mega Financial Holding", label: "Mega Financial Holding" },
  { value: "China Reinsurance Group", label: "China Reinsurance Group" },
  { value: "Grupa PZU", label: "Grupa PZU" },
  { value: "Mapfre", label: "Mapfre" },
  { value: "Keyence", label: "Keyence" },
  { value: "Raymond James Financial", label: "Raymond James Financial" },
  { value: "Hikvision", label: "Hikvision" },
  { value: "Thomson Reuters", label: "Thomson Reuters" },
  { value: "VF", label: "VF" },
  { value: "Aptiv", label: "Aptiv" },
  { value: "Conagra Brands", label: "Conagra Brands" },
  { value: "T&D Holdings", label: "T&D Holdings" },
  { value: "Canadian Pacific Railway", label: "Canadian Pacific Railway" },
  { value: "Link REIT", label: "Link REIT" },
  { value: "CenturyLink", label: "CenturyLink" },
  { value: "Siam Commercial Bank", label: "Siam Commercial Bank" },
  { value: "O'Reilly Automotive", label: "O'Reilly Automotive" },
  { value: "CenterPoint Energy", label: "CenterPoint Energy" },
  { value: "Wanhua Chemical Group", label: "Wanhua Chemical Group" },
  { value: "Corteva", label: "Corteva" },
  { value: "Vestas Wind Systems", label: "Vestas Wind Systems" },
  { value: "Guotai Junan Securities", label: "Guotai Junan Securities" },
  { value: "Shengjing Bank", label: "Shengjing Bank" },
  { value: "Huntington Bank", label: "Huntington Bank" },
  { value: "Bâloise Group", label: "Bâloise Group" },
  { value: "Fortum", label: "Fortum" },
  { value: "Vistra Energy", label: "Vistra Energy" },
  { value: "Roper Technologies", label: "Roper Technologies" },
  { value: "Otis Worldwide", label: "Otis Worldwide" },
  { value: "Arch Capital Group", label: "Arch Capital Group" },
  { value: "Shenzhen Overseas", label: "Shenzhen Overseas" },
  { value: "CapitaLand", label: "CapitaLand" },
  { value: "Rosseti", label: "Rosseti" },
  { value: "Infineon Technologies", label: "Infineon Technologies" },
  { value: "Intuit", label: "Intuit" },
  { value: "Formosa Chemicals", label: "Formosa Chemicals" },
  { value: "Kone", label: "Kone" },
  { value: "Unum", label: "Unum" },
  { value: "Wuliangye Yibin", label: "Wuliangye Yibin" },
  { value: "Publicis Groupe", label: "Publicis Groupe" },
  { value: "LG Electronics", label: "LG Electronics" },
  { value: "Cheniere Energy", label: "Cheniere Energy" },
  { value: "Huishang Bank", label: "Huishang Bank" },
  { value: "Logan Property Holdings", label: "Logan Property Holdings" },
  { value: "UPM-Kymmene", label: "UPM-Kymmene" },
  { value: "PKN Orlen", label: "PKN Orlen" },
  { value: "Abu Dhabi Commercial Bank", label: "Abu Dhabi Commercial Bank" },
  { value: "Suncorp Group", label: "Suncorp Group" },
  { value: "Zijin Mining Group", label: "Zijin Mining Group" },
  { value: "ZTE", label: "ZTE" },
  { value: "Samba Financial Group", label: "Samba Financial Group" },
  { value: "Telia", label: "Telia" },
  {
    value: "Kuehne & Nagel International",
    label: "Kuehne & Nagel International",
  },
  { value: "CP All", label: "CP All" },
  { value: "Teva Pharmaceutical", label: "Teva Pharmaceutical" },
  { value: "Voya Financial", label: "Voya Financial" },
  { value: "TDK", label: "TDK" },
  { value: "DSM", label: "DSM" },
  { value: "China Coal Energy", label: "China Coal Energy" },
  { value: "George Weston", label: "George Weston" },
  { value: "Bank Of Hangzhou", label: "Bank Of Hangzhou" },
  { value: "Absa Group", label: "Absa Group" },
  { value: "Inner Mongolia Yili", label: "Inner Mongolia Yili" },
  { value: "Secom", label: "Secom" },
  { value: "Pioneer Natural Resources", label: "Pioneer Natural Resources" },
  { value: "Hilton", label: "Hilton" },
  { value: "Alexion Pharmaceuticals", label: "Alexion Pharmaceuticals" },
  { value: "Renault", label: "Renault" },
  { value: "Shin Kong Financial", label: "Shin Kong Financial" },
  { value: "Garanti Bank", label: "Garanti Bank" },
  { value: "Obayashi", label: "Obayashi" },
  { value: "Kuwait Finance House", label: "Kuwait Finance House" },
  { value: "Nan Ya Plastics", label: "Nan Ya Plastics" },
  { value: "Ball", label: "Ball" },
  { value: "Deutsche Wohnen", label: "Deutsche Wohnen" },
  { value: "Shaanxi Coal Industry", label: "Shaanxi Coal Industry" },
  { value: "Meituan Dianping", label: "Meituan Dianping" },
  {
    value: "Restaurant Brands International",
    label: "Restaurant Brands International",
  },
  { value: "Chunghwa Telecom", label: "Chunghwa Telecom" },
  { value: "HCL Technologies", label: "HCL Technologies" },
  { value: "Ameren", label: "Ameren" },
  { value: "Schindler Holding", label: "Schindler Holding" },
  { value: "Zoetis", label: "Zoetis" },
  { value: "Oneok", label: "Oneok" },
  { value: "Saudi British Bank", label: "Saudi British Bank" },
  { value: "Chongqing Rural Bank", label: "Chongqing Rural Bank" },
  { value: "Ryanair Holdings", label: "Ryanair Holdings" },
  { value: "BOE Technology Group", label: "BOE Technology Group" },
  { value: "Idemitsu Kosan", label: "Idemitsu Kosan" },
  { value: "Toshiba", label: "Toshiba" },
  { value: "Power Finance", label: "Power Finance" },
  { value: "Asr Nederland", label: "Asr Nederland" },
  { value: "STMicroelectronics", label: "STMicroelectronics" },
  { value: "Assa Abloy", label: "Assa Abloy" },
  { value: "QBE Insurance Group", label: "QBE Insurance Group" },
  { value: "Equitable Holdings", label: "Equitable Holdings" },
  { value: "Phoenix Group Holdings", label: "Phoenix Group Holdings" },
  { value: "CDW", label: "CDW" },
  { value: "Tata Steel", label: "Tata Steel" },
  { value: "Hormel Foods", label: "Hormel Foods" },
  { value: "Toray Industries", label: "Toray Industries" },
  { value: "Rakuten", label: "Rakuten" },
  { value: "BYD", label: "BYD" },
  { value: "Whirlpool", label: "Whirlpool" },
  { value: "CMS Energy", label: "CMS Energy" },
  { value: "Quanta Computer", label: "Quanta Computer" },
  { value: "Koç Holding", label: "Koç Holding" },
  { value: "Banco de Sabadell", label: "Banco de Sabadell" },
  { value: "Formosa Plastics", label: "Formosa Plastics" },
  { value: "Amphenol", label: "Amphenol" },
  { value: "Seagate Technology", label: "Seagate Technology" },
  { value: "OTP Bank", label: "OTP Bank" },
  {
    value: "Luxshare Precision Industry",
    label: "Luxshare Precision Industry",
  },
  { value: "SVB Financial Group", label: "SVB Financial Group" },
  { value: "Uni-President", label: "Uni-President" },
  { value: "Power Grid of India", label: "Power Grid of India" },
  { value: "Bank Leumi", label: "Bank Leumi" },
  { value: "DSV Panalpina", label: "DSV Panalpina" },
  { value: "Hershey", label: "Hershey" },
  { value: "Electronic Arts", label: "Electronic Arts" },
  { value: "Akbank", label: "Akbank" },
  { value: "Hanwha", label: "Hanwha" },
  { value: "American Financial Group", label: "American Financial Group" },
  { value: "Genuine Parts", label: "Genuine Parts" },
  { value: "Trip.com Group", label: "Trip.com Group" },
  { value: "Bangkok Bank", label: "Bangkok Bank" },
  { value: "Bancolombia", label: "Bancolombia" },
  { value: "United Rentals", label: "United Rentals" },
  { value: "China Gas Holdings", label: "China Gas Holdings" },
  { value: "Global Payments", label: "Global Payments" },
  { value: "Fortive", label: "Fortive" },
  { value: "Leonardo", label: "Leonardo" },
  { value: "China Jinmao", label: "China Jinmao" },
  { value: "Equinix", label: "Equinix" },
  { value: "Old Mutual", label: "Old Mutual" },
  { value: "China Eastern Airlines", label: "China Eastern Airlines" },
  { value: "Freeport-McMoRan", label: "Freeport-McMoRan" },
  { value: "Jinke Property Group", label: "Jinke Property Group" },
  { value: "DaVita", label: "DaVita" },
  { value: "Sandvik", label: "Sandvik" },
  { value: "MediaTek", label: "MediaTek" },
  { value: "China Gezhouba", label: "China Gezhouba" },
  {
    value: "RiseSun Real Estate Development",
    label: "RiseSun Real Estate Development",
  },
  { value: "Intact Financial", label: "Intact Financial" },
  { value: "Tohoku Electric Power", label: "Tohoku Electric Power" },
  { value: "New Hope Liuhe", label: "New Hope Liuhe" },
  { value: "ASE Technology Holding", label: "ASE Technology Holding" },
  { value: "Towngas", label: "Towngas" },
  { value: "Corning", label: "Corning" },
  { value: "T Rowe Price", label: "T Rowe Price" },
  { value: "Liberty Global", label: "Liberty Global" },
  { value: "Snam", label: "Snam" },
  { value: "Equity Residential", label: "Equity Residential" },
  { value: "Pembina Pipeline", label: "Pembina Pipeline" },
  { value: "Baker Hughes Company", label: "Baker Hughes Company" },
  { value: "NRG Energy", label: "NRG Energy" },
  { value: "Sabanci Holding", label: "Sabanci Holding" },
  { value: "NortonLifeLock", label: "NortonLifeLock" },
  { value: "Shiseido", label: "Shiseido" },
  { value: "St. James's Place", label: "St. James's Place" },
  { value: "Sanlam", label: "Sanlam" },
  { value: "Vedanta Limited", label: "Vedanta Limited" },
  {
    value: "China National Nuclear Power",
    label: "China National Nuclear Power",
  },
  { value: "Expedia Group", label: "Expedia Group" },
  { value: "Taisei", label: "Taisei" },
  { value: "TransDigm Group", label: "TransDigm Group" },
  { value: "Everest Re Group", label: "Everest Re Group" },
  { value: "Sumitomo Chemical", label: "Sumitomo Chemical" },
  { value: "Aisin Seiki", label: "Aisin Seiki" },
  { value: "IQVIA", label: "IQVIA" },
  { value: "Pegatron", label: "Pegatron" },
  { value: "E.Sun Financial", label: "E.Sun Financial" },
  { value: "Guangzhou Automobile Group", label: "Guangzhou Automobile Group" },
  { value: "CEZ Group", label: "CEZ Group" },
  { value: "Wipro", label: "Wipro" },
  { value: "Beiersdorf", label: "Beiersdorf" },
  {
    value: "Guangzhou Rural Commercial Bank",
    label: "Guangzhou Rural Commercial Bank",
  },
  { value: "ITC", label: "ITC" },
  { value: "CIFI Holdings Group", label: "CIFI Holdings Group" },
  { value: "China Southern Airlines", label: "China Southern Airlines" },
  { value: "Yanzhou Coal Mining", label: "Yanzhou Coal Mining" },
  { value: "Nedbank", label: "Nedbank" },
  { value: "E-Trade Financial", label: "E-Trade Financial" },
  { value: "Motorola Solutions", label: "Motorola Solutions" },
  { value: "Daiwa Securities", label: "Daiwa Securities" },
  { value: "Vertex Pharmaceuticals", label: "Vertex Pharmaceuticals" },
  { value: "Gallagher", label: "Gallagher" },
  { value: "Moody's", label: "Moody's" },
  { value: "Western Digital", label: "Western Digital" },
  { value: "GF Securities", label: "GF Securities" },
  { value: "Akzo Nobel", label: "Akzo Nobel" },
  { value: "Rolls-Royce Holdings", label: "Rolls-Royce Holdings" },
  { value: "Alleghany", label: "Alleghany" },
  { value: "WW Grainger", label: "WW Grainger" },
  { value: "BAIC Motor", label: "BAIC Motor" },
  {
    value: "Shanghai International Port",
    label: "Shanghai International Port",
  },
  { value: "Stora Enso", label: "Stora Enso" },
  { value: "Fukuoka Financial Group", label: "Fukuoka Financial Group" },
  { value: "Constellation Brands", label: "Constellation Brands" },
  { value: "SK Innovation", label: "SK Innovation" },
  { value: "Tokyo Gas", label: "Tokyo Gas" },
  { value: "Kajima", label: "Kajima" },
  { value: "Air Canada", label: "Air Canada" },
  { value: "Dubai Islamic Bank", label: "Dubai Islamic Bank" },
  { value: "Banque Saudi Fransi", label: "Banque Saudi Fransi" },
  { value: "Itaúsa", label: "Itaúsa" },
  { value: "Lonza Group", label: "Lonza Group" },
  { value: "BDO Unibank", label: "BDO Unibank" },
  {
    value: "Joint Stock Commercial Bank for Foreign Trade of Vietnam",
    label: "Joint Stock Commercial Bank for Foreign Trade of Vietnam",
  },
  { value: "Iliad", label: "Iliad" },
  { value: "First Financial Holding", label: "First Financial Holding" },
  { value: "Banco BPM", label: "Banco BPM" },
  { value: "Shimizu", label: "Shimizu" },
  { value: "Aena", label: "Aena" },
  { value: "Agile Group Holdings", label: "Agile Group Holdings" },
  {
    value: "Contemporary Amperex Technology",
    label: "Contemporary Amperex Technology",
  },
  { value: "Isuzu Motors", label: "Isuzu Motors" },
  { value: "Legrand", label: "Legrand" },
  { value: "Digital Realty Trust", label: "Digital Realty Trust" },
  { value: "Mazda Motor", label: "Mazda Motor" },
  { value: "Scor", label: "Scor" },
  { value: "Japan Airlines", label: "Japan Airlines" },
  { value: "Bajaj Finserv", label: "Bajaj Finserv" },
  { value: "Cintas", label: "Cintas" },
  { value: "Intuitive Surgical", label: "Intuitive Surgical" },
  { value: "Chugoku Electric Power", label: "Chugoku Electric Power" },
  { value: "Altice USA", label: "Altice USA" },
  { value: "CGI Group", label: "CGI Group" },
  { value: "PKO Bank Polski", label: "PKO Bank Polski" },
  { value: "Grifols", label: "Grifols" },
  { value: "Sika", label: "Sika" },
  {
    value: "Huaneng Power International",
    label: "Huaneng Power International",
  },
  { value: "Japan Exchange Group", label: "Japan Exchange Group" },
  { value: "Suntory Beverage & Food", label: "Suntory Beverage & Food" },
  { value: "Muyuan Foodstuff", label: "Muyuan Foodstuff" },
  { value: "Hindalco Industries", label: "Hindalco Industries" },
  { value: "Sharp", label: "Sharp" },
  { value: "American Airlines Group", label: "American Airlines Group" },
  { value: "Amadeus IT Group", label: "Amadeus IT Group" },
  { value: "Molina Healthcare", label: "Molina Healthcare" },
  { value: "Novolipetsk Steel", label: "Novolipetsk Steel" },
  { value: "Hoya", label: "Hoya" },
  { value: "Yara International", label: "Yara International" },
  { value: "Qatar Islamic Bank", label: "Qatar Islamic Bank" },
  { value: "Galaxy Entertainment", label: "Galaxy Entertainment" },
  { value: "Welltower", label: "Welltower" },
  {
    value: "China Development Financial",
    label: "China Development Financial",
  },
  { value: "Helvetia Holding", label: "Helvetia Holding" },
  { value: "China Hongqiao Group", label: "China Hongqiao Group" },
  { value: "Tokyu", label: "Tokyu" },
  { value: "Adecco", label: "Adecco" },
  { value: "Emaar Properties", label: "Emaar Properties" },
  { value: "KT", label: "KT" },
  { value: "Public Storage", label: "Public Storage" },
  { value: "AvalonBay Communities", label: "AvalonBay Communities" },
  { value: "IHS Markit", label: "IHS Markit" },
  {
    value: "Taiwan Cooperative Financial",
    label: "Taiwan Cooperative Financial",
  },
  { value: "PG&E", label: "PG&E" },
  { value: "Toppan Printing", label: "Toppan Printing" },
  { value: "Mitsubishi UFJ Lease", label: "Mitsubishi UFJ Lease" },
  { value: "Yum! Brands", label: "Yum! Brands" },
  { value: "Turkish Airlines", label: "Turkish Airlines" },
  { value: "Amcor", label: "Amcor" },
  { value: "Boston Properties", label: "Boston Properties" },
  { value: "Osaka Gas", label: "Osaka Gas" },
  { value: "Financiere de l'Odet", label: "Financiere de l'Odet" },
  { value: "ENN Energy Holdings", label: "ENN Energy Holdings" },
  { value: "Leidos", label: "Leidos" },
  { value: "Vornado Realty", label: "Vornado Realty" },
  { value: "China Merchants Securities", label: "China Merchants Securities" },
  { value: "Macy's", label: "Macy's" },
  { value: "Alcon", label: "Alcon" },
  { value: "EN+ Group International", label: "EN+ Group International" },
  { value: "Thai Beverage", label: "Thai Beverage" },
  { value: "Gecina", label: "Gecina" },
  { value: "VakifBank", label: "VakifBank" },
  { value: "Edwards Lifesciences", label: "Edwards Lifesciences" },
  { value: "ATOS", label: "ATOS" },
  { value: "Skanska", label: "Skanska" },
  { value: "Shanghai Pharmaceuticals", label: "Shanghai Pharmaceuticals" },
  { value: "American Water Works", label: "American Water Works" },
  { value: "Halliburton", label: "Halliburton" },
  {
    value: "China Life Insurance (Taiwan)",
    label: "China Life Insurance (Taiwan)",
  },
  { value: "Arab National Bank", label: "Arab National Bank" },
  { value: "Randstad N.V.", label: "Randstad N.V." },
  { value: "KLA", label: "KLA" },
  { value: "Zhongsheng Group Holdings", label: "Zhongsheng Group Holdings" },
  { value: "Guosen Securities", label: "Guosen Securities" },
  { value: "Twitter", label: "Twitter" },
  {
    value: "China Huarong Asset Management",
    label: "China Huarong Asset Management",
  },
  { value: "Dassault Systemes", label: "Dassault Systemes" },
  { value: "Polyus", label: "Polyus" },
  { value: "Bank Hapoalim", label: "Bank Hapoalim" },
  { value: "Grupo Elektra", label: "Grupo Elektra" },
  { value: "Finatis", label: "Finatis" },
  { value: "NXP Semiconductors", label: "NXP Semiconductors" },
  { value: "Aroundtown", label: "Aroundtown" },
  { value: "China Mengniu Dairy", label: "China Mengniu Dairy" },
  {
    value: "Jiangsu Zhongnan Construction Group",
    label: "Jiangsu Zhongnan Construction Group",
  },
  { value: "Evergy", label: "Evergy" },
  { value: "Givaudan", label: "Givaudan" },
  { value: "JM Smucker", label: "JM Smucker" },
  { value: "iA Financial Corporation", label: "iA Financial Corporation" },
  { value: "WR Berkley", label: "WR Berkley" },
  { value: "SMC", label: "SMC" },
  { value: "ThyssenKrupp Group", label: "ThyssenKrupp Group" },
  { value: "AMP", label: "AMP" },
  { value: "Tata Motors", label: "Tata Motors" },
  { value: "Illumina", label: "Illumina" },
  { value: "Advanced Micro Devices", label: "Advanced Micro Devices" },
  { value: "Microchip Technology", label: "Microchip Technology" },
  {
    value: "Pan Pacific International Holdings",
    label: "Pan Pacific International Holdings",
  },
  { value: "Shanghai Construction", label: "Shanghai Construction" },
  { value: "China Resources Power", label: "China Resources Power" },
  { value: "MOL Hungarian Oil", label: "MOL Hungarian Oil" },
  { value: "Clorox", label: "Clorox" },
  { value: "Krung Thai Bank", label: "Krung Thai Bank" },
  { value: "Kerry Group", label: "Kerry Group" },
  { value: "BBMG", label: "BBMG" },
  { value: "Monster Beverage", label: "Monster Beverage" },
  { value: "HAL Trust", label: "HAL Trust" },
  { value: "Severstal", label: "Severstal" },
  { value: "Genworth Financial", label: "Genworth Financial" },
  { value: "Bank Negara Indonesia", label: "Bank Negara Indonesia" },
  { value: "Terumo", label: "Terumo" },
  { value: "Bank of Greece", label: "Bank of Greece" },
  { value: "Eastman Chemical", label: "Eastman Chemical" },
  { value: "Quest Diagnostics", label: "Quest Diagnostics" },
  { value: "J Sainsbury", label: "J Sainsbury" },
  { value: "Shanghai Electric Group", label: "Shanghai Electric Group" },
  { value: "Grasim Industries", label: "Grasim Industries" },
  { value: "Eisai", label: "Eisai" },
  { value: "Jefferies Financial", label: "Jefferies Financial" },
  { value: "Bank of Baroda", label: "Bank of Baroda" },
  { value: "Rockwell Automation", label: "Rockwell Automation" },
  { value: "Ashtead Group", label: "Ashtead Group" },
  { value: "Jiangsu Hengrui Medicine", label: "Jiangsu Hengrui Medicine" },
  { value: "Rongsheng Petrochemical", label: "Rongsheng Petrochemical" },
  { value: "Advanced Info Service", label: "Advanced Info Service" },
  { value: "Tokyo Century", label: "Tokyo Century" },
  { value: "Align Technology", label: "Align Technology" },
  { value: "Charoen Pokphand Foods", label: "Charoen Pokphand Foods" },
  { value: "Beijing Enterprises", label: "Beijing Enterprises" },
  {
    value: "Foshan Haitian Flavouring and Food",
    label: "Foshan Haitian Flavouring and Food",
  },
  { value: "Yuanta Financial Holding", label: "Yuanta Financial Holding" },
  { value: "Mediobanca", label: "Mediobanca" },
  { value: "Swatch Group", label: "Swatch Group" },
  { value: "Julius Baer Group", label: "Julius Baer Group" },
  { value: "Lundbergs", label: "Lundbergs" },
  { value: "Hua Nan Financial", label: "Hua Nan Financial" },
  { value: "Paychex", label: "Paychex" },
  { value: "Terna", label: "Terna" },
  { value: "Yango Group", label: "Yango Group" },
  { value: "GD Power Development", label: "GD Power Development" },
  { value: "LabCorp", label: "LabCorp" },
  { value: "Sun Art Retail Group", label: "Sun Art Retail Group" },
  { value: "Jeronimo Martins", label: "Jeronimo Martins" },
  { value: "Fanuc", label: "Fanuc" },
  { value: "Marvell Technology Group", label: "Marvell Technology Group" },
  {
    value: "China Resources Pharmaceutical Group",
    label: "China Resources Pharmaceutical Group",
  },
  { value: "ServiceNow", label: "ServiceNow" },
  { value: "Lear", label: "Lear" },
  { value: "Delta Electronics", label: "Delta Electronics" },
  { value: "Markel", label: "Markel" },
  { value: "TUI", label: "TUI" },
  { value: "Inter Rao", label: "Inter Rao" },
  { value: "Air France-KLM", label: "Air France-KLM" },
  { value: "Falabella", label: "Falabella" },
  { value: "SDIC Power Holdings", label: "SDIC Power Holdings" },
  { value: "Hankyu Hanshin Holdings", label: "Hankyu Hanshin Holdings" },
  { value: "Universal Health", label: "Universal Health" },
  { value: "Yum China Holdings", label: "Yum China Holdings" },
  { value: "UCB", label: "UCB" },
  { value: "Metro", label: "Metro" },
  { value: "Mylan", label: "Mylan" },
  { value: "PulteGroup", label: "PulteGroup" },
  { value: "CJ Corporation", label: "CJ Corporation" },
  { value: "Investec", label: "Investec" },
  { value: "Knorr-Bremse", label: "Knorr-Bremse" },
  { value: "Sojitz", label: "Sojitz" },
  { value: "Vipshop Holdings", label: "Vipshop Holdings" },
  { value: "Altice Europe", label: "Altice Europe" },
  { value: "Textron", label: "Textron" },
  { value: "Brown-Forman", label: "Brown-Forman" },
  { value: "Assurant", label: "Assurant" },
  { value: "Ferrovial", label: "Ferrovial" },
  { value: "JSW Steel", label: "JSW Steel" },
  { value: "Olympus", label: "Olympus" },
  { value: "Bank of Ireland", label: "Bank of Ireland" },
  { value: "Lotte Chemical", label: "Lotte Chemical" },
  { value: "LG Household & Health Care", label: "LG Household & Health Care" },
  { value: "AES", label: "AES" },
  { value: "Bank Of Guiyang", label: "Bank Of Guiyang" },
  { value: "Kyushu Electric Power", label: "Kyushu Electric Power" },
  { value: "Alinma Bank", label: "Alinma Bank" },
  { value: "Crown Holdings", label: "Crown Holdings" },
  { value: "China Steel", label: "China Steel" },
  { value: "Cadence Design", label: "Cadence Design" },
  { value: "Kohl's", label: "Kohl's" },
  { value: "Bank of Tianjin", label: "Bank of Tianjin" },
  {
    value: "Shenzhen Mindray Bio-Medical Electronics",
    label: "Shenzhen Mindray Bio-Medical Electronics",
  },
  { value: "Vienna Insurance Group", label: "Vienna Insurance Group" },
  { value: "Agilent Technologies", label: "Agilent Technologies" },
  { value: "Cosco Shipping", label: "Cosco Shipping" },
  { value: "Airports of Thailand", label: "Airports of Thailand" },
  { value: "Jiangsu Yanghe Brewery", label: "Jiangsu Yanghe Brewery" },
  { value: "Fastenal", label: "Fastenal" },
  { value: "All Nippon Airways", label: "All Nippon Airways" },
  { value: "Attijariwafa Bank", label: "Attijariwafa Bank" },
  { value: "X5 Retail Group", label: "X5 Retail Group" },
  { value: "SGS", label: "SGS" },
  { value: "LG", label: "LG" },
  { value: "C.H. Robinson", label: "C.H. Robinson" },
  { value: "Dover", label: "Dover" },
  { value: "Csc Financial", label: "Csc Financial" },
  { value: "Interpublic Group", label: "Interpublic Group" },
  { value: "Dassault Aviation", label: "Dassault Aviation" },
  { value: "NVR", label: "NVR" },
  { value: "Origin Energy", label: "Origin Energy" },
  { value: "Ferrari", label: "Ferrari" },
  { value: "Waste Connections", label: "Waste Connections" },
  { value: "Bio-Rad Laboratories", label: "Bio-Rad Laboratories" },
  { value: "China Aoyuan Group", label: "China Aoyuan Group" },
  { value: "FleetCor Technologies", label: "FleetCor Technologies" },
  { value: "Comerica", label: "Comerica" },
  { value: "Singapore Airlines", label: "Singapore Airlines" },
  { value: "Experian", label: "Experian" },
  { value: "Kaisa Group Holdings", label: "Kaisa Group Holdings" },
  { value: "Molson Coors Brewing", label: "Molson Coors Brewing" },
  { value: "AerCap Holdings", label: "AerCap Holdings" },
  {
    value: "Inner Mongolia Baotou Steel",
    label: "Inner Mongolia Baotou Steel",
  },
  { value: "Ametek", label: "Ametek" },
  { value: "Shionogi", label: "Shionogi" },
  { value: "NASDAQ", label: "NASDAQ" },
  { value: "Shenwan Hongyuan Group", label: "Shenwan Hongyuan Group" },
  { value: "Bank of Changsha", label: "Bank of Changsha" },
  { value: "Techtronic Industries", label: "Techtronic Industries" },
  {
    value: "Huadian Power International",
    label: "Huadian Power International",
  },
  { value: "Aluminum Corp of China", label: "Aluminum Corp of China" },
  { value: "Korea Gas", label: "Korea Gas" },
  {
    value: "Top Frontier Investment Holdings",
    label: "Top Frontier Investment Holdings",
  },
  { value: "Bank Of Chengdu", label: "Bank Of Chengdu" },
  { value: "Mitsubishi Motors", label: "Mitsubishi Motors" },
  { value: "Scentre Group", label: "Scentre Group" },
  { value: "Partners Group Holding", label: "Partners Group Holding" },
  { value: "LKQ", label: "LKQ" },
  { value: "VeriSign", label: "VeriSign" },
  { value: "Ulta Beauty", label: "Ulta Beauty" },
  { value: "Globe Life", label: "Globe Life" },
  { value: "Brighthouse Financial", label: "Brighthouse Financial" },
  {
    value: "Longi Green Energy Technology",
    label: "Longi Green Energy Technology",
  },
  { value: "LARGAN Precision", label: "LARGAN Precision" },
  { value: "Campbell Soup", label: "Campbell Soup" },
  { value: "McCormick", label: "McCormick" },
  { value: "Anta Sports Products", label: "Anta Sports Products" },
  { value: "MTN Group", label: "MTN Group" },
  { value: "Solvay", label: "Solvay" },
  { value: "Nitori Holdings", label: "Nitori Holdings" },
  { value: "Schroders", label: "Schroders" },
  { value: "Mondi", label: "Mondi" },
  { value: "HollyFrontier", label: "HollyFrontier" },
  { value: "GS Holdings", label: "GS Holdings" },
  { value: "Quilter", label: "Quilter" },
  { value: "Ricoh", label: "Ricoh" },
  {
    value: "China International Capital",
    label: "China International Capital",
  },
  { value: "Galp Energia", label: "Galp Energia" },
  { value: "Centrica", label: "Centrica" },
  { value: "Punjab National Bank", label: "Punjab National Bank" },
  { value: "Yamaha Motor", label: "Yamaha Motor" },
  { value: "Db Insurance", label: "Db Insurance" },
  { value: "Franklin Resources", label: "Franklin Resources" },
  { value: "Expeditors International", label: "Expeditors International" },
  { value: "Wolters Kluwer", label: "Wolters Kluwer" },
  { value: "Xilinx", label: "Xilinx" },
  { value: "Oriental Land", label: "Oriental Land" },
  { value: "Goodman Group", label: "Goodman Group" },
  { value: "Tractor Supply", label: "Tractor Supply" },
  { value: "Oji Holdings", label: "Oji Holdings" },
  { value: "Invesco", label: "Invesco" },
  { value: "Lululemon Athletica", label: "Lululemon Athletica" },
  { value: "Samsung SDI", label: "Samsung SDI" },
  { value: "Zhongliang Holdings", label: "Zhongliang Holdings" },
  { value: "Bankinter", label: "Bankinter" },
  { value: "Meiji Holdings", label: "Meiji Holdings" },
  { value: "Hesteel", label: "Hesteel" },
  { value: "Coloplast", label: "Coloplast" },
  { value: "KWG Group Holdings", label: "KWG Group Holdings" },
  { value: "DXC Technology", label: "DXC Technology" },
  { value: "Jiangxi Copper", label: "Jiangxi Copper" },
  { value: "China Resources Gas Group", label: "China Resources Gas Group" },
  { value: "Darden Restaurants", label: "Darden Restaurants" },
  { value: "Aeroports de Paris", label: "Aeroports de Paris" },
  { value: "Garmin", label: "Garmin" },
  { value: "Hydro One", label: "Hydro One" },
  { value: "Datang International Power", label: "Datang International Power" },
  { value: "Daito Trust Construction", label: "Daito Trust Construction" },
  { value: "LG Display", label: "LG Display" },
  { value: "Howmet Aerospace", label: "Howmet Aerospace" },
  { value: "Storebrand", label: "Storebrand" },
  { value: "Valeo", label: "Valeo" },
  { value: "AntarChile", label: "AntarChile" },
  { value: "Bunge", label: "Bunge" },
  { value: "Segro", label: "Segro" },
  { value: "NEXON", label: "NEXON" },
  { value: "Ayala Corp", label: "Ayala Corp" },
  { value: "Skyworks Solutions", label: "Skyworks Solutions" },
  { value: "360 Security Technology", label: "360 Security Technology" },
  { value: "Canara Bank", label: "Canara Bank" },
  { value: "Arista Networks", label: "Arista Networks" },
  { value: "Naver", label: "Naver" },
  { value: "Saputo", label: "Saputo" },
  {
    value: "Shanghai Commercial & Savings Bank",
    label: "Shanghai Commercial & Savings Bank",
  },
  { value: "Bankia", label: "Bankia" },
  { value: "Insurance Australia Group", label: "Insurance Australia Group" },
  { value: "Ahli United Bank", label: "Ahli United Bank" },
  { value: "Transurban Group", label: "Transurban Group" },
  { value: "Olam International", label: "Olam International" },
  { value: "Halkbank", label: "Halkbank" },
  { value: "Mohawk Industries", label: "Mohawk Industries" },
  { value: "Hexagon", label: "Hexagon" },
  { value: "AGC", label: "AGC" },
  {
    value: "J.B. Hunt Transport Services",
    label: "J.B. Hunt Transport Services",
  },
  { value: "Zions Bancorp", label: "Zions Bancorp" },
  { value: "Hess", label: "Hess" },
  { value: "Power Assets Holdings", label: "Power Assets Holdings" },
  { value: "Jones Lang LaSalle", label: "Jones Lang LaSalle" },
  { value: "OMRON", label: "OMRON" },
  { value: "GAIL India", label: "GAIL India" },
  { value: "Annaly Capital Management", label: "Annaly Capital Management" },
  { value: "HNA Technology", label: "HNA Technology" },
  { value: "Masraf Al Rayan", label: "Masraf Al Rayan" },
  { value: "Realty Income", label: "Realty Income" },
  { value: "KPN", label: "KPN" },
  { value: "Wuchan Zhongda Group", label: "Wuchan Zhongda Group" },
  { value: "Midea Real Estate Holding", label: "Midea Real Estate Holding" },
  { value: "Sasol", label: "Sasol" },
  { value: "Cosmo Energy Holdings", label: "Cosmo Energy Holdings" },
  { value: "Citrix Systems", label: "Citrix Systems" },
  { value: "Copart", label: "Copart" },
  { value: "Cerner", label: "Cerner" },
  { value: "Wm Morrison Supermarkets", label: "Wm Morrison Supermarkets" },
  { value: "Umicore", label: "Umicore" },
  { value: "Brenntag", label: "Brenntag" },
  { value: "Metro Group", label: "Metro Group" },
  { value: "Check Point Software", label: "Check Point Software" },
  { value: "Banca Mediolanum", label: "Banca Mediolanum" },
  { value: "Kintetsu", label: "Kintetsu" },
  { value: "Hyundai Steel", label: "Hyundai Steel" },
  { value: "Bank of Jinzhou", label: "Bank of Jinzhou" },
  { value: "Popular", label: "Popular" },
  { value: "Yonghui Superstores", label: "Yonghui Superstores" },
  { value: "China Galaxy Securities", label: "China Galaxy Securities" },
  {
    value: "Shenzhou International Group Holdings",
    label: "Shenzhou International Group Holdings",
  },
  {
    value: "Fidelity National Financial",
    label: "Fidelity National Financial",
  },
  { value: "NetApp", label: "NetApp" },
  { value: "Hyundai Marine & Fire", label: "Hyundai Marine & Fire" },
  { value: "Emera", label: "Emera" },
  { value: "3i Group", label: "3i Group" },
  { value: "Lotte Shopping", label: "Lotte Shopping" },
  { value: "Melrose Industries", label: "Melrose Industries" },
  { value: "Bank of Chongqing", label: "Bank of Chongqing" },
  { value: "Mahindra & Mahindra", label: "Mahindra & Mahindra" },
  { value: "TCL", label: "TCL" },
  { value: "Korea Investment Holdings", label: "Korea Investment Holdings" },
  { value: "BCI-Banco Credito", label: "BCI-Banco Credito" },
  { value: "RHB Bank", label: "RHB Bank" },
  { value: "ALFA", label: "ALFA" },
  { value: "Unicharm", label: "Unicharm" },
  { value: "Maxim Integrated Products", label: "Maxim Integrated Products" },
  { value: "Shinsei Bank", label: "Shinsei Bank" },
  { value: "Signature Bank", label: "Signature Bank" },
  { value: "Penske Automotive", label: "Penske Automotive" },
  { value: "Concordia Financial Group", label: "Concordia Financial Group" },
  {
    value: "Hyundai Heavy Industries Holdings",
    label: "Hyundai Heavy Industries Holdings",
  },
  { value: "MSCI", label: "MSCI" },
  { value: "Chiba Bank", label: "Chiba Bank" },
  {
    value: "Jiangsu Zhangjiagang Rural Commercial Bank",
    label: "Jiangsu Zhangjiagang Rural Commercial Bank",
  },
  { value: "Verbund", label: "Verbund" },
  { value: "Keysight Technologies", label: "Keysight Technologies" },
  { value: "Ventas", label: "Ventas" },
  { value: "Samsung SDS", label: "Samsung SDS" },
  { value: "Harbin Bank", label: "Harbin Bank" },
  {
    value: "Hopson Development Holdings",
    label: "Hopson Development Holdings",
  },
  { value: "Mirae Asset Daewoo", label: "Mirae Asset Daewoo" },
  { value: "SYNNEX", label: "SYNNEX" },
  {
    value: "Westinghouse Air Brake Technologies",
    label: "Westinghouse Air Brake Technologies",
  },
  { value: "Church & Dwight", label: "Church & Dwight" },
  { value: "Luzhou Lao Jiao", label: "Luzhou Lao Jiao" },
  { value: "Alliant Energy", label: "Alliant Energy" },
  { value: "Tenet Healthcare", label: "Tenet Healthcare" },
  { value: "Mizrahi Tefahot Bank", label: "Mizrahi Tefahot Bank" },
  {
    value: "Sunny Optical Technology Group",
    label: "Sunny Optical Technology Group",
  },
  { value: "Schaeffler", label: "Schaeffler" },
  {
    value: "China Shipbuilding Industry",
    label: "China Shipbuilding Industry",
  },
  { value: "Smith & Nephew", label: "Smith & Nephew" },
  { value: "Tingyi Holding", label: "Tingyi Holding" },
  { value: "CJ Cheiljedang", label: "CJ Cheiljedang" },
  { value: "Cemex", label: "Cemex" },
  { value: "Woodside Petroleum", label: "Woodside Petroleum" },
  { value: "Spotify Technology", label: "Spotify Technology" },
  { value: "Bandai Namco Holdings", label: "Bandai Namco Holdings" },
  { value: "Doosan", label: "Doosan" },
  { value: "Qantas Airways", label: "Qantas Airways" },
  { value: "Quinenco", label: "Quinenco" },
  { value: "Times Property Holdings", label: "Times Property Holdings" },
  { value: "East West Bancorp", label: "East West Bancorp" },
  { value: "Starwood Property Trust", label: "Starwood Property Trust" },
  { value: "Ooredoo Q.P.S.C", label: "Ooredoo Q.P.S.C" },
  { value: "People's United Financial", label: "People's United Financial" },
  { value: "RenaissanceRe Holdings", label: "RenaissanceRe Holdings" },
  { value: "Dentsu", label: "Dentsu" },
  { value: "Banco Btg Pactual", label: "Banco Btg Pactual" },
  { value: "Bombardier", label: "Bombardier" },
  { value: "Celanese", label: "Celanese" },
  { value: "Yunnan Baiyao Group", label: "Yunnan Baiyao Group" },
  { value: "Zhongyuan Bank", label: "Zhongyuan Bank" },
  { value: "AGL Energy", label: "AGL Energy" },
  { value: "Jacobs Engineering", label: "Jacobs Engineering" },
  { value: "Cathay Pacific Airways", label: "Cathay Pacific Airways" },
  { value: "Bank of India", label: "Bank of India" },
  { value: "Hunan Valin Steel", label: "Hunan Valin Steel" },
  { value: "Bausch Health Companies", label: "Bausch Health Companies" },
  { value: "Keppel", label: "Keppel" },
  { value: "Greentown China Holdings", label: "Greentown China Holdings" },
  { value: "Cincinnati Financial", label: "Cincinnati Financial" },
  { value: "IndusInd Bank", label: "IndusInd Bank" },
  { value: "BorgWarner", label: "BorgWarner" },
  { value: "Host Hotels & Resorts", label: "Host Hotels & Resorts" },
  { value: "Canadian Tire", label: "Canadian Tire" },
  { value: "Geberit", label: "Geberit" },
  { value: "Bank Pekao", label: "Bank Pekao" },
  { value: "YPF", label: "YPF" },
  { value: "Weyerhaeuser", label: "Weyerhaeuser" },
  { value: "Covivio", label: "Covivio" },
  { value: "Old Dominion Freight Line", label: "Old Dominion Freight Line" },
  {
    value: "Wuestenrot & Wuerttembergische",
    label: "Wuestenrot & Wuerttembergische",
  },
  { value: "Kobe Steel", label: "Kobe Steel" },
  { value: "SG Holdings", label: "SG Holdings" },
  { value: "Ronshine China Holdings", label: "Ronshine China Holdings" },
  { value: "Migdal Insurance", label: "Migdal Insurance" },
  { value: "Packaging Corp of America", label: "Packaging Corp of America" },
  { value: "B3", label: "B3" },
  { value: "Match Group", label: "Match Group" },
  { value: "Smurfit Kappa Group", label: "Smurfit Kappa Group" },
  { value: "Red Eléctrica", label: "Red Eléctrica" },
  { value: "VEON", label: "VEON" },
  { value: "Coca-Cola HBC", label: "Coca-Cola HBC" },
  { value: "Fastighets Balder", label: "Fastighets Balder" },
  { value: "Bank of Zhengzhou", label: "Bank of Zhengzhou" },
  { value: "SLM", label: "SLM" },
  { value: "Mebuki Financial Group", label: "Mebuki Financial Group" },
  { value: "Tech Data", label: "Tech Data" },
  { value: "China Feihe", label: "China Feihe" },
  { value: "Aramark", label: "Aramark" },
  { value: "Meritz Financial Group", label: "Meritz Financial Group" },
  { value: "Suzano Papel e Celulose", label: "Suzano Papel e Celulose" },
  { value: "Israel Discount Bank", label: "Israel Discount Bank" },
  { value: "ResMed", label: "ResMed" },
  {
    value: "China Grand Automotive Services",
    label: "China Grand Automotive Services",
  },
  { value: "JG Summit Holdings", label: "JG Summit Holdings" },
  { value: "Henry Schein", label: "Henry Schein" },
  { value: "Arkema", label: "Arkema" },
  { value: "Advance Auto Parts", label: "Advance Auto Parts" },
  {
    value: "Norwegian Cruise Line Holdings",
    label: "Norwegian Cruise Line Holdings",
  },
  { value: "Bank of Guizhou", label: "Bank of Guizhou" },
  { value: "Burlington Stores", label: "Burlington Stores" },
  { value: "Great Wall Motor", label: "Great Wall Motor" },
  { value: "Vulcan Materials", label: "Vulcan Materials" },
  { value: "Alaska Air Group", label: "Alaska Air Group" },
  { value: "Chow Tai Fook Jewellery", label: "Chow Tai Fook Jewellery" },
  { value: "Hang Lung Group", label: "Hang Lung Group" },
  { value: "Iida Group Holdings", label: "Iida Group Holdings" },
  { value: "Meritz Securities", label: "Meritz Securities" },
  { value: "XPO Logistics", label: "XPO Logistics" },
  { value: "Chang Hwa Bank", label: "Chang Hwa Bank" },
  { value: "Cencosud", label: "Cencosud" },
  { value: "Nomura Research Institute", label: "Nomura Research Institute" },
  {
    value: "Huntington Ingalls Industries",
    label: "Huntington Ingalls Industries",
  },
  { value: "ICA Gruppen", label: "ICA Gruppen" },
  { value: "Zain", label: "Zain" },
  { value: "Cenovus Energy", label: "Cenovus Energy" },
  { value: "Synopsys", label: "Synopsys" },
  { value: "Sistema", label: "Sistema" },
  { value: "Medipal Holdings", label: "Medipal Holdings" },
  { value: "Alstom", label: "Alstom" },
  { value: "Banque Cantonale Vaudoise", label: "Banque Cantonale Vaudoise" },
  { value: "Avery Dennison", label: "Avery Dennison" },
  { value: "China National Chemical", label: "China National Chemical" },
  { value: "Hyundai Engineering", label: "Hyundai Engineering" },
  { value: "BNK Financial Group", label: "BNK Financial Group" },
  { value: "Covestro", label: "Covestro" },
  { value: "RSA Insurance Group", label: "RSA Insurance Group" },
  { value: "Bunzl", label: "Bunzl" },
  {
    value: "China Resources Cement Holdings",
    label: "China Resources Cement Holdings",
  },
  {
    value: "Shanghai International Airport",
    label: "Shanghai International Airport",
  },
  {
    value: "Mettler-Toledo International",
    label: "Mettler-Toledo International",
  },
  { value: "SS&C Technologies", label: "SS&C Technologies" },
  { value: "Taishin Financial Holdings", label: "Taishin Financial Holdings" },
  {
    value: "Beijing Capital Development",
    label: "Beijing Capital Development",
  },
  { value: "Lixil Group", label: "Lixil Group" },
  { value: "AGNC Investment", label: "AGNC Investment" },
  { value: "Far East Horizon", label: "Far East Horizon" },
  { value: "LEG Immobilien AG", label: "LEG Immobilien AG" },
  { value: "Nippon Paint", label: "Nippon Paint" },
  { value: "New Residential Investment", label: "New Residential Investment" },
  { value: "Grupo Bimbo", label: "Grupo Bimbo" },
  { value: "Sino-Ocean Group Holding", label: "Sino-Ocean Group Holding" },
  { value: "Sumitomo Metal Mining", label: "Sumitomo Metal Mining" },
  { value: "Lindt & Sprungli", label: "Lindt & Sprungli" },
  { value: "Bawag Group", label: "Bawag Group" },
  { value: "SCA", label: "SCA" },
  { value: "Verisk Analytics", label: "Verisk Analytics" },
  { value: "Masco", label: "Masco" },
  { value: "Husky Energy", label: "Husky Energy" },
  {
    value: "Alexandria Real Estate Equities",
    label: "Alexandria Real Estate Equities",
  },
  { value: "BPER Banca", label: "BPER Banca" },
  { value: "S-Oil", label: "S-Oil" },
  { value: "Guangdong Investment", label: "Guangdong Investment" },
  {
    value: "Commercial Bank For Investment & Development Of Vietnam",
    label: "Commercial Bank For Investment & Development Of Vietnam",
  },
  { value: "Arrow Electronics", label: "Arrow Electronics" },
  { value: "AutoNation", label: "AutoNation" },
  { value: "Caesars Entertainment", label: "Caesars Entertainment" },
  { value: "NiSource", label: "NiSource" },
  { value: "Metropolitan Bank & Trust", label: "Metropolitan Bank & Trust" },
  { value: "Bank of East Asia", label: "Bank of East Asia" },
  { value: "Western Union", label: "Western Union" },
  { value: "Atmos Energy", label: "Atmos Energy" },
  {
    value: "Commercial International Bank",
    label: "Commercial International Bank",
  },
  { value: "Persimmon", label: "Persimmon" },
  { value: "Norsk Hydro", label: "Norsk Hydro" },
  { value: "GCI Liberty", label: "GCI Liberty" },
  { value: "KION Group", label: "KION Group" },
  { value: "STRABAG", label: "STRABAG" },
  { value: "China Molybdenum", label: "China Molybdenum" },
  { value: "Sofina", label: "Sofina" },
  { value: "Halyk Bank", label: "Halyk Bank" },
  { value: "Arab Bank", label: "Arab Bank" },
  { value: "Barratt Developments", label: "Barratt Developments" },
  {
    value: "Zhejiang Zheneng Electric Power",
    label: "Zhejiang Zheneng Electric Power",
  },
  { value: "Hong Leong Financial", label: "Hong Leong Financial" },
  { value: "Colruyt", label: "Colruyt" },
  { value: "Shizuoka Bank", label: "Shizuoka Bank" },
  { value: "Abu Dhabi Islamic Bank", label: "Abu Dhabi Islamic Bank" },
  { value: "Arca Continental", label: "Arca Continental" },
  { value: "Cattolica Assicurazioni", label: "Cattolica Assicurazioni" },
  { value: "Yuexiu Property", label: "Yuexiu Property" },
  { value: "SKF Group", label: "SKF Group" },
  { value: "iHeartMedia", label: "iHeartMedia" },
  { value: "Navient", label: "Navient" },
  { value: "Teleflex", label: "Teleflex" },
  {
    value: "Korea Shipbuilding & Offshore Engineering",
    label: "Korea Shipbuilding & Offshore Engineering",
  },
  { value: "Weatherford International", label: "Weatherford International" },
  { value: "Ansys", label: "Ansys" },
  { value: "Sun Pharma Industries", label: "Sun Pharma Industries" },
  { value: "China International Marine", label: "China International Marine" },
  { value: "IDEXX Laboratories", label: "IDEXX Laboratories" },
  {
    value: "NARI Technology Development",
    label: "NARI Technology Development",
  },
  { value: "Empire", label: "Empire" },
  {
    value: "China Communications Services",
    label: "China Communications Services",
  },
  { value: "Onex", label: "Onex" },
  { value: "Nordstrom", label: "Nordstrom" },
  { value: "Synovus Financial", label: "Synovus Financial" },
  { value: "Kerry Properties", label: "Kerry Properties" },
  { value: "Pinnacle West", label: "Pinnacle West" },
  { value: "UBI Banca", label: "UBI Banca" },
  { value: "Hainan Airlines", label: "Hainan Airlines" },
  { value: "Nippon Yusen", label: "Nippon Yusen" },
  { value: "Tiffany & Co.", label: "Tiffany & Co." },
  { value: "Hologic", label: "Hologic" },
  { value: "AECOM Technology", label: "AECOM Technology" },
  {
    value: "China Conch Venture Holdings",
    label: "China Conch Venture Holdings",
  },
  { value: "Mashreq Bank", label: "Mashreq Bank" },
  { value: "Bank Audi", label: "Bank Audi" },
  { value: "E-mart", label: "E-mart" },
  { value: "Teleperformance", label: "Teleperformance" },
  { value: "Ajinomoto", label: "Ajinomoto" },
  {
    value: "International Flavors & Fragrances",
    label: "International Flavors & Fragrances",
  },
  { value: "Xerox", label: "Xerox" },
  { value: "Electric Power Development", label: "Electric Power Development" },
  { value: "Saudi Arabian Mining", label: "Saudi Arabian Mining" },
  { value: "Kawasaki Heavy Industries", label: "Kawasaki Heavy Industries" },
  { value: "Union Bank of India", label: "Union Bank of India" },
  { value: "Newcrest Mining", label: "Newcrest Mining" },
  {
    value: "China Merchants Port Holdings",
    label: "China Merchants Port Holdings",
  },
  { value: "Reliance Steel", label: "Reliance Steel" },
  { value: "Incyte", label: "Incyte" },
  { value: "Gudang Garam", label: "Gudang Garam" },
  { value: "Ceconomy", label: "Ceconomy" },
  {
    value: "China International Travel Service",
    label: "China International Travel Service",
  },
  { value: "Shopify", label: "Shopify" },
  { value: "Chipotle Mexican Grill", label: "Chipotle Mexican Grill" },
  { value: "OneMain Holdings", label: "OneMain Holdings" },
  { value: "AIB Group", label: "AIB Group" },
  { value: "Live Nation Entertainment", label: "Live Nation Entertainment" },
  { value: "DCC", label: "DCC" },
  { value: "EMS-Chemie Holding", label: "EMS-Chemie Holding" },
  { value: "Shimano", label: "Shimano" },
  { value: "Steel Dynamics", label: "Steel Dynamics" },
  { value: "Technipfmc", label: "Technipfmc" },
  {
    value: "Xiamen International Trade Group",
    label: "Xiamen International Trade Group",
  },
  { value: "Ternium", label: "Ternium" },
  { value: "Bajaj Auto", label: "Bajaj Auto" },
  { value: "US Foods", label: "US Foods" },
  { value: "Dai Nippon Printing", label: "Dai Nippon Printing" },
  { value: "Vingroup", label: "Vingroup" },
  { value: "Epiroc", label: "Epiroc" },
  { value: "Magnitogorsk Iron & Steel", label: "Magnitogorsk Iron & Steel" },
  { value: "Magnit", label: "Magnit" },
  { value: "Santos", label: "Santos" },
  {
    value: "Booz Allen Hamilton Holding",
    label: "Booz Allen Hamilton Holding",
  },
  { value: "Flex", label: "Flex" },
  { value: "Sekisui Chemical", label: "Sekisui Chemical" },
  { value: "Akamai Technologies", label: "Akamai Technologies" },
  { value: "CPFL Energia", label: "CPFL Energia" },
  { value: "Manpower", label: "Manpower" },
  { value: "Kansas City Southern", label: "Kansas City Southern" },
  { value: "Enstar Group Ltd.", label: "Enstar Group Ltd." },
  { value: "Petronas Chemicals", label: "Petronas Chemicals" },
  { value: "Square", label: "Square" },
  { value: "Wayfair", label: "Wayfair" },
  { value: "Martin Marietta Materials", label: "Martin Marietta Materials" },
  {
    value: "American National Insurance",
    label: "American National Insurance",
  },
  { value: "Essex Property Trust", label: "Essex Property Trust" },
  { value: "Sonova Holding", label: "Sonova Holding" },
  { value: "Grupo Inbursa", label: "Grupo Inbursa" },
  { value: "Korean Air", label: "Korean Air" },
  { value: "Mitsubishi Materials", label: "Mitsubishi Materials" },
  { value: "Antofagasta", label: "Antofagasta" },
  { value: "Compal Electronics", label: "Compal Electronics" },
  { value: "Blom Bank", label: "Blom Bank" },
  { value: "Safaricom", label: "Safaricom" },
  { value: "Johnson Matthey", label: "Johnson Matthey" },
  { value: "Fgl Holdings", label: "Fgl Holdings" },
  { value: "KT&G", label: "KT&G" },
  { value: "Next", label: "Next" },
  { value: "BOK Financial", label: "BOK Financial" },
  { value: "Voestalpine", label: "Voestalpine" },
  {
    value: "Sichuan Language Development",
    label: "Sichuan Language Development",
  },
  { value: "Wendel", label: "Wendel" },
  { value: "Banca MPS", label: "Banca MPS" },
  { value: "SinoPac Financial", label: "SinoPac Financial" },
  { value: "Jabil Circuit", label: "Jabil Circuit" },
  { value: "AVIC Capita", label: "AVIC Capita" },
  { value: "PTT Global Chemical", label: "PTT Global Chemical" },
  { value: "Xiamen Xiangyu", label: "Xiamen Xiangyu" },
  { value: "Commercial Bank of Qatar", label: "Commercial Bank of Qatar" },
  { value: "Barry Callebaut", label: "Barry Callebaut" },
  { value: "IAC/InterActiveCorp", label: "IAC/InterActiveCorp" },
  { value: "NH Investment & Securities", label: "NH Investment & Securities" },
  { value: "Industries Qatar", label: "Industries Qatar" },
  { value: "Jyske Bank", label: "Jyske Bank" },
  { value: "Mercuries & Associates", label: "Mercuries & Associates" },
  { value: "Alfresa Holdings", label: "Alfresa Holdings" },
  { value: "Hertz Global Holdings", label: "Hertz Global Holdings" },
  { value: "Hokuhoku Financial Group", label: "Hokuhoku Financial Group" },
  { value: "Hyundai Glovis", label: "Hyundai Glovis" },
  { value: "Ramsay Health Care", label: "Ramsay Health Care" },
  { value: "Autodesk", label: "Autodesk" },
  { value: "INTL FCStone", label: "INTL FCStone" },
  { value: "ONO Pharmaceutical", label: "ONO Pharmaceutical" },
  { value: "President Chain Store", label: "President Chain Store" },
  { value: "Lendlease Group", label: "Lendlease Group" },
  { value: "Wirecard", label: "Wirecard" },
  { value: "CSPC Pharmaceutical Group", label: "CSPC Pharmaceutical Group" },
  { value: "World Fuel Services", label: "World Fuel Services" },
  { value: "Vietin Bank", label: "Vietin Bank" },
  { value: "Asian Paints", label: "Asian Paints" },
  { value: "Goodyear", label: "Goodyear" },
  { value: "Mitsui Chemicals", label: "Mitsui Chemicals" },
  { value: "Atlassian", label: "Atlassian" },
  { value: "RTL Group", label: "RTL Group" },
  { value: "Qurate Retail Group", label: "Qurate Retail Group" },
  { value: "Zoom Video Communications", label: "Zoom Video Communications" },
  { value: "Yamato Holdings", label: "Yamato Holdings" },
  { value: "Novozymes", label: "Novozymes" },
  { value: "Dexus", label: "Dexus" },
  { value: "Virgin Money UK", label: "Virgin Money UK" },
  { value: "Cooper Companies", label: "Cooper Companies" },
  { value: "Gap", label: "Gap" },
  { value: "New York Community Bancorp", label: "New York Community Bancorp" },
  { value: "Canadian Utilities", label: "Canadian Utilities" },
  { value: "Nippon Express", label: "Nippon Express" },
  { value: "Workday", label: "Workday" },
  { value: "Otsuka", label: "Otsuka" },
  { value: "Koito Manufacturing", label: "Koito Manufacturing" },
  { value: "Taiwan Cement", label: "Taiwan Cement" },
  { value: "Teck Resources", label: "Teck Resources" },
  {
    value: "Hansoh Pharmaceutical Group",
    label: "Hansoh Pharmaceutical Group",
  },
  { value: "Almarai", label: "Almarai" },
  { value: "Agnico Eagle Mines", label: "Agnico Eagle Mines" },
  { value: "Showa Denko", label: "Showa Denko" },
  { value: "Cellnex Telecom", label: "Cellnex Telecom" },
  {
    value: "Qingdao Rural Commercial Bank",
    label: "Qingdao Rural Commercial Bank",
  },
  { value: "Braskem", label: "Braskem" },
  { value: "Continental Resources", label: "Continental Resources" },
  { value: "Avis Budget Group", label: "Avis Budget Group" },
  { value: "Kyushu Financial Group", label: "Kyushu Financial Group" },
  {
    value: "Nishi-nippon Financial Holdings",
    label: "Nishi-nippon Financial Holdings",
  },
  { value: "Hachijuni Bank", label: "Hachijuni Bank" },
  { value: "Zoomlion Heavy Industry", label: "Zoomlion Heavy Industry" },
  { value: "SBA Communications", label: "SBA Communications" },
  { value: "Hulic", label: "Hulic" },
  { value: "Waters", label: "Waters" },
  { value: "Yamaguchi Financial", label: "Yamaguchi Financial" },
  { value: "Wistron", label: "Wistron" },
  { value: "Hengyi Petrochemical", label: "Hengyi Petrochemical" },
  { value: "Latam Airlines", label: "Latam Airlines" },
  { value: "Kesko", label: "Kesko" },
  { value: "Hengan International Group", label: "Hengan International Group" },
  { value: "Wingtech Technology", label: "Wingtech Technology" },
  { value: "Franco-Nevada", label: "Franco-Nevada" },
  { value: "North Pacific Bank", label: "North Pacific Bank" },
  { value: "Banco Comercial Portugues", label: "Banco Comercial Portugues" },
  { value: "Kingfisher", label: "Kingfisher" },
  { value: "Banco Davivienda", label: "Banco Davivienda" },
  { value: "DexCom", label: "DexCom" },
  { value: "Japan Securities", label: "Japan Securities" },
  { value: "Acciona", label: "Acciona" },
  { value: "China Longyuan Power", label: "China Longyuan Power" },
  { value: "Pinduoduo", label: "Pinduoduo" },
  { value: "Adyen", label: "Adyen" },
  { value: "Bank of Kyoto", label: "Bank of Kyoto" },
  { value: "Mitsui OSK Lines", label: "Mitsui OSK Lines" },
  { value: "Hiroshima Bank", label: "Hiroshima Bank" },
  { value: "WEG", label: "WEG" },
  { value: "Rajesh Exports", label: "Rajesh Exports" },
  { value: "Sino Biopharmaceutical", label: "Sino Biopharmaceutical" },
  { value: "Lundin Energy", label: "Lundin Energy" },
  { value: "MercadoLibre", label: "MercadoLibre" },
  { value: "Taylor Wimpey", label: "Taylor Wimpey" },
  { value: "Renesas Electronics", label: "Renesas Electronics" },
  { value: "Hotai Motor", label: "Hotai Motor" },
  {
    value: "Daishi Hokuetsu Financial Group",
    label: "Daishi Hokuetsu Financial Group",
  },
  { value: "Kinross Gold", label: "Kinross Gold" },
  { value: "Unisplendour", label: "Unisplendour" },
  { value: "Veeva Systems", label: "Veeva Systems" },
  { value: "Tahoe Group", label: "Tahoe Group" },
  {
    value: "PGE Polska Grupa Energetyczna",
    label: "PGE Polska Grupa Energetyczna",
  },
  { value: "Steinhoff International", label: "Steinhoff International" },
  { value: "Beijing Shougang", label: "Beijing Shougang" },
  { value: "Teradyne", label: "Teradyne" },
  { value: "United Natural Foods", label: "United Natural Foods" },
  { value: "PBF Energy", label: "PBF Energy" },
  { value: "Zalando", label: "Zalando" },
  { value: "Chugoku Bank", label: "Chugoku Bank" },
  { value: "LG Uplus", label: "LG Uplus" },
  { value: "Royal Mail", label: "Royal Mail" },
  { value: "77 Bank", label: "77 Bank" },
  { value: "Shandong Gold Mining", label: "Shandong Gold Mining" },
  { value: "Powerlong Real Estate", label: "Powerlong Real Estate" },
  { value: "Cemig", label: "Cemig" },
  { value: "Gunma Bank", label: "Gunma Bank" },
  { value: "Invitation Homes", label: "Invitation Homes" },
  { value: "Berry Global Group", label: "Berry Global Group" },
  {
    value: "China Development Bank Financial Leasing",
    label: "China Development Bank Financial Leasing",
  },
  { value: "Genting", label: "Genting" },
  { value: "Nippon Steel Trading", label: "Nippon Steel Trading" },
  { value: "FMC", label: "FMC" },
  { value: "Interactive Brokers Group", label: "Interactive Brokers Group" },
  { value: "Tenneco", label: "Tenneco" },
  { value: "Tokyu Fudosan", label: "Tokyu Fudosan" },
  {
    value: "Haidilao International Holding",
    label: "Haidilao International Holding",
  },
  { value: "Performance Food Group", label: "Performance Food Group" },
  { value: "Domino's Pizza", label: "Domino's Pizza" },
  { value: "Ultrapar Participacoes", label: "Ultrapar Participacoes" },
  {
    value: "Hubei Biocause Pharmaceutical",
    label: "Hubei Biocause Pharmaceutical",
  },
  { value: "Snap", label: "Snap" },
  { value: "Eurobank Ergasias", label: "Eurobank Ergasias" },
  {
    value: "Companhia Brasileira de Distribuicao",
    label: "Companhia Brasileira de Distribuicao",
  },
  { value: "Fibra Uno", label: "Fibra Uno" },
  { value: "First Citizens Bank", label: "First Citizens Bank" },
  { value: "Pgnig Group", label: "Pgnig Group" },
  { value: "National Bank of Greece", label: "National Bank of Greece" },
  { value: "Zebra Technologies", label: "Zebra Technologies" },
  { value: "Tsim Sha Tsui Properties", label: "Tsim Sha Tsui Properties" },
  { value: "Vodafone Idea", label: "Vodafone Idea" },
  { value: "Alpha Bank", label: "Alpha Bank" },
  { value: "Community Health Systems", label: "Community Health Systems" },
  { value: "Rite Aid", label: "Rite Aid" },
  { value: "Xylem", label: "Xylem" },
  { value: "IHI", label: "IHI" },
  { value: "M3", label: "M3" },
  { value: "Bank Muscat", label: "Bank Muscat" },
  { value: "Accor", label: "Accor" },
  { value: "American Equity Investment", label: "American Equity Investment" },
  { value: "Iyo Bank", label: "Iyo Bank" },
  { value: "Lens Technology", label: "Lens Technology" },
  { value: "TP ICAP", label: "TP ICAP" },
  { value: "Piraeus Bank", label: "Piraeus Bank" },
  {
    value: "XCMG Construction Machinery",
    label: "XCMG Construction Machinery",
  },
  { value: "Air Lease", label: "Air Lease" },
  { value: "Commerce Bank", label: "Commerce Bank" },
  { value: "CoStar Group", label: "CoStar Group" },
  { value: "Grupo Bolivar", label: "Grupo Bolivar" },
  { value: "Bank of Suzhou", label: "Bank of Suzhou" },
  { value: "Seattle Genetics", label: "Seattle Genetics" },
  { value: "Sinotruk Hong Kong", label: "Sinotruk Hong Kong" },
  {
    value: "Harel Insurance Investments & Financial Services",
    label: "Harel Insurance Investments & Financial Services",
  },
  { value: "Avary Holding (Shenzhen)", label: "Avary Holding (Shenzhen)" },
  { value: "Liberty Broadband", label: "Liberty Broadband" },
  { value: "Jiangxi Bank", label: "Jiangxi Bank" },
  { value: "Unibail-Rodamco", label: "Unibail-Rodamco" },
  { value: "CPI Property Group", label: "CPI Property Group" },
  { value: "Daelim Industrial", label: "Daelim Industrial" },
  { value: "Moscow Exchange", label: "Moscow Exchange" },
  { value: "Minebea", label: "Minebea" },
  { value: "PVH", label: "PVH" },
  { value: "News Corp", label: "News Corp" },
  { value: "Brambles", label: "Brambles" },
  { value: "JetBlue Airways", label: "JetBlue Airways" },
  { value: "SDIC Capital", label: "SDIC Capital" },
  { value: "Haseko", label: "Haseko" },
  { value: "Deutsche Pfandbriefbank", label: "Deutsche Pfandbriefbank" },
  { value: "Western Alliance Bancorp.", label: "Western Alliance Bancorp." },
  { value: "Celltrion", label: "Celltrion" },
  { value: "Unicaja Banco", label: "Unicaja Banco" },
  { value: "Wuxi Apptec", label: "Wuxi Apptec" },
  { value: "Aristocrat Leisure", label: "Aristocrat Leisure" },
  { value: "Bank of Xi'an", label: "Bank of Xi'an" },
  { value: "China Aviation Oil", label: "China Aviation Oil" },
  { value: "Alrosa", label: "Alrosa" },
  { value: "SBI Holdings", label: "SBI Holdings" },
  { value: "Suzuken", label: "Suzuken" },
  { value: "Will Semiconductor", label: "Will Semiconductor" },
  {
    value: "Adani Ports & Special Economic Zone",
    label: "Adani Ports & Special Economic Zone",
  },
  { value: "Broadridge Financial", label: "Broadridge Financial" },
  {
    value: "Momentum Metropolitan Holdings",
    label: "Momentum Metropolitan Holdings",
  },
  { value: "DGB Financial Group", label: "DGB Financial Group" },
  { value: "Mercantil Servicios", label: "Mercantil Servicios" },
  { value: "Offcn Education Technology", label: "Offcn Education Technology" },
  {
    value: "Bangkok Dusit Medical Services",
    label: "Bangkok Dusit Medical Services",
  },
  { value: "Huafa Industrial", label: "Huafa Industrial" },
  { value: "Huaibei Mining Holdings", label: "Huaibei Mining Holdings" },
  { value: "Aeroflot-Russian Airlines", label: "Aeroflot-Russian Airlines" },
  { value: "Inchcape", label: "Inchcape" },
  { value: "Splunk", label: "Splunk" },
  { value: "El Puerto de Liverpool", label: "El Puerto de Liverpool" },
  { value: "Hyakugo Bank", label: "Hyakugo Bank" },
  { value: "VICI Properties", label: "VICI Properties" },
  { value: "BayWa", label: "BayWa" },
  { value: "Constellation Software", label: "Constellation Software" },
  { value: "Nitto Denko", label: "Nitto Denko" },
  { value: "Ares Capital", label: "Ares Capital" },
  { value: "Juroku Bank", label: "Juroku Bank" },
  { value: "Hakuhodo DY Holdings", label: "Hakuhodo DY Holdings" },
  { value: "Tosoh", label: "Tosoh" },
  { value: "CIT Group", label: "CIT Group" },
  { value: "Bank of Qingdao", label: "Bank of Qingdao" },
  { value: "Bohai Leasing", label: "Bohai Leasing" },
  { value: "Quanta Services", label: "Quanta Services" },
  { value: "Taiwan Business Bank", label: "Taiwan Business Bank" },
  { value: "Hikari Tsushin", label: "Hikari Tsushin" },
  { value: "Mosaic", label: "Mosaic" },
  { value: "Shiga Bank", label: "Shiga Bank" },
  { value: "Targa Resources", label: "Targa Resources" },
  { value: "TMB Bank", label: "TMB Bank" },
  { value: "CNO Financial Group", label: "CNO Financial Group" },
  { value: "Avnet", label: "Avnet" },
  { value: "Wynn Resorts", label: "Wynn Resorts" },
  { value: "Steel Authority of India", label: "Steel Authority of India" },
  { value: "Axiata Group", label: "Axiata Group" },
  { value: "First Pacific", label: "First Pacific" },
  { value: "Far Eastern New Century", label: "Far Eastern New Century" },
  { value: "San-In Godo Bank", label: "San-In Godo Bank" },
  {
    value: "Chongqing Zhifei Biological Products",
    label: "Chongqing Zhifei Biological Products",
  },
  { value: "Hanwa", label: "Hanwa" },
  { value: "Red Star Macalline Group", label: "Red Star Macalline Group" },
  { value: "Uniqa", label: "Uniqa" },
  { value: "Aozora Bank", label: "Aozora Bank" },
  { value: "Ogaki Kyoritsu Bank", label: "Ogaki Kyoritsu Bank" },
  { value: "FinecoBank", label: "FinecoBank" },
  { value: "Kirkland Lake Gold", label: "Kirkland Lake Gold" },
  { value: "Rexel", label: "Rexel" },
  { value: "Banco BBVA Peru", label: "Banco BBVA Peru" },
  { value: "Swiss Prime Site", label: "Swiss Prime Site" },
  { value: "Toho Bank", label: "Toho Bank" },
  { value: "Avenue Supermarts", label: "Avenue Supermarts" },
  { value: "AmBank Group", label: "AmBank Group" },
  { value: "First Horizon National", label: "First Horizon National" },
  { value: "Want Want China", label: "Want Want China" },
  { value: "Nanto Bank", label: "Nanto Bank" },
  { value: "Ralph Lauren", label: "Ralph Lauren" },
  { value: "Tenaris", label: "Tenaris" },
  { value: "Banque Centrale Populaire", label: "Banque Centrale Populaire" },
  { value: "Credito Emiliano", label: "Credito Emiliano" },
  { value: "Advantest", label: "Advantest" },
  { value: "UGI", label: "UGI" },
  { value: "Angang Steel", label: "Angang Steel" },
  { value: "RingCentral", label: "RingCentral" },
  { value: "Bendigo & Adelaide Bank", label: "Bendigo & Adelaide Bank" },
  {
    value: "Nine Dragons Paper Holdings",
    label: "Nine Dragons Paper Holdings",
  },
  { value: "Wuxi Biologics", label: "Wuxi Biologics" },
  { value: "Mowi ASA", label: "Mowi ASA" },
  { value: "Tech Mahindra", label: "Tech Mahindra" },
  { value: "WPG Holdings", label: "WPG Holdings" },
  { value: "Bank of Jiujiang", label: "Bank of Jiujiang" },
  { value: "Fluor", label: "Fluor" },
  {
    value: "Tokyo Kiraboshi Financial Group",
    label: "Tokyo Kiraboshi Financial Group",
  },
  { value: "Orient", label: "Orient" },
  { value: "Admiral Group", label: "Admiral Group" },
  { value: "Bureau Veritas", label: "Bureau Veritas" },
  { value: "Duke Realty", label: "Duke Realty" },
  { value: "Core-Mark Holding", label: "Core-Mark Holding" },
  { value: "Huntsman", label: "Huntsman" },
  { value: "Newell Brands", label: "Newell Brands" },
  { value: "Palo Alto Networks", label: "Palo Alto Networks" },
  { value: "Prosperity Bancshares", label: "Prosperity Bancshares" },
  { value: "Vopak", label: "Vopak" },
  { value: "Senshu Ikeda Holdings", label: "Senshu Ikeda Holdings" },
  { value: "Fortinet", label: "Fortinet" },
  { value: "Aier Eye Hospital Group", label: "Aier Eye Hospital Group" },
  {
    value: "Shanghai Fosun Pharmaceutical",
    label: "Shanghai Fosun Pharmaceutical",
  },
  { value: "Zenith Bank", label: "Zenith Bank" },
  { value: "Dali Foods Group", label: "Dali Foods Group" },
  { value: "Polymetal International", label: "Polymetal International" },
  { value: "Sartorius", label: "Sartorius" },
  { value: "DocuSign", label: "DocuSign" },
  { value: "Adient", label: "Adient" },
  { value: "Inventec", label: "Inventec" },
  { value: "East Money Information", label: "East Money Information" },
  { value: "Asustek Computer", label: "Asustek Computer" },
  { value: "China SCE Group Holdings", label: "China SCE Group Holdings" },
  { value: "Poly Property Group Co.", label: "Poly Property Group Co." },
  {
    value: "Canadian Apartment Properties Real Estate Investment Trust",
    label: "Canadian Apartment Properties Real Estate Investment Trust",
  },
  { value: "Yes Bank", label: "Yes Bank" },
  { value: "Central Bank of India", label: "Central Bank of India" },
  { value: "Okta", label: "Okta" },
  { value: "Cronos Group", label: "Cronos Group" },
  { value: "First American Financial", label: "First American Financial" },
  { value: "TCF Financial", label: "TCF Financial" },
  { value: "Murphy Oil", label: "Murphy Oil" },
  { value: "Cullen/Frost Bankers", label: "Cullen/Frost Bankers" },
  { value: "Snap-on", label: "Snap-on" },
  { value: "Spirit AeroSystems", label: "Spirit AeroSystems" },
  { value: "Bank Of Gansu", label: "Bank Of Gansu" },
  { value: "Guangdong Haid Group", label: "Guangdong Haid Group" },
  {
    value: "Ningxia Baofeng Energy Group",
    label: "Ningxia Baofeng Energy Group",
  },
  { value: "Shaw Communications", label: "Shaw Communications" },
  { value: "IDEX", label: "IDEX" },
  { value: "Teledyne Technologies", label: "Teledyne Technologies" },
  { value: "Healthpeak Properties", label: "Healthpeak Properties" },
  {
    value: "Shanghai Ganglian E-Commerce Holdings",
    label: "Shanghai Ganglian E-Commerce Holdings",
  },
  { value: "SEB SA", label: "SEB SA" },
  { value: "Caltex Australia", label: "Caltex Australia" },
  { value: "LT Group", label: "LT Group" },
  { value: "Extra Space Storage", label: "Extra Space Storage" },
  { value: "Chewy", label: "Chewy" },
  { value: "Stifel Financial", label: "Stifel Financial" },
  { value: "United Utilities", label: "United Utilities" },
  { value: "Frontier Communications", label: "Frontier Communications" },
  { value: "Sysmex", label: "Sysmex" },
  { value: "Orient Securities", label: "Orient Securities" },
  { value: "Liberbank", label: "Liberbank" },
  { value: "TransUnion", label: "TransUnion" },
  { value: "Alfa Laval", label: "Alfa Laval" },
  { value: "Westlake Chemical", label: "Westlake Chemical" },
  { value: "Clal Insurance Enterprises", label: "Clal Insurance Enterprises" },
  { value: "Hasbro", label: "Hasbro" },
  { value: "E-L Financial", label: "E-L Financial" },
  { value: "Keiyo Bank", label: "Keiyo Bank" },
  { value: "Yamada Denki", label: "Yamada Denki" },
  { value: "Pirelli", label: "Pirelli" },
  { value: "Basler Kantonalbank", label: "Basler Kantonalbank" },
  { value: "Luzerner Kantonalbank", label: "Luzerner Kantonalbank" },
  { value: "Trimble", label: "Trimble" },
  { value: "Banca Popolare di Sondrio", label: "Banca Popolare di Sondrio" },
  { value: "Aareal Bank", label: "Aareal Bank" },
  { value: "Hyakujushi Bank", label: "Hyakujushi Bank" },
  {
    value: "Beijing Kingsoft Office Software.",
    label: "Beijing Kingsoft Office Software.",
  },
  { value: "Foot Locker", label: "Foot Locker" },
  { value: "Marathon Oil", label: "Marathon Oil" },
  {
    value: "Changchun High & New Technology",
    label: "Changchun High & New Technology",
  },
  { value: "Wheaton Precious Metals", label: "Wheaton Precious Metals" },
  {
    value: "Jointown Pharmaceutical Group",
    label: "Jointown Pharmaceutical Group",
  },
  { value: "Marketaxess Holdings", label: "Marketaxess Holdings" },
  { value: "Medical Properties Trust", label: "Medical Properties Trust" },
  { value: "Steris", label: "Steris" },
  { value: "Yuzhou Properties", label: "Yuzhou Properties" },
  { value: "Equifax", label: "Equifax" },
  {
    value: "General Insurance Corporation Of India",
    label: "General Insurance Corporation Of India",
  },
  { value: "Hokkoku Bank", label: "Hokkoku Bank" },
  { value: "Fuyo General Lease", label: "Fuyo General Lease" },
  { value: "Kiyo Bank", label: "Kiyo Bank" },
  { value: "Chimera Investment", label: "Chimera Investment" },
  { value: "Delivery Hero", label: "Delivery Hero" },
  { value: "Klepierre", label: "Klepierre" },
  { value: "BioMarin Pharmaceutical", label: "BioMarin Pharmaceutical" },
  { value: "Magazine Luiza", label: "Magazine Luiza" },
  {
    value: "China Everbright International",
    label: "China Everbright International",
  },
  { value: "MTU Aero Engines AG", label: "MTU Aero Engines AG" },
  { value: "Oshkosh", label: "Oshkosh" },
  { value: "Yonyou Network Technology", label: "Yonyou Network Technology" },
  { value: "Berkeley Group Holdings", label: "Berkeley Group Holdings" },
  { value: "Azrieli Group Ltd.", label: "Azrieli Group Ltd." },
  {
    value: "China Nuclear Engineering Corporation",
    label: "China Nuclear Engineering Corporation",
  },
  { value: "Ovintiv", label: "Ovintiv" },
  { value: "Lamb Weston Holdings", label: "Lamb Weston Holdings" },
  { value: "Xinyu Iron & Steel", label: "Xinyu Iron & Steel" },
  { value: "Murphy USA", label: "Murphy USA" },
  {
    value: "Guangzhou Baiyunshan Pharmaceutical Holdings",
    label: "Guangzhou Baiyunshan Pharmaceutical Holdings",
  },
  { value: "Musashino Bank", label: "Musashino Bank" },
  {
    value: "Semiconductor Manufacturing International",
    label: "Semiconductor Manufacturing International",
  },
  { value: "Genmab", label: "Genmab" },
  { value: "Coty", label: "Coty" },
  { value: "Saipem", label: "Saipem" },
  { value: "Samsung Securities", label: "Samsung Securities" },
  { value: "Abengoa", label: "Abengoa" },
  { value: "Parkland Fuel", label: "Parkland Fuel" },
  { value: "Pou Chen", label: "Pou Chen" },
  { value: "Toll Brothers", label: "Toll Brothers" },
  { value: "Amdocs", label: "Amdocs" },
  { value: "EFG International", label: "EFG International" },
  { value: "Securitas", label: "Securitas" },
  {
    value: "Inspur Electronic Information Industry",
    label: "Inspur Electronic Information Industry",
  },
  { value: "Indian Bank", label: "Indian Bank" },
  { value: "Marks & Spencer", label: "Marks & Spencer" },
  { value: "Hyatt Hotels", label: "Hyatt Hotels" },
  { value: "Montage Technology", label: "Montage Technology" },
  { value: "IDBI Bank", label: "IDBI Bank" },
  { value: "Twilio", label: "Twilio" },
  {
    value: "Brilliance China Automotive Holdings",
    label: "Brilliance China Automotive Holdings",
  },
  { value: "Guoco Group", label: "Guoco Group" },
  { value: "Makita", label: "Makita" },
  { value: "Brown & Brown", label: "Brown & Brown" },
  {
    value: "China Resources Beer (Holdings)",
    label: "China Resources Beer (Holdings)",
  },
  { value: "Kingspan Group PLC", label: "Kingspan Group PLC" },
  { value: "JB Financial Group", label: "JB Financial Group" },
  { value: "NCR", label: "NCR" },
  { value: "Roku", label: "Roku" },
  { value: "Wintrust Financial", label: "Wintrust Financial" },
  { value: "FIBI Holdings", label: "FIBI Holdings" },
  { value: "Swedish Match", label: "Swedish Match" },
  { value: "Tongling Nonferrous Metals", label: "Tongling Nonferrous Metals" },
  { value: "Prysmian", label: "Prysmian" },
  { value: "Delek Group", label: "Delek Group" },
  { value: "Electrolux Group", label: "Electrolux Group" },
  { value: "Orkla", label: "Orkla" },
  { value: "US Steel", label: "US Steel" },
  { value: "Just Eat Takeaway.com", label: "Just Eat Takeaway.com" },
  { value: "ST Engineering", label: "ST Engineering" },
  { value: "Financial Street Holdings", label: "Financial Street Holdings" },
  { value: "F.N.B.", label: "F.N.B." },
  { value: "Moderna", label: "Moderna" },
  { value: "Nuernberger Beteiligungs", label: "Nuernberger Beteiligungs" },
  { value: "Sears Holdings", label: "Sears Holdings" },
  { value: "BJ's Wholesale Club", label: "BJ's Wholesale Club" },
  {
    value: "Mid-america Apartment Communities",
    label: "Mid-america Apartment Communities",
  },
  { value: "Shenzhen Goodix Technology", label: "Shenzhen Goodix Technology" },
  { value: "Paycom", label: "Paycom" },
  { value: "Dollarama", label: "Dollarama" },
  {
    value: "Take-Two Interactive Software",
    label: "Take-Two Interactive Software",
  },
  { value: "Kojamo Oyj", label: "Kojamo Oyj" },
  { value: "Valley Natl Bancorp", label: "Valley Natl Bancorp" },
  { value: "Chesapeake Energy", label: "Chesapeake Energy" },
  { value: "JTEKT", label: "JTEKT" },
  { value: "Alnylam Pharmaceuticals", label: "Alnylam Pharmaceuticals" },
  { value: "Dixons Carphone", label: "Dixons Carphone" },
  { value: "Credit Bank of Moscow", label: "Credit Bank of Moscow" },
  { value: "Just Group", label: "Just Group" },
  { value: "Inmobiliaria Colonial", label: "Inmobiliaria Colonial" },
  { value: "Cabot Oil & Gas", label: "Cabot Oil & Gas" },
  { value: "Holmen AB", label: "Holmen AB" },
  { value: "Indorama Ventures", label: "Indorama Ventures" },
  { value: "L Brands", label: "L Brands" },
  { value: "Slack Technologies", label: "Slack Technologies" },
  { value: "Diamondback Energy", label: "Diamondback Energy" },
  { value: "Founder Securities", label: "Founder Securities" },
  {
    value: "Merlin Properties SOCIMI S.A",
    label: "Merlin Properties SOCIMI S.A",
  },
  { value: "Heico", label: "Heico" },
  { value: "W.P. Carey", label: "W.P. Carey" },
  {
    value: "Zhejiang Century Huatong Group",
    label: "Zhejiang Century Huatong Group",
  },
];
